// DO NOT EDIT THIS FILE
// GENERATE FILE COMMAND: yarn codegen
import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  float: { input: any; output: any; }
  geom: { input: any; output: any; }
  jsonb: { input: any; output: any; }
};

export type ActiveContractor = {
  __typename?: 'ActiveContractor';
  applicationId: Scalars['ID']['output'];
  carModel?: Maybe<Scalars['String']['output']>;
  contractorName: Scalars['String']['output'];
  isCorporate: Scalars['String']['output'];
  spaceName: Scalars['String']['output'];
  supportCarModel: Scalars['String']['output'];
  totalMonthlyRent: Scalars['Int']['output'];
  useStartDate?: Maybe<Scalars['Date']['output']>;
};

export type ActiveContractorConnection = {
  __typename?: 'ActiveContractorConnection';
  edges?: Maybe<Array<Maybe<ActiveContractorEdge>>>;
  pageInfo: PageInfo;
};

export type ActiveContractorEdge = {
  __typename?: 'ActiveContractorEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActiveContractor>;
};

export type ActiveContractorFilterInput = {
  applicationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  propertyId: Scalars['ID']['input'];
  sort?: InputMaybe<ActiveContractorSortKey>;
};

export type ActiveContractorSortKey = {
  isCorporate?: InputMaybe<OrderByEnum>;
  monthlyRent?: InputMaybe<OrderByEnum>;
  spaceName?: InputMaybe<OrderByEnum>;
  useStartDate?: InputMaybe<OrderByEnum>;
};

export type ActivePropertiesOfCompanyResponse = {
  __typename?: 'ActivePropertiesOfCompanyResponse';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ActiveSpacesOfPropertyResponse = {
  __typename?: 'ActiveSpacesOfPropertyResponse';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  spaceGroupId: Scalars['String']['output'];
};

export type AdminAvailability = {
  __typename?: 'AdminAvailability';
  numberOfFree?: Maybe<Scalars['Int']['output']>;
  numberOfFreeSchedule?: Maybe<Scalars['Int']['output']>;
  numberOfOccupied?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AdminContractor = {
  __typename?: 'AdminContractor';
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type AdminFeature = {
  __typename?: 'AdminFeature';
  type?: Maybe<Scalars['String']['output']>;
};

export type AdminPropertyBulkInsert = {
  properties: Array<AdminPropertyInputCreate>;
  propertyManageCompany: Scalars['ID']['input'];
};

export type AdminPropertyBulkInsertResponse = {
  __typename?: 'AdminPropertyBulkInsertResponse';
  insertedRows?: Maybe<InsertedRows>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type AdminPropertyConnection = {
  __typename?: 'AdminPropertyConnection';
  edges: Array<AdminPropertyListEdge>;
  pageInfo: PageInfo;
};

export type AdminPropertyDetailOfficer = {
  __typename?: 'AdminPropertyDetailOfficer';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AdminPropertyDetailResponse = {
  __typename?: 'AdminPropertyDetailResponse';
  address: Scalars['String']['output'];
  controlNumber: Scalars['String']['output'];
  geocode: Geom;
  id: Scalars['ID']['output'];
  images: Array<Maybe<Image>>;
  name: Scalars['String']['output'];
  officer: AdminPropertyDetailOfficer;
  remarks?: Maybe<Scalars['String']['output']>;
  visibility: PropertyVisibility;
};

export type AdminPropertyInputCreate = {
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemNumber?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  municipality: Scalars['String']['input'];
  name: Scalars['String']['input'];
  personInCharge: Scalars['String']['input'];
  prefectureName: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  spaceGroups: Array<AdminSpaceGroupCreateInput>;
  town: Scalars['String']['input'];
};

export type AdminPropertyList = {
  __typename?: 'AdminPropertyList';
  address?: Maybe<Scalars['String']['output']>;
  availability?: Maybe<AvailabilityAdmin>;
  controlNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  officer?: Maybe<AdminPropertyListOfficer>;
  remarks?: Maybe<Scalars['String']['output']>;
  visibility: PropertyVisibility;
};

export type AdminPropertyListEdge = {
  __typename?: 'AdminPropertyListEdge';
  cursor: Scalars['String']['output'];
  node: AdminPropertyList;
};

export type AdminPropertyListInput = {
  order?: InputMaybe<AdminPropertyListOrder>;
  propertyManageCompanyId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AdminPropertyListOfficer = {
  __typename?: 'AdminPropertyListOfficer';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export const AdminPropertyListOrder = {
  AddressAsc: 'ADDRESS_ASC',
  AddressDesc: 'ADDRESS_DESC',
  ControlNumberAsc: 'CONTROL_NUMBER_ASC',
  ControlNumberDesc: 'CONTROL_NUMBER_DESC',
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC',
  NumberOfEmptyAsc: 'NUMBER_OF_EMPTY_ASC',
  NumberOfEmptyDesc: 'NUMBER_OF_EMPTY_DESC',
  NumberOfOccupiedAsc: 'NUMBER_OF_OCCUPIED_ASC',
  NumberOfOccupiedDesc: 'NUMBER_OF_OCCUPIED_DESC',
  PersonInChargeAsc: 'PERSON_IN_CHARGE_ASC',
  PersonInChargeDesc: 'PERSON_IN_CHARGE_DESC'
} as const;

export type AdminPropertyListOrder = typeof AdminPropertyListOrder[keyof typeof AdminPropertyListOrder];
export type AdminSpaceConnection = {
  __typename?: 'AdminSpaceConnection';
  edges?: Maybe<Array<Maybe<AdminSpaceEdge>>>;
  pageInfo: PageInfo;
};

export type AdminSpaceCreateInput = {
  name: Scalars['String']['input'];
  usages?: InputMaybe<Array<SpaceUsageInput>>;
};

export type AdminSpaceDetail = {
  __typename?: 'AdminSpaceDetail';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  spaceAvailableStatus?: Maybe<SpaceAvailableStatus>;
  spaceGroup?: Maybe<AdminSpaceGroupValue>;
  status?: Maybe<Scalars['Int']['output']>;
  usages?: Maybe<Array<Maybe<AdminSpaceUsage>>>;
};

export type AdminSpaceEdge = {
  __typename?: 'AdminSpaceEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AdminSpaceDetail>;
};

export type AdminSpaceGroupCreateInput = {
  contract: ContractInput;
  contractCost: ContractCostInput;
  feature: FeatureInput;
  freeRent: Scalars['Int']['input'];
  initialCost: InitialCostInput;
  initialOtherFee?: InputMaybe<Array<InitialOtherFeeInput>>;
  monthlyOtherFee?: InputMaybe<Array<MonthlyOtherFeeInput>>;
  monthlyRent: MonthlyRentInput;
  remarks?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<SizeInput>;
  spaces: Array<AdminSpaceCreateInput>;
  supportCarModel: Array<SupportCarModel>;
};

export type AdminSpaceGroupDetail = {
  __typename?: 'AdminSpaceGroupDetail';
  contract?: Maybe<Contract>;
  contractCost?: Maybe<ContractCost>;
  feature?: Maybe<SpaceGroupFeature>;
  id?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<Images>>>;
  initialCost?: Maybe<InitialCost>;
  isAvailabilityPublic?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  monthlyRent?: Maybe<MonthlyRent>;
  remarks?: Maybe<Scalars['String']['output']>;
  size?: Maybe<SpaceGroupSize>;
  spaceGroupAvailability?: Maybe<SpaceGroupAvailability>;
  supportCarModel?: Maybe<Scalars['String']['output']>;
};

export type AdminSpaceGroupListConnection = {
  __typename?: 'AdminSpaceGroupListConnection';
  edges: Array<AdminSpaceGroupsListEdge>;
  pageInfo: PageInfo;
};

export type AdminSpaceGroupListFilter = {
  order?: InputMaybe<AdminSpaceGroupOrder>;
};

export const AdminSpaceGroupOrder = {
  IsAvailabilityPublicAsc: 'IS_AVAILABILITY_PUBLIC_ASC',
  IsAvailabilityPublicDesc: 'IS_AVAILABILITY_PUBLIC_DESC',
  IsPublicAsc: 'IS_PUBLIC_ASC',
  IsPublicDesc: 'IS_PUBLIC_DESC',
  MonthlyRentAsc: 'MONTHLY_RENT_ASC',
  MonthlyRentDesc: 'MONTHLY_RENT_DESC',
  NumberOfBookedAsc: 'NUMBER_OF_BOOKED_ASC',
  NumberOfBookedDesc: 'NUMBER_OF_BOOKED_DESC',
  NumberOfEmptyAsc: 'NUMBER_OF_EMPTY_ASC',
  NumberOfEmptyDesc: 'NUMBER_OF_EMPTY_DESC',
  NumberOfFullPlanCancelledAsc: 'NUMBER_OF_FULL_PLAN_CANCELLED_ASC',
  NumberOfFullPlanCancelledDesc: 'NUMBER_OF_FULL_PLAN_CANCELLED_DESC',
  NumberOfFullPlanEndedAsc: 'NUMBER_OF_FULL_PLAN_ENDED_ASC',
  NumberOfFullPlanEndedDesc: 'NUMBER_OF_FULL_PLAN_ENDED_DESC',
  NumberOfFullSpaceAsc: 'NUMBER_OF_FULL_SPACE_ASC',
  NumberOfFullSpaceDesc: 'NUMBER_OF_FULL_SPACE_DESC',
  NumberOfFullTemporaryAsc: 'NUMBER_OF_FULL_TEMPORARY_ASC',
  NumberOfFullTemporaryDesc: 'NUMBER_OF_FULL_TEMPORARY_DESC',
  NumberOfOccupiedAsc: 'NUMBER_OF_OCCUPIED_ASC',
  NumberOfOccupiedDesc: 'NUMBER_OF_OCCUPIED_DESC',
  NumberOfSpacesAsc: 'NUMBER_OF_SPACES_ASC',
  NumberOfSpacesDesc: 'NUMBER_OF_SPACES_DESC'
} as const;

export type AdminSpaceGroupOrder = typeof AdminSpaceGroupOrder[keyof typeof AdminSpaceGroupOrder];
export type AdminSpaceGroupValue = {
  __typename?: 'AdminSpaceGroupValue';
  id?: Maybe<Scalars['String']['output']>;
  monthlyRent?: Maybe<PaymentInfo>;
  supportCarModel?: Maybe<Scalars['jsonb']['output']>;
};

export type AdminSpaceGroupsList = {
  __typename?: 'AdminSpaceGroupsList';
  feature: AdminSpaceGroupsListFeature;
  id: Scalars['ID']['output'];
  isAvailabilityPublic: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  monthlyRent: AdminSpaceGroupsListMonthlyRent;
  remarks: Scalars['String']['output'];
  spaceGroupAvailability: SpaceGroupAvailability;
  supportCarModel: Scalars['String']['output'];
};

export type AdminSpaceGroupsListEdge = {
  __typename?: 'AdminSpaceGroupsListEdge';
  cursor: Scalars['String']['output'];
  node: AdminSpaceGroupsList;
};

export type AdminSpaceGroupsListFeature = {
  __typename?: 'AdminSpaceGroupsListFeature';
  type: Scalars['String']['output'];
};

export type AdminSpaceGroupsListMonthlyRent = {
  __typename?: 'AdminSpaceGroupsListMonthlyRent';
  isTaxExempt: Scalars['Boolean']['output'];
  value: Scalars['Int']['output'];
};

export type AdminSpaceListFilter = {
  order?: InputMaybe<AdminSpaceOrder>;
};

export const AdminSpaceOrder = {
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC',
  SpaceAvailableStatusAsc: 'SPACE_AVAILABLE_STATUS_ASC',
  SpaceAvailableStatusDesc: 'SPACE_AVAILABLE_STATUS_DESC',
  StatusAsc: 'STATUS_ASC',
  StatusDesc: 'STATUS_DESC'
} as const;

export type AdminSpaceOrder = typeof AdminSpaceOrder[keyof typeof AdminSpaceOrder];
export type AdminSpaceUsage = {
  __typename?: 'AdminSpaceUsage';
  approveCancelDate?: Maybe<Scalars['Date']['output']>;
  contractor?: Maybe<AdminContractor>;
  terminateDate?: Maybe<Scalars['Date']['output']>;
  useStartDate?: Maybe<Scalars['Date']['output']>;
};

export type AgreementPaymentInput = {
  contractDetailId: Scalars['String']['input'];
  isAgreed: Scalars['Boolean']['input'];
};

export type AllLesseePropertiesList = {
  __typename?: 'AllLesseePropertiesList';
  address?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  geom?: Maybe<Scalars['geom']['output']>;
  id: Scalars['ID']['output'];
  isLanditProperty?: Maybe<Scalars['Boolean']['output']>;
  isValidProperty?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AllPropertyListFilter = {
  distanceNumber?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  limitRecord?: InputMaybe<Scalars['Int']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
};

export type Applicant = {
  __typename?: 'Applicant';
  company?: Maybe<Company>;
  name: Scalars['String']['output'];
};

export type ApplicantConfig = {
  businessContent: Scalars['Boolean']['input'];
  contactPerson: ContactPerson;
  fax: Scalars['Boolean']['input'];
  furigana: Scalars['Boolean']['input'];
  historyDoc: Scalars['Boolean']['input'];
  hp: Scalars['Boolean']['input'];
  importantDate: Scalars['Boolean']['input'];
  insuranceCard: Scalars['Boolean']['input'];
  numberOfEmployees: Scalars['Boolean']['input'];
  revenue: Scalars['Boolean']['input'];
};

export type ApplicantConfigType = {
  __typename?: 'ApplicantConfigType';
  address?: Maybe<Scalars['Boolean']['output']>;
  backOfIdCard: Scalars['Boolean']['output'];
  businessContent: Scalars['Boolean']['output'];
  contactPerson: ContactPersonType;
  email: Scalars['Boolean']['output'];
  fax: Scalars['Boolean']['output'];
  furigana: Scalars['Boolean']['output'];
  historyDoc: Scalars['Boolean']['output'];
  hp: Scalars['Boolean']['output'];
  idCard: Scalars['Boolean']['output'];
  importantDate: Scalars['Boolean']['output'];
  insuranceCard: Scalars['Boolean']['output'];
  name: Scalars['Boolean']['output'];
  numberOfEmployees: Scalars['Boolean']['output'];
  phoneNumber: Scalars['Boolean']['output'];
  revenue: Scalars['Boolean']['output'];
};

export type Application = {
  __typename?: 'Application';
  applicant: Applicant;
  carUserInfo: Array<CarUserInfo>;
  child?: Maybe<Application>;
  contractDocument?: Maybe<BaseContractDocumentResponse>;
  contractType?: Maybe<ContractTypeEnum>;
  documents: Array<File>;
  duration: ApplicationTime;
  guarantor: Guarantor;
  id: Scalars['ID']['output'];
  intendedUse: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  numberOfCar: Scalars['Int']['output'];
  parent?: Maybe<Application>;
  spaceGroup: SpaceGroupUsed;
  spaces: Array<SpaceUsed>;
  status: ApplicationStatusEnum;
  type?: Maybe<ApplicationTypeEnum>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type ApplicationBulkMessagePayload = {
  __typename?: 'ApplicationBulkMessagePayload';
  bulkMessageId: Scalars['ID']['output'];
  content: Array<Scalars['String']['output']>;
};

export type ApplicationChange = {
  __typename?: 'ApplicationChange';
  application: Application;
};

export type ApplicationConfig = {
  hopeSpaces: Scalars['Boolean']['input'];
  intendedUse: Scalars['Boolean']['input'];
  useEndDate: Scalars['Boolean']['input'];
  useStartDate: Scalars['Boolean']['input'];
};

export type ApplicationConfigType = {
  __typename?: 'ApplicationConfigType';
  hopeSpaces: Scalars['Boolean']['output'];
  intendedUse: Scalars['Boolean']['output'];
  useEndDate: Scalars['Boolean']['output'];
  useStartDate: Scalars['Boolean']['output'];
};

export type ApplicationConfirmGetResponse = {
  __typename?: 'ApplicationConfirmGetResponse';
  application: ConfirmApplication;
  applicationContractor: ApplicationContractor;
  applicationGuarantee: ApplicationGuarantee;
  applicationSpaces?: Maybe<Array<Maybe<ApplicationSpace>>>;
  applicationUsageInfo: Array<ApplicationUsageInfo>;
};

export type ApplicationConfirmResponse = {
  __typename?: 'ApplicationConfirmResponse';
  id?: Maybe<Scalars['String']['output']>;
};

export type ApplicationConnection = {
  __typename?: 'ApplicationConnection';
  edges?: Maybe<Array<Maybe<ApplicationEdge>>>;
  pageInfo: PageInfo;
};

export type ApplicationContractChange = {
  __typename?: 'ApplicationContractChange';
  after: ApplicationChange;
  before: ApplicationChange;
};

export type ApplicationContractDetailResponse = {
  __typename?: 'ApplicationContractDetailResponse';
  applicationContractor?: Maybe<ApplicationContractorResponse>;
  applicationProperty?: Maybe<ApplicationPropertyResponse>;
  id: Scalars['ID']['output'];
  useStartDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ApplicationContractor = {
  __typename?: 'ApplicationContractor';
  address: Scalars['String']['output'];
  cBusinessContent: Scalars['String']['output'];
  cContractor?: Maybe<GetContractor>;
  cHp: Scalars['String']['output'];
  cNumberOfEmployees?: Maybe<Scalars['Int']['output']>;
  documents?: Maybe<ApplicationContractorDocument>;
  email: Scalars['String']['output'];
  fax: Scalars['String']['output'];
  furigana: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  importantDate?: Maybe<Scalars['Date']['output']>;
  isCorporate: Scalars['Boolean']['output'];
  municipality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  prefectureId?: Maybe<Scalars['String']['output']>;
  revenue?: Maybe<Scalars['Int']['output']>;
  town?: Maybe<Scalars['String']['output']>;
};

export type ApplicationContractorChange = {
  __typename?: 'ApplicationContractorChange';
  address?: Maybe<StringChange>;
  cBusinessContent?: Maybe<StringChange>;
  cContractor?: Maybe<GetContractorChange>;
  cHp?: Maybe<StringChange>;
  cNumberOfEmployees?: Maybe<IntChange>;
  documents?: Maybe<ApplicationContractorChangeDocument>;
  email?: Maybe<StringChange>;
  fax?: Maybe<StringChange>;
  furigana?: Maybe<StringChange>;
  importantDate?: Maybe<DateChange>;
  isCorporate?: Maybe<BooleanChange>;
  municipality?: Maybe<StringChange>;
  name?: Maybe<StringChange>;
  phoneNumber?: Maybe<StringChange>;
  prefectureId?: Maybe<StringChange>;
  revenue?: Maybe<IntChange>;
  town?: Maybe<StringChange>;
};

export type ApplicationContractorChangeDocument = {
  __typename?: 'ApplicationContractorChangeDocument';
  backOfContractorIdCard?: Maybe<FileChange>;
  cHistoryCertificate?: Maybe<FileChange>;
  contractorIdCard?: Maybe<FileChange>;
  insuranceCard?: Maybe<FileChange>;
};

export type ApplicationContractorCompanyCreateResponse = {
  __typename?: 'ApplicationContractorCompanyCreateResponse';
  address?: Maybe<Scalars['String']['output']>;
  cBusinessContent?: Maybe<Scalars['String']['output']>;
  cContractor?: Maybe<Scalars['jsonb']['output']>;
  cHp?: Maybe<Scalars['String']['output']>;
  cNumberOfEmployees?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  furigana?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  importantDate?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  revenue?: Maybe<Scalars['Int']['output']>;
};

export type ApplicationContractorCreateResponse = {
  __typename?: 'ApplicationContractorCreateResponse';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  furigana?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  importantDate?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  revenue?: Maybe<Scalars['Int']['output']>;
};

export type ApplicationContractorDocument = {
  __typename?: 'ApplicationContractorDocument';
  backOfContractorIdCard?: Maybe<File>;
  cHistoryCertificate?: Maybe<File>;
  contractorIdCard?: Maybe<File>;
  insuranceCard?: Maybe<File>;
};

export type ApplicationContractorGetResponse = {
  __typename?: 'ApplicationContractorGetResponse';
  address: Scalars['String']['output'];
  cBusinessContent?: Maybe<Scalars['String']['output']>;
  cContractor?: Maybe<Scalars['jsonb']['output']>;
  cHp?: Maybe<Scalars['String']['output']>;
  cNumberOfEmployees?: Maybe<Scalars['Int']['output']>;
  documents?: Maybe<LesseeApplicationDocumentDetailResponse>;
  email: Scalars['String']['output'];
  fax: Scalars['String']['output'];
  furigana: Scalars['String']['output'];
  id: Scalars['String']['output'];
  importantDate?: Maybe<Scalars['Date']['output']>;
  isCorporate: Scalars['Boolean']['output'];
  municipality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  prefectureId?: Maybe<Scalars['String']['output']>;
  revenue?: Maybe<Scalars['Int']['output']>;
  town?: Maybe<Scalars['String']['output']>;
};

export type ApplicationContractorInput = {
  applicationDocumentInput?: InputMaybe<ApplicationDocumentInput>;
  businessContent?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<ContactPersonInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  furigana?: InputMaybe<Scalars['String']['input']>;
  hp?: InputMaybe<Scalars['String']['input']>;
  importantDate?: InputMaybe<Scalars['Date']['input']>;
  isCorporate?: InputMaybe<Scalars['Boolean']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  prefectureId?: InputMaybe<Scalars['ID']['input']>;
  revenue?: InputMaybe<Scalars['Int']['input']>;
  town?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationContractorResponse = {
  __typename?: 'ApplicationContractorResponse';
  address: Scalars['String']['output'];
  isCorporate?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ApplicationContractorSortKey = {
  address?: InputMaybe<OrderByEnum>;
  cBusinessContent?: InputMaybe<OrderByEnum>;
  cContractor?: InputMaybe<OrderByEnum>;
  cHp?: InputMaybe<OrderByEnum>;
  cNumberOfEmployees?: InputMaybe<OrderByEnum>;
  email?: InputMaybe<OrderByEnum>;
  fax?: InputMaybe<OrderByEnum>;
  furigana?: InputMaybe<OrderByEnum>;
  id?: InputMaybe<OrderByEnum>;
  importantDate?: InputMaybe<OrderByEnum>;
  isCorporate?: InputMaybe<OrderByEnum>;
  name?: InputMaybe<OrderByEnum>;
  phoneNumber?: InputMaybe<OrderByEnum>;
  revenue?: InputMaybe<OrderByEnum>;
};

export type ApplicationCustomerResponse = {
  __typename?: 'ApplicationCustomerResponse';
  applicationContractor?: Maybe<LessorApplicationContractorResponse>;
  applicationProperty?: Maybe<ApplicationPropertyResponse>;
  contractDocuments?: Maybe<Array<Maybe<ContractDocumentCustomResponse>>>;
  contractDoneDate?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ApplicationDetailResponse = {
  __typename?: 'ApplicationDetailResponse';
  application?: Maybe<ConfirmApplicationChange>;
  applicationContractor?: Maybe<ApplicationContractorChange>;
  applicationGuarantee?: Maybe<ApplicationGuaranteeChange>;
  applicationSpaces?: Maybe<Array<Maybe<ApplicationSpaceChange>>>;
  applicationUsageInfo?: Maybe<Array<Maybe<ApplicationUsageInfoChange>>>;
  isFull: Scalars['Boolean']['output'];
  originalApplicationIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ApplicationDetectChangeResponse = {
  __typename?: 'ApplicationDetectChangeResponse';
  application?: Maybe<ConfirmApplicationChange>;
  applicationContractor?: Maybe<ApplicationContractorChange>;
  applicationGuarantee?: Maybe<ApplicationGuaranteeChange>;
  applicationSpaces?: Maybe<Array<Maybe<ApplicationSpaceChange>>>;
  applicationUsageInfo?: Maybe<Array<Maybe<ApplicationUsageInfoChange>>>;
};

export type ApplicationDocumentInput = {
  backOfIdCard?: InputMaybe<Scalars['String']['input']>;
  cHistoryCertificate?: InputMaybe<Scalars['String']['input']>;
  idCard?: InputMaybe<Scalars['String']['input']>;
  insuranceCard?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationDownloadResponse = {
  __typename?: 'ApplicationDownloadResponse';
  filename?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ApplicationEdge = {
  __typename?: 'ApplicationEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Application>;
};

export type ApplicationFilterInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ApplicationSortKey>;
  status?: InputMaybe<ApplicationStatusFilterEnum>;
};

export type ApplicationGuarantee = {
  __typename?: 'ApplicationGuarantee';
  address: Scalars['String']['output'];
  annualRevenue?: Maybe<Scalars['Int']['output']>;
  backOfCosignerIdCard?: Maybe<File>;
  birthday?: Maybe<Scalars['Date']['output']>;
  capital?: Maybe<Scalars['Int']['output']>;
  cosignerIdCard?: Maybe<File>;
  email: Scalars['String']['output'];
  employmentCompanyAddress: Scalars['String']['output'];
  employmentCompanyName: Scalars['String']['output'];
  familyRelationship: Scalars['String']['output'];
  fax: Scalars['String']['output'];
  hp: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  importantDate?: Maybe<Scalars['Date']['output']>;
  isGuarantor: Scalars['Boolean']['output'];
  lengthOfEmployment?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  numberOfEmployees?: Maybe<Scalars['Int']['output']>;
  phoneNumber: Scalars['String']['output'];
  revenue?: Maybe<Scalars['Int']['output']>;
};

export type ApplicationGuaranteeChange = {
  __typename?: 'ApplicationGuaranteeChange';
  address?: Maybe<StringChange>;
  annualRevenue?: Maybe<IntChange>;
  backOfCosignerIdCard?: Maybe<FileChange>;
  birthday?: Maybe<DateChange>;
  capital?: Maybe<IntChange>;
  cosignerIdCard?: Maybe<FileChange>;
  email?: Maybe<StringChange>;
  employmentCompanyAddress?: Maybe<StringChange>;
  employmentCompanyAddressMunicipality?: Maybe<StringChange>;
  employmentCompanyAddressPrefectureId?: Maybe<StringChange>;
  employmentCompanyAddressTown?: Maybe<StringChange>;
  employmentCompanyName?: Maybe<StringChange>;
  familyRelationship?: Maybe<StringChange>;
  fax?: Maybe<StringChange>;
  hp?: Maybe<StringChange>;
  importantDate?: Maybe<DateChange>;
  isGuarantor?: Maybe<BooleanChange>;
  lengthOfEmployment?: Maybe<IntChange>;
  municipality?: Maybe<StringChange>;
  name?: Maybe<StringChange>;
  numberOfEmployees?: Maybe<IntChange>;
  phoneNumber?: Maybe<StringChange>;
  prefectureId?: Maybe<StringChange>;
  revenue?: Maybe<IntChange>;
  town?: Maybe<StringChange>;
};

export type ApplicationGuaranteeInput = {
  annualRevenue?: InputMaybe<Scalars['Int']['input']>;
  backOfCosignerIdCard?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  capital?: InputMaybe<Scalars['Int']['input']>;
  cosignerIdCard?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employmentCompanyAddressMunicipality?: InputMaybe<Scalars['String']['input']>;
  employmentCompanyAddressPrefectureId?: InputMaybe<Scalars['ID']['input']>;
  employmentCompanyAddressTown?: InputMaybe<Scalars['String']['input']>;
  employmentCompanyName?: InputMaybe<Scalars['String']['input']>;
  familyRelationship?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  hp?: InputMaybe<Scalars['String']['input']>;
  importantDate?: InputMaybe<Scalars['Date']['input']>;
  isGuarantor?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfEmployment?: InputMaybe<Scalars['Int']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  prefectureId?: InputMaybe<Scalars['ID']['input']>;
  revenue?: InputMaybe<Scalars['Int']['input']>;
  town?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationIncludeOtherFee = {
  __typename?: 'ApplicationIncludeOtherFee';
  applicant: Applicant;
  approveCancelAt?: Maybe<Scalars['Date']['output']>;
  approveCancelDate?: Maybe<Scalars['Date']['output']>;
  carUserInfo: Array<CarUserInfo>;
  child?: Maybe<Application>;
  contractDocument?: Maybe<BaseContractDocumentResponse>;
  contractType?: Maybe<ContractTypeEnum>;
  documents: Array<File>;
  duration: ApplicationTime;
  guarantor: Guarantor;
  id: Scalars['ID']['output'];
  initialOtherFee?: Maybe<Array<Maybe<InitialOtherFee>>>;
  intendedUse: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  monthlyOtherFee?: Maybe<Array<Maybe<MonthlyOtherFee>>>;
  numberOfCar: Scalars['Int']['output'];
  parent?: Maybe<Application>;
  property?: Maybe<PropertyBaseResponse>;
  requestCancelAt?: Maybe<Scalars['Date']['output']>;
  requestCancelDate?: Maybe<Scalars['Date']['output']>;
  spaceGroup: SpaceGroupUsed;
  spaces: Array<SpaceUsed>;
  status: ApplicationStatusEnum;
  type?: Maybe<ApplicationTypeEnum>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type ApplicationInput = {
  applicationContractorInput?: InputMaybe<ApplicationContractorInput>;
  applicationGuaranteeInput?: InputMaybe<ApplicationGuaranteeInput>;
  applicationUsageInfoInput?: InputMaybe<ApplicationUsageInfoInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
  spaceGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type ApplicationInputDraft = {
  applicationContractorInput?: InputMaybe<ApplicationContractorInput>;
  applicationGuaranteeInput?: InputMaybe<ApplicationGuaranteeInput>;
  applicationUsageInfoInput?: InputMaybe<ApplicationUsageInfoInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  propertyId: Scalars['ID']['input'];
  spaceGroupId: Scalars['ID']['input'];
  spaceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ApplicationLessorSignatoryInfoType = {
  __typename?: 'ApplicationLessorSignatoryInfoType';
  agent_company_name?: Maybe<Scalars['String']['output']>;
  agent_municipality?: Maybe<Scalars['String']['output']>;
  agent_name?: Maybe<Scalars['String']['output']>;
  agent_prefecture_id?: Maybe<Scalars['String']['output']>;
  agent_town?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice_number?: Maybe<Scalars['String']['output']>;
  is_lessor_join_contract?: Maybe<Scalars['Boolean']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  prefecture_id?: Maybe<Scalars['ID']['output']>;
  property_manage_company_id: Scalars['ID']['output'];
  seal_image_url?: Maybe<Scalars['String']['output']>;
  signatory_company_name?: Maybe<Scalars['String']['output']>;
  signatory_email?: Maybe<Scalars['String']['output']>;
  signatory_name?: Maybe<Scalars['String']['output']>;
  signatory_type?: Maybe<Scalars['Int']['output']>;
  town?: Maybe<Scalars['String']['output']>;
};

export type ApplicationLessorSignatoryResponse = {
  __typename?: 'ApplicationLessorSignatoryResponse';
  agentCompanyName?: Maybe<Scalars['String']['output']>;
  agentMunicipality?: Maybe<Scalars['String']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  agentPrefectureId?: Maybe<Scalars['String']['output']>;
  agentTown?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isLessorJoinContract: Scalars['Boolean']['output'];
  municipality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  prefectureId?: Maybe<Scalars['String']['output']>;
  propertyManageCompanyId?: Maybe<Scalars['String']['output']>;
  sealImageUrl?: Maybe<Scalars['String']['output']>;
  signatoryCompanyName?: Maybe<Scalars['String']['output']>;
  signatoryEmail: Scalars['String']['output'];
  /**
   * signatoryType as integer:
   * 0: HOLDER_STAMP
   * 1: OTHER_STAMP
   */
  signatoryName: Scalars['String']['output'];
  signatoryType: Scalars['Int']['output'];
  town?: Maybe<Scalars['String']['output']>;
};

export type ApplicationManageItemResponse = {
  __typename?: 'ApplicationManageItemResponse';
  applicationProperty: ApplicationManagePropertyItem;
  approveCancelAt?: Maybe<Scalars['Date']['output']>;
  approveCancelDate?: Maybe<Scalars['Date']['output']>;
  contractType?: Maybe<Scalars['String']['output']>;
  hasUnreadMessage: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isEditable: Scalars['Boolean']['output'];
  monthlyAdminFee: Scalars['Int']['output'];
  monthlyOtherFee?: Maybe<Array<Maybe<MonthlyOtherFee>>>;
  monthlyRent?: Maybe<PaymentInfo>;
  requestCancelAt?: Maybe<Scalars['Date']['output']>;
  requestCancelDate?: Maybe<Scalars['Date']['output']>;
  status: Scalars['String']['output'];
  totalMonthlyOtherFee: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  useEndDate?: Maybe<Scalars['Date']['output']>;
  useStartDate?: Maybe<Scalars['Date']['output']>;
};

export type ApplicationManageProperty = {
  __typename?: 'ApplicationManageProperty';
  dailyRateType?: Maybe<Scalars['Int']['output']>;
  feature?: Maybe<Scalars['jsonb']['output']>;
  initialCost?: Maybe<Scalars['Int']['output']>;
  monthlyRent?: Maybe<Scalars['Int']['output']>;
  propertyAddress?: Maybe<Scalars['String']['output']>;
  propertyControlNumber?: Maybe<Scalars['String']['output']>;
  propertyImage?: Maybe<File>;
  propertyName?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  renewalFee?: Maybe<PaymentInfo>;
  spaceGroup?: Maybe<ApplicationManageSpaceGroup>;
  supportCarModel?: Maybe<Scalars['jsonb']['output']>;
  yearContract?: Maybe<Scalars['Int']['output']>;
};

export type ApplicationManagePropertyItem = {
  __typename?: 'ApplicationManagePropertyItem';
  propertyAddress: Scalars['String']['output'];
  propertyControlNumber: Scalars['String']['output'];
  propertyImage?: Maybe<File>;
  propertyName: Scalars['String']['output'];
};

export type ApplicationManageResponse = {
  __typename?: 'ApplicationManageResponse';
  applicationDetail?: Maybe<ApplicationDetailResponse>;
  applicationOverview?: Maybe<ApplicationOverviewResponse>;
};

export type ApplicationManageSpaceGroup = {
  __typename?: 'ApplicationManageSpaceGroup';
  contractCost?: Maybe<ContractCost>;
  initialCost?: Maybe<InitialCost>;
  initialOtherFee?: Maybe<Array<Maybe<InitialOtherFee>>>;
  monthlyOtherFee?: Maybe<Array<Maybe<MonthlyOtherFee>>>;
  monthlyOtherFeeDescription?: Maybe<Array<Maybe<MonthlyOtherFeeDescription>>>;
  monthlyRent?: Maybe<MonthlyRent>;
};

export type ApplicationMessage = {
  __typename?: 'ApplicationMessage';
  applicationRelatedId?: Maybe<Scalars['ID']['output']>;
  bulkAttachmentId?: Maybe<Scalars['ID']['output']>;
  bulkMessageId?: Maybe<Scalars['ID']['output']>;
  content: Scalars['String']['output'];
  file?: Maybe<File>;
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  sendAt: Scalars['DateTime']['output'];
  sender: Sender;
  type: MessageType;
};

export type ApplicationMessageEdge = {
  __typename?: 'ApplicationMessageEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ApplicationMessage>;
};

export type ApplicationMessagePayload = {
  __typename?: 'ApplicationMessagePayload';
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ApplicationOfficial = {
  __typename?: 'ApplicationOfficial';
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ApplicationOverviewResponse = {
  __typename?: 'ApplicationOverviewResponse';
  applicationProperty?: Maybe<ApplicationManagePropertyItem>;
  approveCancelAt?: Maybe<Scalars['Date']['output']>;
  approveCancelDate?: Maybe<Scalars['Date']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<Scalars['String']['output']>;
  hasUnpaidBilling?: Maybe<Scalars['Boolean']['output']>;
  hasUnreadMessage: Scalars['Boolean']['output'];
  monthlyAdminFee: Scalars['Int']['output'];
  monthlyOtherFee?: Maybe<Array<Maybe<MonthlyOtherFee>>>;
  monthlyRent?: Maybe<PaymentInfo>;
  requestCancelAt?: Maybe<Scalars['Date']['output']>;
  requestCancelDate?: Maybe<Scalars['Date']['output']>;
  status: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
  useEndDate?: Maybe<Scalars['Date']['output']>;
  useStartDate?: Maybe<Scalars['Date']['output']>;
};

export type ApplicationPayload = {
  __typename?: 'ApplicationPayload';
  application?: Maybe<ApplicationResponseSuccess>;
  userErrors?: Maybe<Array<Maybe<Errors>>>;
};

export type ApplicationProperty = {
  __typename?: 'ApplicationProperty';
  spaceGroup?: Maybe<ApplicationSpaceGroup>;
};

export type ApplicationPropertyInfoResponse = {
  __typename?: 'ApplicationPropertyInfoResponse';
  applicationProperty?: Maybe<ApplicationManageProperty>;
  applicationStatus?: Maybe<Scalars['Int']['output']>;
  geocode?: Maybe<Scalars['geom']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
};

export type ApplicationPropertyResponse = {
  __typename?: 'ApplicationPropertyResponse';
  administrativeFee?: Maybe<Scalars['Int']['output']>;
  deposit?: Maybe<PaymentInfo>;
  depositAdminFee?: Maybe<Scalars['Int']['output']>;
  gratuityFee?: Maybe<PaymentInfo>;
  initialOtherFee?: Maybe<Array<Maybe<InitialOtherFee>>>;
  monthlyOtherFee?: Maybe<Array<Maybe<MonthlyOtherFee>>>;
  monthlyOtherFeeDescription?: Maybe<Array<Maybe<MonthlyOtherFeeDescription>>>;
  propertyAddress?: Maybe<Scalars['String']['output']>;
  propertyControlNumber?: Maybe<Scalars['String']['output']>;
  propertyName?: Maybe<Scalars['String']['output']>;
  storeFee?: Maybe<PaymentInfo>;
};

export type ApplicationPropertySortKey = {
  dailyRateType?: InputMaybe<OrderByEnum>;
  deposit?: InputMaybe<OrderByEnum>;
  feature?: InputMaybe<OrderByEnum>;
  gratuityFee?: InputMaybe<OrderByEnum>;
  id?: InputMaybe<OrderByEnum>;
  monthlyRent?: InputMaybe<OrderByEnum>;
  otherCost?: InputMaybe<OrderByEnum>;
  otherMonthlyRent?: InputMaybe<OrderByEnum>;
  propertyAddress?: InputMaybe<OrderByEnum>;
  propertyControlNumber?: InputMaybe<OrderByEnum>;
  propertyName?: InputMaybe<OrderByEnum>;
  remarks?: InputMaybe<OrderByEnum>;
  renewalFee?: InputMaybe<OrderByEnum>;
  supportCarModel?: InputMaybe<OrderByEnum>;
  yearContract?: InputMaybe<OrderByEnum>;
};

export type ApplicationRelated = {
  __typename?: 'ApplicationRelated';
  id: Scalars['ID']['output'];
  isEditable: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
};

export type ApplicationResponse = {
  __typename?: 'ApplicationResponse';
  application?: Maybe<ApplicationOfficial>;
  status: Scalars['Int']['output'];
  useStartDate?: Maybe<Scalars['DateTime']['output']>;
  userErrors?: Maybe<Array<Maybe<Errors>>>;
};

export type ApplicationResponseSuccess = {
  __typename?: 'ApplicationResponseSuccess';
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ApplicationSendCancelRequestResponse = {
  __typename?: 'ApplicationSendCancelRequestResponse';
  application?: Maybe<ApplicationResponseSuccess>;
  userErrors?: Maybe<Array<Maybe<Errors>>>;
};

export type ApplicationSortKey = {
  applicationContractor?: InputMaybe<ApplicationContractorSortKey>;
  applicationProperty?: InputMaybe<ApplicationPropertySortKey>;
  applicationUsageInfo?: InputMaybe<ApplicationUsageInfoSortKey>;
  appliedAt?: InputMaybe<OrderByEnum>;
  cancellationDate?: InputMaybe<OrderByEnum>;
  contractDate?: InputMaybe<OrderByEnum>;
  contractType?: InputMaybe<OrderByEnum>;
  createdAt?: InputMaybe<OrderByEnum>;
  email?: InputMaybe<OrderByEnum>;
  id?: InputMaybe<OrderByEnum>;
  intendedUse?: InputMaybe<OrderByEnum>;
  isEditable?: InputMaybe<OrderByEnum>;
  numberOfCars?: InputMaybe<OrderByEnum>;
  password?: InputMaybe<OrderByEnum>;
  propertyManageId?: InputMaybe<OrderByEnum>;
  reviewSentAt?: InputMaybe<OrderByEnum>;
  spaceGroupId?: InputMaybe<OrderByEnum>;
  status?: InputMaybe<OrderByEnum>;
  type?: InputMaybe<OrderByEnum>;
  updatedAt?: InputMaybe<OrderByEnum>;
  useEndDate?: InputMaybe<OrderByEnum>;
  useStartDate?: InputMaybe<OrderByEnum>;
};

export type ApplicationSpace = {
  __typename?: 'ApplicationSpace';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ApplicationSpaceChange = {
  __typename?: 'ApplicationSpaceChange';
  id?: Maybe<IdChange>;
  name?: Maybe<StringChange>;
};

export type ApplicationSpaceGroup = {
  __typename?: 'ApplicationSpaceGroup';
  availability?: Maybe<ApplicationSpaceGroupAvailability>;
  contractCost?: Maybe<ContractCost>;
  initialCost?: Maybe<InitialCost>;
  initialOtherFee?: Maybe<Array<Maybe<InitialOtherFee>>>;
  monthlyOtherFee?: Maybe<Array<Maybe<MonthlyOtherFee>>>;
  monthlyRent?: Maybe<MonthlyRent>;
  property?: Maybe<Property>;
  supportCarModel?: Maybe<Scalars['String']['output']>;
};

export type ApplicationSpaceGroupAvailability = {
  __typename?: 'ApplicationSpaceGroupAvailability';
  numberOfFree?: Maybe<Scalars['Int']['output']>;
  numberOfFullSpace?: Maybe<Scalars['Int']['output']>;
};

export type ApplicationSpaceResponse = {
  __typename?: 'ApplicationSpaceResponse';
  applicationSpace: Array<ApplicationSpace>;
  id: Scalars['String']['output'];
  spaceId: Scalars['String']['output'];
  userErrors?: Maybe<Array<Maybe<Errors>>>;
};

export type ApplicationStatusContractResponse = {
  __typename?: 'ApplicationStatusContractResponse';
  billingDoc?: Maybe<Scalars['String']['output']>;
  billingDocCreatedAt?: Maybe<Scalars['Date']['output']>;
  contractDoc?: Maybe<Scalars['String']['output']>;
  contractDocCreatedAt?: Maybe<Scalars['Date']['output']>;
  spaceGuideDoc?: Maybe<Scalars['String']['output']>;
  spaceGuideDocCreatedAt?: Maybe<Scalars['Date']['output']>;
  status: Scalars['String']['output'];
};

export const ApplicationStatusEnum = {
  ApplicationAcceptance: 'APPLICATION_ACCEPTANCE',
  ApplicationNg: 'APPLICATION_NG',
  AppraisalNg: 'APPRAISAL_NG',
  CancellationAcceptance: 'CANCELLATION_ACCEPTANCE',
  CancellationScheduled: 'CANCELLATION_SCHEDULED',
  Contract: 'CONTRACT',
  ContractCompleted: 'CONTRACT_COMPLETED',
  ContractForceCanceled: 'CONTRACT_FORCE_CANCELED',
  ContractNg: 'CONTRACT_NG',
  ContractNormalCanceled: 'CONTRACT_NORMAL_CANCELED',
  Screening: 'SCREENING',
  TemporaryStorage: 'TEMPORARY_STORAGE'
} as const;

export type ApplicationStatusEnum = typeof ApplicationStatusEnum[keyof typeof ApplicationStatusEnum];
export const ApplicationStatusFilterEnum = {
  ApplicationAcceptance: 'APPLICATION_ACCEPTANCE',
  Contract: 'CONTRACT',
  ContractCompleted: 'CONTRACT_COMPLETED',
  Screening: 'SCREENING'
} as const;

export type ApplicationStatusFilterEnum = typeof ApplicationStatusFilterEnum[keyof typeof ApplicationStatusFilterEnum];
export type ApplicationStatusReview = {
  __typename?: 'ApplicationStatusReview';
  reviewSendAt?: Maybe<Scalars['Date']['output']>;
  status: Scalars['String']['output'];
};

export type ApplicationStatusReviewResponse = {
  __typename?: 'ApplicationStatusReviewResponse';
  application?: Maybe<ApplicationStatusReview>;
  document?: Maybe<DocumentStatusReview>;
};

export type ApplicationStatusUpdate = {
  __typename?: 'ApplicationStatusUpdate';
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ApplicationStatusUpdateWhenCompleteResponse = {
  __typename?: 'ApplicationStatusUpdateWhenCompleteResponse';
  application?: Maybe<ApplicationStatusUpdate>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type ApplicationTemporary = {
  __typename?: 'ApplicationTemporary';
  id: Scalars['ID']['output'];
  intendedUse?: Maybe<Scalars['String']['output']>;
  numberOfCar?: Maybe<Scalars['Int']['output']>;
  useStartDate?: Maybe<Scalars['String']['output']>;
};

export type ApplicationTime = {
  __typename?: 'ApplicationTime';
  applyAt?: Maybe<Scalars['String']['output']>;
  cancellationAt?: Maybe<Scalars['String']['output']>;
  contractAt?: Maybe<Scalars['String']['output']>;
  endAt?: Maybe<Scalars['String']['output']>;
  reviewSentAt?: Maybe<Scalars['String']['output']>;
  startAt?: Maybe<Scalars['String']['output']>;
};

export const ApplicationTypeEnum = {
  ManualRegistration: 'MANUAL_REGISTRATION',
  Parkstock: 'PARKSTOCK'
} as const;

export type ApplicationTypeEnum = typeof ApplicationTypeEnum[keyof typeof ApplicationTypeEnum];
export type ApplicationUsageInfo = {
  __typename?: 'ApplicationUsageInfo';
  address: Scalars['String']['output'];
  backOfUserIdCard?: Maybe<File>;
  birthday?: Maybe<Scalars['Date']['output']>;
  carModel: Scalars['String']['output'];
  colorOfCar: Scalars['String']['output'];
  email: Scalars['String']['output'];
  employmentCompanyAddress: Scalars['String']['output'];
  employmentCompanyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  numberPlate: NumberPlateType;
  phoneNumber: Scalars['String']['output'];
  relationshipWithContractor: Scalars['String']['output'];
  sizeOfCar: Scalars['Int']['output'];
  userCertificate?: Maybe<File>;
  userIdCard?: Maybe<File>;
};

export type ApplicationUsageInfoChange = {
  __typename?: 'ApplicationUsageInfoChange';
  address?: Maybe<StringChange>;
  backOfUserIdCard?: Maybe<FileChange>;
  birthday?: Maybe<DateChange>;
  carModel?: Maybe<StringChange>;
  colorOfCar?: Maybe<StringChange>;
  email?: Maybe<StringChange>;
  employmentCompanyAddress?: Maybe<StringChange>;
  employmentCompanyAddressMunicipality?: Maybe<StringChange>;
  employmentCompanyAddressPrefectureId?: Maybe<StringChange>;
  employmentCompanyAddressTown?: Maybe<StringChange>;
  employmentCompanyName?: Maybe<StringChange>;
  municipality?: Maybe<StringChange>;
  name?: Maybe<StringChange>;
  numberPlate?: Maybe<NumberPlateTypeChange>;
  phoneNumber?: Maybe<StringChange>;
  prefectureId?: Maybe<StringChange>;
  relationshipWithContractor?: Maybe<StringChange>;
  sizeOfCar?: Maybe<IntChange>;
  town?: Maybe<StringChange>;
  userCertificate?: Maybe<FileChange>;
  userIdCard?: Maybe<FileChange>;
};

export type ApplicationUsageInfoInput = {
  intendedUse?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<ApplicationUsageInfoItem>>>;
  numberOfCars: Scalars['Int']['input'];
  spaceGroupId?: InputMaybe<Scalars['ID']['input']>;
  spaceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  useStartDate?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationUsageInfoItem = {
  backOfIdCard?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  carModel?: InputMaybe<Scalars['String']['input']>;
  certificate?: InputMaybe<Scalars['String']['input']>;
  colorOfCar?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employmentCompanyAddressMunicipality?: InputMaybe<Scalars['String']['input']>;
  employmentCompanyAddressPrefectureId?: InputMaybe<Scalars['ID']['input']>;
  employmentCompanyAddressTown?: InputMaybe<Scalars['String']['input']>;
  employmentCompanyName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idCard?: InputMaybe<Scalars['String']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberPlate?: InputMaybe<NumberPlate>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  prefectureId?: InputMaybe<Scalars['ID']['input']>;
  relationshipWithContractor?: InputMaybe<Scalars['String']['input']>;
  sizeOfCar?: InputMaybe<SizeOfCar>;
  town?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationUsageInfoResponse = {
  __typename?: 'ApplicationUsageInfoResponse';
  id: Scalars['String']['output'];
};

export type ApplicationUsageInfoSortKey = {
  sizeOfCar?: InputMaybe<OrderByEnum>;
};

export type ApplicationUsageInfoTemporary = {
  __typename?: 'ApplicationUsageInfoTemporary';
  application?: Maybe<ApplicationTemporary>;
  carUserInfo?: Maybe<Array<Maybe<CarUserInfo>>>;
  spaces?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type ApplyInitialOtherFee = {
  __typename?: 'ApplyInitialOtherFee';
  name: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type ApplyMonthlyOtherFee = {
  __typename?: 'ApplyMonthlyOtherFee';
  applyMonths?: Maybe<Array<Scalars['Int']['output']>>;
  name: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type ApproveCancelApplicationInput = {
  approveCancelDate?: InputMaybe<Scalars['Date']['input']>;
  isApproved: Scalars['Boolean']['input'];
};

export type ApproveCancelApplicationResponse = {
  __typename?: 'ApproveCancelApplicationResponse';
  application?: Maybe<ApplicationResponseSuccess>;
  userErrors?: Maybe<Array<Maybe<Errors>>>;
};

export const AreaLevel = {
  Municipality: 'municipality',
  Prefecture: 'prefecture',
  Town: 'town'
} as const;

export type AreaLevel = typeof AreaLevel[keyof typeof AreaLevel];
export type AreaPathLevelResponse = {
  __typename?: 'AreaPathLevelResponse';
  level: AreaLevel;
  municipalitySlug?: Maybe<Scalars['String']['output']>;
  prefectureSlug: Scalars['String']['output'];
  townSlug?: Maybe<Scalars['String']['output']>;
};

export type AreaPrefectureItem = {
  __typename?: 'AreaPrefectureItem';
  id: Scalars['ID']['output'];
  kanaName?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  level: AreaLevel;
  long?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  orderNo?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

export type AreaPrefectureListResponse = {
  __typename?: 'AreaPrefectureListResponse';
  prefectures: Array<AreaPrefectureItem>;
};

export type AtportLink = {
  isLinked?: InputMaybe<Scalars['Boolean']['input']>;
  requestedCustomerAcquisitionWithinOneWeek?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AtportLinkUpdateResponse = {
  __typename?: 'AtportLinkUpdateResponse';
  property?: Maybe<IProperty>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

/** Simple availability for lessee property nearby and similar responses */
export type Availability = {
  __typename?: 'Availability';
  numberOfFree?: Maybe<Scalars['Int']['output']>;
  numberOfOccupied?: Maybe<Scalars['Int']['output']>;
};

/** Property availability with full status breakdown from computed field */
export type AvailabilityAdmin = {
  __typename?: 'AvailabilityAdmin';
  /** Total booked spaces excluding temporary */
  bookedSpace?: Maybe<Scalars['Int']['output']>;
  /** Number of empty/available spaces */
  emptySpace?: Maybe<Scalars['Int']['output']>;
  /** Number of spaces with non-temporary bookings with cancel date >= today */
  fullPlanCancelled?: Maybe<Scalars['Int']['output']>;
  /** Number of spaces with non-temporary bookings with terminate date >= today */
  fullPlanEnded?: Maybe<Scalars['Int']['output']>;
  /** Number of spaces with permanent bookings */
  fullSpace?: Maybe<Scalars['Int']['output']>;
  /** Number of spaces with temporary bookings */
  fullTemporary?: Maybe<Scalars['Int']['output']>;
  /** Total occupied spaces including temporary */
  occupiedSpace?: Maybe<Scalars['Int']['output']>;
  /** Total number of spaces */
  totalSpace?: Maybe<Scalars['Int']['output']>;
};

export type BaseContractDocumentResponse = {
  __typename?: 'BaseContractDocumentResponse';
  cloudsignDocumentId?: Maybe<Scalars['String']['output']>;
  documentStatus?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isUpdatedContract?: Maybe<Scalars['Boolean']['output']>;
};

export type BillingFeeDetail = {
  __typename?: 'BillingFeeDetail';
  initial?: Maybe<Array<InitialFeeDetail>>;
  monthly?: Maybe<Array<MonthlyFeeDetail>>;
};

export type BooleanChange = {
  __typename?: 'BooleanChange';
  isChange: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type BulkMessagePayload = {
  __typename?: 'BulkMessagePayload';
  message?: Maybe<ApplicationBulkMessagePayload>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type CarConfig = {
  carModel: Scalars['Boolean']['input'];
  colorOfCar: Scalars['Boolean']['input'];
  sizeOfCar: Scalars['Boolean']['input'];
};

export type CarConfigType = {
  __typename?: 'CarConfigType';
  carModel: Scalars['Boolean']['output'];
  colorOfCar: Scalars['Boolean']['output'];
  numberPlate: Scalars['Boolean']['output'];
  sizeOfCar: Scalars['Boolean']['output'];
};

export type CarInfo = {
  __typename?: 'CarInfo';
  color: Scalars['String']['output'];
  model: Scalars['String']['output'];
  number: Scalars['jsonb']['output'];
  type: Scalars['Int']['output'];
};

export type CarUserInfo = {
  __typename?: 'CarUserInfo';
  carInfo?: Maybe<CarInfo>;
  id: Scalars['ID']['output'];
  userInfo?: Maybe<UserInfo>;
};

export type CardSessionResponse = {
  __typename?: 'CardSessionResponse';
  expire: Scalars['String']['output'];
  linkUrl: Scalars['String']['output'];
};

export type ChangePasswordInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ChangePasswordResponse = {
  __typename?: 'ChangePasswordResponse';
  applicationId: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Company = {
  __typename?: 'Company';
  address: Scalars['String']['output'];
  content: Scalars['String']['output'];
  email: Scalars['String']['output'];
  fax: Scalars['String']['output'];
  furigana: Scalars['String']['output'];
  hp: Scalars['String']['output'];
  id: Scalars['String']['output'];
  importantDate?: Maybe<Scalars['String']['output']>;
  isCorporate: Scalars['Boolean']['output'];
  municipality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  numberOfEmployees?: Maybe<Scalars['Int']['output']>;
  personInContact?: Maybe<CompanyContactPerson>;
  phoneNumber: Scalars['String']['output'];
  prefectureId?: Maybe<Scalars['String']['output']>;
  revenue?: Maybe<Scalars['Int']['output']>;
  town?: Maybe<Scalars['String']['output']>;
};

export type CompanyConfig = {
  __typename?: 'CompanyConfig';
  company?: Maybe<Company>;
  userErrors?: Maybe<Array<Maybe<Errors>>>;
};

export type CompanyConfigDetailInput = {
  applicationId?: InputMaybe<Scalars['ID']['input']>;
  page: Scalars['Int']['input'];
  propertyId?: InputMaybe<Scalars['ID']['input']>;
};

export type CompanyConfigDetailResponse = {
  __typename?: 'CompanyConfigDetailResponse';
  id: Scalars['ID']['output'];
  logo: Scalars['String']['output'];
  propertyManageCompanyId: Scalars['ID']['output'];
  siteName: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CompanyContactPerson = {
  __typename?: 'CompanyContactPerson';
  department: Scalars['String']['output'];
  email: Scalars['String']['output'];
  fax: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type CompanyDetail = {
  __typename?: 'CompanyDetail';
  address: Scalars['String']['output'];
  branchName?: Maybe<Scalars['String']['output']>;
  closingTime?: Maybe<Scalars['String']['output']>;
  defaultContractDocument?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  openingTime?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type CompanyDetailList = {
  __typename?: 'CompanyDetailList';
  address: Scalars['String']['output'];
  branchName?: Maybe<Scalars['String']['output']>;
  closingTime?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  openingTime?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
};

export type CompanyFormConfig = {
  __typename?: 'CompanyFormConfig';
  applicant?: Maybe<ApplicantConfigType>;
  application?: Maybe<ApplicationConfigType>;
  car?: Maybe<CarConfigType>;
  guarantor?: Maybe<GuarantorConfigType>;
  user?: Maybe<UserConfigType>;
};

export type CompanyPayload = {
  __typename?: 'CompanyPayload';
  company?: Maybe<ICompany>;
  userErrors?: Maybe<Array<Maybe<Errors>>>;
};

export type CompanySiteInput = {
  isParkStock?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CompleteContractConfirmationStepResponse = {
  __typename?: 'CompleteContractConfirmationStepResponse';
  contractConfirmationStep: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CompleteRegisterInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type CompleteRegisterResponse = {
  __typename?: 'CompleteRegisterResponse';
  applicationId?: Maybe<Scalars['String']['output']>;
  contractMakingId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  propertyId?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  spaceGroupId?: Maybe<Scalars['String']['output']>;
};

export type ConfirmApplication = {
  __typename?: 'ConfirmApplication';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  intendedUse: Scalars['String']['output'];
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  numberOfCars: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  useEndDate?: Maybe<Scalars['Date']['output']>;
  useStartDate?: Maybe<Scalars['Date']['output']>;
};

export type ConfirmApplicationChange = {
  __typename?: 'ConfirmApplicationChange';
  id?: Maybe<StringChange>;
  intendedUse?: Maybe<StringChange>;
  isEditable?: Maybe<BooleanChange>;
  numberOfCars?: Maybe<IntChange>;
  useEndDate?: Maybe<DateChange>;
  useStartDate?: Maybe<DateChange>;
};

export type ContactPerson = {
  fax: Scalars['Boolean']['input'];
};

export type ContactPersonInput = {
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ContactPersonType = {
  __typename?: 'ContactPersonType';
  department: Scalars['Boolean']['output'];
  email: Scalars['Boolean']['output'];
  fax: Scalars['Boolean']['output'];
  name: Scalars['Boolean']['output'];
  phoneNumber: Scalars['Boolean']['output'];
};

export type Contract = {
  __typename?: 'Contract';
  dailyRateType?: Maybe<Scalars['Int']['output']>;
  years?: Maybe<Scalars['Int']['output']>;
};

export type ContractApplication = {
  __typename?: 'ContractApplication';
  applicationContractor?: Maybe<ApplicationContractorResponse>;
  applicationProperty?: Maybe<ApplicationPropertyResponse>;
  appliedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  useStartDate?: Maybe<Scalars['Date']['output']>;
};

export type ContractBillResponse = {
  __typename?: 'ContractBillResponse';
  amount: Scalars['Int']['output'];
  detail?: Maybe<RentalInfoDetailType>;
  itemType: Scalars['Int']['output'];
};

export type ContractBillingItemResponse = {
  __typename?: 'ContractBillingItemResponse';
  amount: Scalars['Float']['output'];
  billingCycleEnd?: Maybe<Scalars['Date']['output']>;
  billingCycleStart?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  dueDate: Scalars['Date']['output'];
  /**
   * Item type as integer:
   * 0: FIRST_PAYMENT - Initial payment
   * 1: MONTHLY_PAYMENT - Monthly recurring payment
   */
  itemType: Scalars['Int']['output'];
  /**
   * Contract billing status as integer:
   * 0: PENDING - 未払い (Not paid yet)
   * 1: UNPAID - 支払前 (Before payment)
   * 2: PAID - 支払済 (Paid)
   * 3: CANCEL - キャンセル (Cancelled)
   * 4: SUBROGATION - 代位弁済 (Subrogation)
   */
  status: Scalars['Int']['output'];
};

export const ContractBillingStatusEnum = {
  Paid: 'PAID',
  Pending: 'PENDING',
  Subrogation: 'SUBROGATION',
  Unpaid: 'UNPAID'
} as const;

export type ContractBillingStatusEnum = typeof ContractBillingStatusEnum[keyof typeof ContractBillingStatusEnum];
export type ContractCost = {
  __typename?: 'ContractCost';
  administrativeFee?: Maybe<Scalars['Int']['output']>;
  depositAdminFee?: Maybe<Scalars['Int']['output']>;
  renewalAddFee?: Maybe<Scalars['Int']['output']>;
  renewalAdminFee?: Maybe<PaymentInfo>;
  renewalFee?: Maybe<PaymentInfo>;
  storeFee?: Maybe<PaymentInfo>;
};

export type ContractCostInput = {
  administrativeFee: Scalars['Int']['input'];
  renewalAdminFee: TaxPriceInput;
  storeFee: TaxPriceInput;
};

export const ContractDailyRateType = {
  AllPossible: 'ALL_POSSIBLE',
  NotPossible: 'NOT_POSSIBLE',
  OnlyEndMonth: 'ONLY_END_MONTH',
  OnlyFirstMonth: 'ONLY_FIRST_MONTH'
} as const;

export type ContractDailyRateType = typeof ContractDailyRateType[keyof typeof ContractDailyRateType];
export type ContractDetailResponse = {
  __typename?: 'ContractDetailResponse';
  application?: Maybe<ApplicationContractDetailResponse>;
  certificateDeliveryAddressFull?: Maybe<Scalars['String']['output']>;
  certificateDeliveryMunicipality?: Maybe<Scalars['String']['output']>;
  certificateDeliveryPrefectureId?: Maybe<Scalars['String']['output']>;
  certificateDeliveryTown?: Maybe<Scalars['String']['output']>;
  contractBills?: Maybe<Array<Maybe<ContractBillResponse>>>;
  contractPaymentInfo?: Maybe<ContractPaymentInfoResponse>;
  desiredDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  formExpiredAt?: Maybe<Scalars['DateTime']['output']>;
  formSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  needParkingCertificate: Scalars['Boolean']['output'];
  privacyPolicyAgreed: Scalars['Boolean']['output'];
  specialTerms?: Maybe<Scalars['String']['output']>;
  step: Scalars['Int']['output'];
};

export type ContractDocument = {
  __typename?: 'ContractDocument';
  application?: Maybe<ContractApplication>;
  cloudsignDocumentId?: Maybe<Scalars['String']['output']>;
  conclusionDate?: Maybe<Scalars['Date']['output']>;
  documentStatus?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  propertyImage?: Maybe<PropertyUsedImageResponse>;
  updatedAt: Scalars['Date']['output'];
};

export type ContractDocumentCustomResponse = {
  __typename?: 'ContractDocumentCustomResponse';
  conclusionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
};

export type ContractDocumentDetailResponse = {
  __typename?: 'ContractDocumentDetailResponse';
  canTransfer?: Maybe<Scalars['Boolean']['output']>;
  cloudsignDocumentId?: Maybe<Scalars['String']['output']>;
  conclusionDate?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  documentStatus?: Maybe<Scalars['Int']['output']>;
  files?: Maybe<Array<Maybe<FileResponse>>>;
  id: Scalars['String']['output'];
  isUpdatedContract?: Maybe<Scalars['Boolean']['output']>;
  lastProcessedAt?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  receivers?: Maybe<Array<Maybe<ReceiverResponse>>>;
  reportees?: Maybe<Array<Maybe<ReporteeResponse>>>;
  sentAt?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ContractDocumentEdge = {
  __typename?: 'ContractDocumentEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ContractDocument>;
};

export type ContractDocumentInfo = {
  __typename?: 'ContractDocumentInfo';
  documentId: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  generatedAt: Scalars['DateTime']['output'];
};

export type ContractDocumentSortKey = {
  application?: InputMaybe<ApplicationSortKey>;
  conclusionDate?: InputMaybe<OrderByEnum>;
  createdAt?: InputMaybe<OrderByEnum>;
  documentStatus?: InputMaybe<OrderByEnum>;
  id?: InputMaybe<OrderByEnum>;
  updatedAt?: InputMaybe<OrderByEnum>;
};

export type ContractDocumentStep1Input = {
  note?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ContractDocumentStep4Input = {
  canTransfer: Scalars['Boolean']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

export type ContractFormBackStepInput = {
  contractDetailId: Scalars['ID']['input'];
  currentStep: Scalars['Int']['input'];
};

export type ContractInput = {
  dailyRateType: ContractDailyRateType;
  renewalFee: TaxPriceInput;
  years: Scalars['Int']['input'];
};

export type ContractPaymentInfoResponse = {
  __typename?: 'ContractPaymentInfoResponse';
  creditCardPaymentMethod?: Maybe<CreditCardPaymentMethodResponse>;
  paymentMethodType?: Maybe<Scalars['Int']['output']>;
};

export type ContractPaymentResponse = {
  __typename?: 'ContractPaymentResponse';
  id: Scalars['String']['output'];
};

export type ContractPaymentResponseCreditCard = {
  __typename?: 'ContractPaymentResponseCreditCard';
  id: Scalars['String']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export const ContractTypeEnum = {
  DocumentContract: 'DOCUMENT_CONTRACT',
  OnlineContract: 'ONLINE_CONTRACT'
} as const;

export type ContractTypeEnum = typeof ContractTypeEnum[keyof typeof ContractTypeEnum];
export type Contractor = {
  __typename?: 'Contractor';
  applicationId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type ContractorInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicationContractorInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  furigana?: InputMaybe<Scalars['String']['input']>;
  importantDate?: InputMaybe<Scalars['Date']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  prefectureId?: InputMaybe<Scalars['ID']['input']>;
  revenue?: InputMaybe<Scalars['Int']['input']>;
  town?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicationContractorLessorInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  applicationDocumentInput: LessorApplicationDocumentInput;
  businessContent?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<ContactPersonInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  furigana?: InputMaybe<Scalars['String']['input']>;
  hp?: InputMaybe<Scalars['String']['input']>;
  importantDate?: InputMaybe<Scalars['Date']['input']>;
  isCorporate: Scalars['Boolean']['input'];
  municipality?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  prefectureId?: InputMaybe<Scalars['ID']['input']>;
  revenue?: InputMaybe<Scalars['Int']['input']>;
  town?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicationLessorSignatoryInput = {
  agentCompanyName?: InputMaybe<Scalars['String']['input']>;
  agentMunicipality?: InputMaybe<Scalars['String']['input']>;
  agentName?: InputMaybe<Scalars['String']['input']>;
  agentPrefectureId?: InputMaybe<Scalars['String']['input']>;
  agentTown?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  isLessorJoinContract: Scalars['Boolean']['input'];
  municipality?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  prefectureId?: InputMaybe<Scalars['String']['input']>;
  sealImageUrl?: InputMaybe<Scalars['String']['input']>;
  signatoryCompanyName?: InputMaybe<Scalars['String']['input']>;
  signatoryEmail: Scalars['String']['input'];
  /**
   * signatoryType as integer:
   * 0: HOLDER_STAMP
   * 1: OTHER_STAMP
   */
  signatoryName: Scalars['String']['input'];
  signatoryType: Scalars['Int']['input'];
  town?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCardSessionInput = {
  contractDetailId: Scalars['ID']['input'];
};

export type CreateContactRequestInput = {
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  externalPropertyId: Scalars['ID']['input'];
  isCorporate: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  sizeOfCar: Scalars['Int']['input'];
  useEndDate?: InputMaybe<Scalars['Date']['input']>;
  useOfCars: Scalars['Int']['input'];
  useStartDate: Scalars['Date']['input'];
  vehicleType: Scalars['String']['input'];
};

export type CreateContactRequestResponse = {
  __typename?: 'CreateContactRequestResponse';
  id: Scalars['String']['output'];
};

export type CreateLessorApplicationUsageInfoInput = {
  applicationUsageInfoItem: LessorApplicationUsageInfoItem;
  intendedUse?: InputMaybe<Scalars['String']['input']>;
  numberOfCars: Scalars['Int']['input'];
  useStartDate: Scalars['String']['input'];
};

export type CreateMessageTemplateInput = {
  body: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateOwnerInquiryInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  inquiry?: InputMaybe<Scalars['String']['input']>;
  parkingLots: Array<ParkingLotInput>;
  phoneNumber: Scalars['String']['input'];
};

export type CreatePropertyInput = {
  geocode: Geocode;
  hasGuarantee?: InputMaybe<Scalars['Boolean']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemNumber?: InputMaybe<Scalars['String']['input']>;
  mailingGroupId?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  municipality: Scalars['String']['input'];
  name: Scalars['String']['input'];
  personInCharge: Scalars['String']['input'];
  prefectureId: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  town: Scalars['String']['input'];
  visibility?: InputMaybe<PropertyVisibility>;
};

export type CreatePropertyManageCompanyOfficerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  firstNameKana: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  lastNameKana: Scalars['String']['input'];
  propertyCompanyId: Scalars['String']['input'];
};

export type CreatePropertyManageCompanyOfficerResponse = {
  __typename?: 'CreatePropertyManageCompanyOfficerResponse';
  authUid: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  firstNameKana: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  lastNameKana: Scalars['String']['output'];
  propertyCompanyId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CreditCardPaymentMethodResponse = {
  __typename?: 'CreditCardPaymentMethodResponse';
  cardExpire: Scalars['String']['output'];
  cardHolderName: Scalars['String']['output'];
  cardLast4: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomerApplication = {
  __typename?: 'CustomerApplication';
  applicant: Applicant;
  approveCancelAt?: Maybe<Scalars['Date']['output']>;
  approveCancelDate?: Maybe<Scalars['Date']['output']>;
  carUserInfo: Array<CarUserInfo>;
  child?: Maybe<Application>;
  contractType?: Maybe<ContractTypeEnum>;
  duration: ApplicationTime;
  id: Scalars['ID']['output'];
  intendedUse: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  numberOfCar: Scalars['Int']['output'];
  parent?: Maybe<Application>;
  requestCancelAt?: Maybe<Scalars['Date']['output']>;
  requestCancelDate?: Maybe<Scalars['Date']['output']>;
  spaceGroup: SpaceGroupUsed;
  spaces: Array<CustomerSpace>;
  status: ApplicationStatusEnum;
  type?: Maybe<ApplicationTypeEnum>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type CustomerApplicationConnection = {
  __typename?: 'CustomerApplicationConnection';
  edges?: Maybe<Array<Maybe<CustomerApplicationEdge>>>;
  pageInfo: PageInfo;
};

export type CustomerApplicationEdge = {
  __typename?: 'CustomerApplicationEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CustomerApplication>;
};

export type CustomerApplicationFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ApplicationSortKey>;
  statuses?: InputMaybe<Array<InputMaybe<ApplicationStatusEnum>>>;
};

export type CustomerChangePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type CustomerChangePasswordResponse = {
  __typename?: 'CustomerChangePasswordResponse';
  message: Scalars['String']['output'];
};

export type CustomerForgotPasswordInput = {
  email: Scalars['String']['input'];
};

export type CustomerForgotPasswordResponse = {
  __typename?: 'CustomerForgotPasswordResponse';
  message: Scalars['String']['output'];
};

export type CustomerLoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type CustomerLogoutResponse = {
  __typename?: 'CustomerLogoutResponse';
  message: Scalars['String']['output'];
};

export type CustomerResetPasswordInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type CustomerResetPasswordResponse = {
  __typename?: 'CustomerResetPasswordResponse';
  message: Scalars['String']['output'];
};

export type CustomerResponse = {
  __typename?: 'CustomerResponse';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type CustomerSpace = {
  __typename?: 'CustomerSpace';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DashboardApplicationStatistic = {
  __typename?: 'DashboardApplicationStatistic';
  count: Scalars['Int']['output'];
  status: ApplicationStatusEnum;
};

export type DashboardApplicationStatisticsResult = {
  __typename?: 'DashboardApplicationStatisticsResult';
  statistics: Array<DashboardApplicationStatistic>;
};

export type DashboardBillingStatsMonth = {
  __typename?: 'DashboardBillingStatsMonth';
  billedAmount: Scalars['Int']['output'];
  month: Scalars['String']['output'];
  paidAmount: Scalars['Int']['output'];
  subrogationAmount: Scalars['Int']['output'];
};

export type DashboardBillingStatsResult = {
  __typename?: 'DashboardBillingStatsResult';
  months: Array<DashboardBillingStatsMonth>;
  offset: Scalars['Int']['output'];
  period: DashboardStatsPeriodOption;
  totalMonths: Scalars['Int']['output'];
};

export type DashboardPropertyStatisticsResult = {
  __typename?: 'DashboardPropertyStatisticsResult';
  efficiency: Scalars['Int']['output'];
  emptyProperties: Scalars['Int']['output'];
  fullProperties: Scalars['Int']['output'];
  present: DashboardPropertyStatsPresent;
  totalPrivateProperties: Scalars['Int']['output'];
  totalPublicProperties: Scalars['Int']['output'];
};

export type DashboardPropertyStatsPresent = {
  __typename?: 'DashboardPropertyStatsPresent';
  free: Scalars['Int']['output'];
  full: Scalars['Int']['output'];
};

export type DashboardSpaceStatsPresent = {
  __typename?: 'DashboardSpaceStatsPresent';
  free: Scalars['Int']['output'];
  full: Scalars['Int']['output'];
  temporary: Scalars['Int']['output'];
};

export type DashboardSpaceStatsResponse = {
  __typename?: 'DashboardSpaceStatsResponse';
  efficiency: Scalars['Int']['output'];
  present: DashboardSpaceStatsPresent;
  totalSpaceFree: Scalars['Int']['output'];
  totalSpaceFull: Scalars['Int']['output'];
  totalSpaceInactive: Scalars['Int']['output'];
  totalSpaceTemporary: Scalars['Int']['output'];
  totalSpacesActive: Scalars['Int']['output'];
};

export const DashboardStatsPeriodOption = {
  OneYear: 'ONE_YEAR',
  SixMonths: 'SIX_MONTHS',
  ThreeMonths: 'THREE_MONTHS',
  TwoYears: 'TWO_YEARS'
} as const;

export type DashboardStatsPeriodOption = typeof DashboardStatsPeriodOption[keyof typeof DashboardStatsPeriodOption];
export type DateChange = {
  __typename?: 'DateChange';
  isChange: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['Date']['output']>;
};

export type DateRangeInput = {
  /** Datetime at 23:59:59 in client's local timezone (e.g., 2025-03-25T23:59:59+09:00) */
  end?: InputMaybe<Scalars['String']['input']>;
  /** Datetime at 00:00 in client's local timezone (e.g., 2025-03-25T00:00:00+09:00) */
  start?: InputMaybe<Scalars['String']['input']>;
};

export type DefaultMonthlyRent = {
  __typename?: 'DefaultMonthlyRent';
  isTaxExempt: Scalars['Boolean']['output'];
  value: Scalars['Int']['output'];
};

export type DeleteMailingGroupResponse = {
  __typename?: 'DeleteMailingGroupResponse';
  id: Scalars['ID']['output'];
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type DeleteMessageTemplateInput = {
  messageTemplateId: Scalars['String']['input'];
};

export type DeleteSpaceGroup = {
  __typename?: 'DeleteSpaceGroup';
  id: Scalars['ID']['output'];
};

export type DeleteSpaceGroupResponse = {
  __typename?: 'DeleteSpaceGroupResponse';
  spaceGroup?: Maybe<DeleteSpaceGroup>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type Document = {
  __typename?: 'Document';
  downloadedAt?: Maybe<Scalars['Date']['output']>;
  file?: Maybe<File>;
};

export type DocumentResponse = {
  __typename?: 'DocumentResponse';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  storagePath: Scalars['String']['output'];
};

export type DocumentStatusReview = {
  __typename?: 'DocumentStatusReview';
  downloadedAt?: Maybe<Scalars['Date']['output']>;
};

export const DocumentType = {
  Billing: 'BILLING',
  Contract: 'CONTRACT',
  SpaceGuide: 'SPACE_GUIDE'
} as const;

export type DocumentType = typeof DocumentType[keyof typeof DocumentType];
export type DownloadApplicationReviewResponse = {
  __typename?: 'DownloadApplicationReviewResponse';
  downloadedAt?: Maybe<Scalars['Date']['output']>;
};

export type Errors = {
  __typename?: 'Errors';
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Feature = {
  __typename?: 'Feature';
  lentItem: Scalars['String']['output'];
  pavement: Scalars['String']['output'];
  roof: Scalars['String']['output'];
  time: FeatureTime;
  type: Scalars['String']['output'];
};

export type FeatureInput = {
  loan: Scalars['String']['input'];
  pavement: FeaturePavement;
  roof: FeatureRoof;
  time?: InputMaybe<FeatureTimeInput>;
  type: FeatureType;
};

export const FeaturePavement = {
  Asphalt: 'ASPHALT',
  Concrete: 'CONCRETE',
  Gravel: 'GRAVEL',
  Others: 'OTHERS',
  Unknown: 'UNKNOWN'
} as const;

export type FeaturePavement = typeof FeaturePavement[keyof typeof FeaturePavement];
export const FeatureRoof = {
  No: 'NO',
  Unknown: 'UNKNOWN',
  Yes: 'YES'
} as const;

export type FeatureRoof = typeof FeatureRoof[keyof typeof FeatureRoof];
export type FeatureTime = {
  __typename?: 'FeatureTime';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  startDate: Scalars['DateTime']['output'];
};

export type FeatureTimeInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export const FeatureType = {
  Flat: 'FLAT',
  Mechanical: 'MECHANICAL',
  Solid: 'SOLID'
} as const;

export type FeatureType = typeof FeatureType[keyof typeof FeatureType];
export type Fee = {
  __typename?: 'Fee';
  isTaxExempt: Scalars['Boolean']['output'];
  value: Scalars['Int']['output'];
};

export type File = {
  __typename?: 'File';
  createdAt?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['Int']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileType: Scalars['String']['output'];
  originUrl?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type FileChange = {
  __typename?: 'FileChange';
  isChange: Scalars['Boolean']['output'];
  value?: Maybe<File>;
};

export type FileResponse = {
  __typename?: 'FileResponse';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  widgets?: Maybe<Array<Maybe<WidgetResponse>>>;
};

export type FinalizeContractInput = {
  contractDetailId: Scalars['ID']['input'];
};

export type ForgotPasswordInput = {
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type ForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse';
  message: Scalars['String']['output'];
};

export type FormConfigInput = {
  applicant: ApplicantConfig;
  application: ApplicationConfig;
  car: CarConfig;
  guarantor: GuarantorConfig;
  user: UserConfig;
};

export type GenerateAdminSignedUrlInput = {
  fileName: Scalars['String']['input'];
  itemId?: InputMaybe<Scalars['ID']['input']>;
  targetFolder: PublicTargetFolder;
};

export type GenerateSignedPostPolicyResponse = {
  __typename?: 'GenerateSignedPostPolicyResponse';
  fields: Scalars['JSON']['output'];
  url: Scalars['String']['output'];
};

export type GenerateSignedUrlInput = {
  fileName: Scalars['String']['input'];
  /** 1-For Download, 2-For Upload */
  type: Scalars['Int']['input'];
};

export type GenerateSignedUrlResponse = {
  __typename?: 'GenerateSignedUrlResponse';
  url: Scalars['String']['output'];
};

export type GenerateUploadSignedUrlForPropertyMasterInputDetail = {
  fileName: Scalars['String']['input'];
  isPublicBucket?: InputMaybe<Scalars['Boolean']['input']>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  targetFolder: TargetFolder;
};

export type GenerateUploadSignedUrlInput = {
  fileName: Scalars['String']['input'];
  isPublicBucket?: InputMaybe<Scalars['Boolean']['input']>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  targetFolder: TargetFolder;
};

export type GenerateUploadSignedUrlInputDetail = {
  fileName: Scalars['String']['input'];
  isPublicBucket?: InputMaybe<Scalars['Boolean']['input']>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  targetFolder: TargetFolder;
};

export type GeneratedContractPdfFile = {
  __typename?: 'GeneratedContractPdfFile';
  createdAt?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type Geocode = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type Geom = {
  __typename?: 'Geom';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GetContractDetailManageResponse = {
  __typename?: 'GetContractDetailManageResponse';
  contractPaymentInfo?: Maybe<ContractPaymentInfoResponse>;
  id: Scalars['ID']['output'];
};

export type GetContractPdfDocumentResult = {
  __typename?: 'GetContractPdfDocumentResult';
  generated?: Maybe<GeneratedContractPdfFile>;
  signedUpload?: Maybe<SignedUploadContractPdfFile>;
};

export type GetContractor = {
  __typename?: 'GetContractor';
  department: Scalars['String']['output'];
  email: Scalars['String']['output'];
  fax: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type GetContractorChange = {
  __typename?: 'GetContractorChange';
  department?: Maybe<StringChange>;
  email?: Maybe<StringChange>;
  fax?: Maybe<StringChange>;
  name?: Maybe<StringChange>;
  phoneNumber?: Maybe<StringChange>;
};

export type Guarantor = {
  __typename?: 'Guarantor';
  address: Scalars['String']['output'];
  annualRevenue?: Maybe<Scalars['Int']['output']>;
  backOfCosignerIdCard?: Maybe<File>;
  birthday?: Maybe<Scalars['String']['output']>;
  capital?: Maybe<Scalars['Int']['output']>;
  cosignerIdCard?: Maybe<File>;
  email: Scalars['String']['output'];
  employmentCompanyAddress?: Maybe<Scalars['String']['output']>;
  employmentCompanyAddressMunicipality?: Maybe<Scalars['String']['output']>;
  employmentCompanyAddressPrefectureId?: Maybe<Scalars['String']['output']>;
  employmentCompanyAddressTown?: Maybe<Scalars['String']['output']>;
  employmentCompanyName?: Maybe<Scalars['String']['output']>;
  familyRelationship: Scalars['String']['output'];
  fax: Scalars['String']['output'];
  hp?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importantDate?: Maybe<Scalars['Date']['output']>;
  isGuarantor: Scalars['Boolean']['output'];
  lengthOfEmployment?: Maybe<Scalars['Int']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  numberOfEmployees?: Maybe<Scalars['Int']['output']>;
  phoneNumber: Scalars['String']['output'];
  prefectureId?: Maybe<Scalars['String']['output']>;
  revenue?: Maybe<Scalars['Int']['output']>;
  town?: Maybe<Scalars['String']['output']>;
  workplace?: Maybe<GuarantorWorkPlace>;
};

export type GuarantorConfig = {
  annualRevenue: Scalars['Boolean']['input'];
  birthday: Scalars['Boolean']['input'];
  capital: Scalars['Boolean']['input'];
  employmentCompanyAddress: Scalars['Boolean']['input'];
  employmentCompanyName: Scalars['Boolean']['input'];
  familyRelationship: Scalars['Boolean']['input'];
  fax: Scalars['Boolean']['input'];
  hp: Scalars['Boolean']['input'];
  importantDate: Scalars['Boolean']['input'];
  lengthOfEmployment: Scalars['Boolean']['input'];
  numberOfEmployees: Scalars['Boolean']['input'];
  revenue: Scalars['Boolean']['input'];
};

export type GuarantorConfigType = {
  __typename?: 'GuarantorConfigType';
  address: Scalars['Boolean']['output'];
  annualRevenue: Scalars['Boolean']['output'];
  backOfCosignerIdCard: Scalars['Boolean']['output'];
  birthday: Scalars['Boolean']['output'];
  capital: Scalars['Boolean']['output'];
  cosignerIdCard: Scalars['Boolean']['output'];
  email: Scalars['Boolean']['output'];
  employmentCompanyAddress: Scalars['Boolean']['output'];
  employmentCompanyName: Scalars['Boolean']['output'];
  familyRelationship: Scalars['Boolean']['output'];
  fax: Scalars['Boolean']['output'];
  hp: Scalars['Boolean']['output'];
  importantDate: Scalars['Boolean']['output'];
  lengthOfEmployment: Scalars['Boolean']['output'];
  name: Scalars['Boolean']['output'];
  numberOfEmployees: Scalars['Boolean']['output'];
  phoneNumber: Scalars['Boolean']['output'];
  revenue: Scalars['Boolean']['output'];
};

export type GuarantorWorkPlace = {
  __typename?: 'GuarantorWorkPlace';
  address: Scalars['String']['output'];
  annualRevenue?: Maybe<Scalars['Int']['output']>;
  capital?: Maybe<Scalars['Int']['output']>;
  email: Scalars['String']['output'];
  employmentCompanyAddressMunicipality?: Maybe<Scalars['String']['output']>;
  employmentCompanyAddressPrefectureId?: Maybe<Scalars['String']['output']>;
  employmentCompanyAddressTown?: Maybe<Scalars['String']['output']>;
  fax: Scalars['String']['output'];
  hp: Scalars['String']['output'];
  importantDate?: Maybe<Scalars['Date']['output']>;
  lengthOfEmployment?: Maybe<Scalars['Int']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  numberOfEmployees?: Maybe<Scalars['Int']['output']>;
  phoneNumber: Scalars['String']['output'];
  prefectureId?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
};

export type ICompany = {
  __typename?: 'ICompany';
  id: Scalars['String']['output'];
};

export type IMonthlySpaceAvailability = {
  __typename?: 'IMonthlySpaceAvailability';
  id: Scalars['String']['output'];
};

export type IProperty = {
  __typename?: 'IProperty';
  id: Scalars['String']['output'];
};

export type IdChange = {
  __typename?: 'IdChange';
  isChange: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['ID']['output']>;
};

export type Image = {
  __typename?: 'Image';
  id?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Images = {
  __typename?: 'Images';
  id?: Maybe<Scalars['String']['output']>;
  storagePath?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ImagesUpdate = {
  id?: InputMaybe<Scalars['ID']['input']>;
  storagePath: Scalars['String']['input'];
};

export type InitialCost = {
  __typename?: 'InitialCost';
  deposit?: Maybe<PaymentInfo>;
  gratuityFee?: Maybe<PaymentInfo>;
};

export type InitialCostInput = {
  deposit: TaxPriceInput;
  gratuityFee: TaxPriceInput;
};

export type InitialFeeDetail = {
  __typename?: 'InitialFeeDetail';
  administrativeFee?: Maybe<Scalars['Float']['output']>;
  applyInitialOtherFee?: Maybe<Array<ApplyInitialOtherFee>>;
  deposit?: Maybe<Scalars['Float']['output']>;
  depositAdminFee?: Maybe<Scalars['Float']['output']>;
  gratuityFee?: Maybe<Scalars['Float']['output']>;
  storeFee?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type InitialOtherFee = {
  __typename?: 'InitialOtherFee';
  cost: PaymentInfo;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type InitialOtherFeeInput = {
  cost: TaxPriceInput;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type InsertedRows = {
  __typename?: 'InsertedRows';
  count?: Maybe<Scalars['Int']['output']>;
};

export type IntChange = {
  __typename?: 'IntChange';
  isChange: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['Int']['output']>;
};

export type KanaGroupMunicipality = {
  __typename?: 'KanaGroupMunicipality';
  items: Array<MunicipalityItem>;
  label: Scalars['String']['output'];
};

export type KanaGroupTown = {
  __typename?: 'KanaGroupTown';
  items: Array<TownItem>;
  label: Scalars['String']['output'];
};

export type LesseeApplicationDocumentDetailResponse = {
  __typename?: 'LesseeApplicationDocumentDetailResponse';
  backOfContractorIdCard?: Maybe<File>;
  cHistoryCertificate?: Maybe<File>;
  contractorIdCard?: Maybe<File>;
  id: Scalars['ID']['output'];
  insuranceCard?: Maybe<File>;
};

export type LesseeApplicationGuaranteeResponse = {
  __typename?: 'LesseeApplicationGuaranteeResponse';
  address: Scalars['String']['output'];
  annualRevenue?: Maybe<Scalars['Int']['output']>;
  backOfCosignerIdCard?: Maybe<File>;
  birthday?: Maybe<Scalars['Date']['output']>;
  capital?: Maybe<Scalars['Int']['output']>;
  cosignerIdCard?: Maybe<File>;
  email: Scalars['String']['output'];
  employmentCompanyAddress: Scalars['String']['output'];
  employmentCompanyAddressMunicipality?: Maybe<Scalars['String']['output']>;
  employmentCompanyAddressPrefectureId?: Maybe<Scalars['String']['output']>;
  employmentCompanyAddressTown?: Maybe<Scalars['String']['output']>;
  employmentCompanyName: Scalars['String']['output'];
  familyRelationship: Scalars['String']['output'];
  fax: Scalars['String']['output'];
  hp: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  importantDate?: Maybe<Scalars['Date']['output']>;
  isGuarantor: Scalars['Boolean']['output'];
  lengthOfEmployment?: Maybe<Scalars['Int']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  numberOfEmployees?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  prefectureId?: Maybe<Scalars['String']['output']>;
  revenue?: Maybe<Scalars['Int']['output']>;
  town?: Maybe<Scalars['String']['output']>;
};

export type LesseeContractDocumentDetailResponse = {
  __typename?: 'LesseeContractDocumentDetailResponse';
  canTransfer?: Maybe<Scalars['Boolean']['output']>;
  cloudsignDocumentId?: Maybe<Scalars['String']['output']>;
  conclusionDate?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  documentStatus?: Maybe<Scalars['Int']['output']>;
  files?: Maybe<Array<Maybe<FileResponse>>>;
  id: Scalars['String']['output'];
  lastProcessedAt?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  receivers?: Maybe<Array<Maybe<ReceiverResponse>>>;
  reportees?: Maybe<Array<Maybe<ReporteeResponse>>>;
  sentAt?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type LesseePropertyConnection = {
  __typename?: 'LesseePropertyConnection';
  edges: Array<LesseePropertyListEdge>;
  pageInfo: PageInfo;
};

export type LesseePropertyDetail = {
  __typename?: 'LesseePropertyDetail';
  address: Scalars['String']['output'];
  controlNumber: Scalars['String']['output'];
  descriptionMetadata: Scalars['String']['output'];
  geocode: Geom;
  geom: Scalars['geom']['output'];
  id: Scalars['ID']['output'];
  images: Array<Maybe<Image>>;
  isPreview: Scalars['Boolean']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  propertyNearby: Array<Maybe<LesseePropertyNearby>>;
  propertyStatusNumber: Scalars['jsonb']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  spaceGroups: Array<Maybe<LesseeSpaceGroup>>;
  supportCarModel?: Maybe<Scalars['String']['output']>;
  visibility: PropertyVisibility;
};

export type LesseePropertyList = {
  __typename?: 'LesseePropertyList';
  address?: Maybe<Scalars['String']['output']>;
  controlNumber?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  geom: Scalars['geom']['output'];
  id: Scalars['ID']['output'];
  isLanditProperty?: Maybe<Scalars['Boolean']['output']>;
  isValidProperty?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  propertyAvailabilityNumber?: Maybe<Scalars['Int']['output']>;
  propertyImages?: Maybe<LesseePropertyListImages>;
  propertyMaxMonthlyRent?: Maybe<Scalars['float']['output']>;
  propertyMaxMonthlyRentIsMax?: Maybe<Scalars['Boolean']['output']>;
  propertyMinMonthlyRent?: Maybe<Scalars['float']['output']>;
  propertyMinMonthlyRentIsMax?: Maybe<Scalars['Boolean']['output']>;
  propertyStatusNumber?: Maybe<Scalars['jsonb']['output']>;
  spaceGroups?: Maybe<Array<Maybe<LesseePropertyListSpaceGroups>>>;
  supportCarModel?: Maybe<Scalars['String']['output']>;
};

export type LesseePropertyListEdge = {
  __typename?: 'LesseePropertyListEdge';
  cursor: Scalars['String']['output'];
  node: LesseePropertyList;
};

export type LesseePropertyListFilter = {
  availableSpaceNumber?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  monthlyRent?: InputMaybe<LesseePropertyListMonthlyRent>;
  search?: InputMaybe<Scalars['String']['input']>;
  startUsageTime?: InputMaybe<Scalars['DateTime']['input']>;
  supportCarModel?: InputMaybe<Scalars['String']['input']>;
};

export type LesseePropertyListImages = {
  __typename?: 'LesseePropertyListImages';
  storagePath?: Maybe<Scalars['String']['output']>;
};

export type LesseePropertyListMonthlyRent = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type LesseePropertyListOrder = {
  propertyAvailabilityNumber?: InputMaybe<Scalars['String']['input']>;
  propertyMonthlyRent?: InputMaybe<Scalars['String']['input']>;
};

export type LesseePropertyListSpaceGroups = {
  __typename?: 'LesseePropertyListSpaceGroups';
  feature: Scalars['jsonb']['output'];
  freeRent: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isAvailabilityPublic?: Maybe<Scalars['Boolean']['output']>;
  minAvailabilityDate?: Maybe<Scalars['Date']['output']>;
  monthlyAdminFee: Scalars['Int']['output'];
  monthlyRent: Fee;
  monthlyRentValue?: Maybe<Scalars['Float']['output']>;
  spaceGroupMonthlyRentIsMax: Scalars['Boolean']['output'];
  spaceGroupStatusNumber?: Maybe<Scalars['jsonb']['output']>;
  supportCarModel?: Maybe<Scalars['String']['output']>;
};

export type LesseePropertyNearby = {
  __typename?: 'LesseePropertyNearby';
  address: Scalars['String']['output'];
  availability: Availability;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  isLanditProperty: Scalars['Boolean']['output'];
  maxCostPerMonth: Scalars['Float']['output'];
  maxSupportCarModel?: Maybe<Scalars['String']['output']>;
  minCostPerMonth: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  spaceGroups?: Maybe<Array<Maybe<SpaceGroupNearbyResponse>>>;
};

export type LesseeSpaceGroup = {
  __typename?: 'LesseeSpaceGroup';
  administrativeFee: Scalars['Int']['output'];
  costPerMonth: Scalars['Float']['output'];
  costRegist: Scalars['Float']['output'];
  dailyRateType: Scalars['Int']['output'];
  deposit: Fee;
  depositAdminFee: Scalars['Int']['output'];
  existingSpaceGroupId: Scalars['String']['output'];
  feature: Scalars['JSON']['output'];
  freeRent: Scalars['Int']['output'];
  gratuityFee: Fee;
  groundHeight?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  images: Array<Maybe<Image>>;
  initialOtherFee?: Maybe<Array<Maybe<InitialOtherFee>>>;
  isAvailabilityPublic: Scalars['Boolean']['output'];
  isFull?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  minAvailabilityDate?: Maybe<Scalars['Date']['output']>;
  monthlyAdminFee: Scalars['Int']['output'];
  monthlyOtherFee?: Maybe<Array<Maybe<MonthlyOtherFee>>>;
  monthlyOtherFeeDescription?: Maybe<Array<Maybe<MonthlyOtherFeeDescription>>>;
  monthlyRent: Fee;
  remarks?: Maybe<Scalars['String']['output']>;
  renewalAddFee: Scalars['Int']['output'];
  renewalAdminFee: Fee;
  renewalFee: Fee;
  spaceGroupMonthlyRentIsMax: Scalars['Boolean']['output'];
  spaces: Array<Maybe<Space>>;
  storeFee: Fee;
  supportCarModel: Scalars['JSON']['output'];
  tireWidth?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
  yearContract: Scalars['Int']['output'];
};

export type LessorApplicationContractorResponse = {
  __typename?: 'LessorApplicationContractorResponse';
  cContractor?: Maybe<CContractorResponse>;
  isCorporate: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type LessorApplicationDocumentInput = {
  backOfContractorIdCard: Scalars['String']['input'];
  cHistoryCertificate?: InputMaybe<Scalars['String']['input']>;
  contractorIdCard: Scalars['String']['input'];
  insuranceCard?: InputMaybe<Scalars['String']['input']>;
};

export type LessorApplicationEditInput = {
  applicationContractorInput: CreateApplicationContractorLessorInput;
  applicationGuaranteeInput: LessorApplicationGuaranteeInput;
  applicationUsageInfoInput: CreateLessorApplicationUsageInfoInput;
  contractType: ContractTypeEnum;
  id: Scalars['ID']['input'];
  propertyId: Scalars['ID']['input'];
  spaceId: Scalars['ID']['input'];
};

export type LessorApplicationEditResponse = {
  __typename?: 'LessorApplicationEditResponse';
  application?: Maybe<ApplicationOfficial>;
  userErrors?: Maybe<Array<Maybe<Errors>>>;
};

export type LessorApplicationGuaranteeInput = {
  annualRevenue?: InputMaybe<Scalars['Int']['input']>;
  backOfCosignerIdCard?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  capital?: InputMaybe<Scalars['Int']['input']>;
  cosignerIdCard?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  employmentCompanyAddressMunicipality?: InputMaybe<Scalars['String']['input']>;
  employmentCompanyAddressPrefectureId?: InputMaybe<Scalars['String']['input']>;
  employmentCompanyAddressTown?: InputMaybe<Scalars['String']['input']>;
  employmentCompanyName?: InputMaybe<Scalars['String']['input']>;
  familyRelationship?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  hp?: InputMaybe<Scalars['String']['input']>;
  importantDate?: InputMaybe<Scalars['String']['input']>;
  isGuarantor: Scalars['Boolean']['input'];
  lengthOfEmployment?: InputMaybe<Scalars['Int']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  prefectureId?: InputMaybe<Scalars['String']['input']>;
  revenue?: InputMaybe<Scalars['Int']['input']>;
  town?: InputMaybe<Scalars['String']['input']>;
};

export type LessorApplicationRegistrationInput = {
  applicationContractorInput: CreateApplicationContractorLessorInput;
  applicationGuaranteeInput: LessorApplicationGuaranteeInput;
  applicationUsageInfoInput: CreateLessorApplicationUsageInfoInput;
  contractType: ContractTypeEnum;
  propertyId: Scalars['ID']['input'];
  spaceId: Scalars['ID']['input'];
};

export type LessorApplicationRegistrationResponse = {
  __typename?: 'LessorApplicationRegistrationResponse';
  application?: Maybe<ApplicationOfficial>;
  userErrors?: Maybe<Array<Maybe<Errors>>>;
};

export type LessorApplicationUsageInfoItem = {
  backOfIdCard: Scalars['String']['input'];
  birthday?: InputMaybe<Scalars['String']['input']>;
  carModel?: InputMaybe<Scalars['String']['input']>;
  certificate: Scalars['String']['input'];
  colorOfCar?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  employmentCompanyAddressMunicipality?: InputMaybe<Scalars['String']['input']>;
  employmentCompanyAddressPrefectureId?: InputMaybe<Scalars['String']['input']>;
  employmentCompanyAddressTown?: InputMaybe<Scalars['String']['input']>;
  employmentCompanyName?: InputMaybe<Scalars['String']['input']>;
  idCard: Scalars['String']['input'];
  municipality?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  numberPlate?: InputMaybe<NumberPlate>;
  phoneNumber: Scalars['String']['input'];
  prefectureId?: InputMaybe<Scalars['String']['input']>;
  relationshipWithContractor?: InputMaybe<Scalars['String']['input']>;
  sizeOfCar?: InputMaybe<SizeOfCar>;
  town?: InputMaybe<Scalars['String']['input']>;
};

export type LessorCompanyConfigDetailResponse = {
  __typename?: 'LessorCompanyConfigDetailResponse';
  companyHp?: Maybe<Scalars['String']['output']>;
  logo: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
};

export type LessorGetDetailResponse = {
  __typename?: 'LessorGetDetailResponse';
  additionalInfo?: Maybe<Scalars['jsonb']['output']>;
  application?: Maybe<ApplicationCustomerResponse>;
  applicationId: Scalars['String']['output'];
  applicationLessorSignatoryInfo?: Maybe<ApplicationLessorSignatoryInfoType>;
  certificateDeliveryAddressFull?: Maybe<Scalars['String']['output']>;
  certificateDeliveryMunicipality?: Maybe<Scalars['String']['output']>;
  certificateDeliveryPrefectureId?: Maybe<Scalars['String']['output']>;
  certificateDeliveryTown?: Maybe<Scalars['String']['output']>;
  contractConfirmationStep?: Maybe<Scalars['Int']['output']>;
  contractPaymentInfo?: Maybe<ContractPaymentInfoResponse>;
  desiredDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  formExpiredAt?: Maybe<Scalars['DateTime']['output']>;
  formSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isDoneFirstPayment: Scalars['Boolean']['output'];
  manualContractStep?: Maybe<Scalars['Int']['output']>;
  needParkingCertificate?: Maybe<Scalars['Boolean']['output']>;
  privacyPolicyAgreed?: Maybe<Scalars['Boolean']['output']>;
  specialTerms?: Maybe<Scalars['String']['output']>;
  step: Scalars['Int']['output'];
};

export type LessorLatestLesseeMessage = {
  __typename?: 'LessorLatestLesseeMessage';
  applicationId: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  hasAttachment: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  sender: Sender;
};

export type LessorPropertyConnection = {
  __typename?: 'LessorPropertyConnection';
  edges: Array<LessorPropertyListEdge>;
  pageInfo: PageInfo;
};

export type LessorPropertyDetailFeature = {
  __typename?: 'LessorPropertyDetailFeature';
  type: Scalars['String']['output'];
};

export type LessorPropertyDetailMonthlyRent = {
  __typename?: 'LessorPropertyDetailMonthlyRent';
  default: DefaultMonthlyRent;
};

export type LessorPropertyDetailOfficer = {
  __typename?: 'LessorPropertyDetailOfficer';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LessorPropertyDetailOrder = {
  availabilityPublic?: InputMaybe<Scalars['String']['input']>;
  emptySpace?: InputMaybe<Scalars['String']['input']>;
  fullSpace?: InputMaybe<Scalars['String']['input']>;
  monthlyRent?: InputMaybe<Scalars['String']['input']>;
  scheduleSpace?: InputMaybe<Scalars['String']['input']>;
  spacePublic?: InputMaybe<Scalars['String']['input']>;
  totalSpace?: InputMaybe<Scalars['String']['input']>;
};

export type LessorPropertyDetailResponse = {
  __typename?: 'LessorPropertyDetailResponse';
  address: Scalars['String']['output'];
  atportLink?: Maybe<Scalars['jsonb']['output']>;
  controlNumber: Scalars['String']['output'];
  geocode: Geom;
  hasGuarantee?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  images: Array<Maybe<Image>>;
  mailingGroup?: Maybe<PropertyMailingGroup>;
  memo?: Maybe<Scalars['String']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  officer: LessorPropertyDetailOfficer;
  prefecture?: Maybe<Prefecture>;
  preview: Preview;
  remarks?: Maybe<Scalars['String']['output']>;
  spaceGroups: Array<Maybe<LessorPropertyDetailSpaceGroups>>;
  town?: Maybe<Scalars['String']['output']>;
  visibility: PropertyVisibility;
};

export type LessorPropertyDetailSpaceGroups = {
  __typename?: 'LessorPropertyDetailSpaceGroups';
  feature: LessorPropertyDetailFeature;
  freeRent: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  initialOtherFee?: Maybe<Array<Maybe<InitialOtherFee>>>;
  isAvailabilityPublic: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  monthlyOtherFee?: Maybe<Array<Maybe<MonthlyOtherFee>>>;
  monthlyRent: LessorPropertyDetailMonthlyRent;
  remarks?: Maybe<Scalars['String']['output']>;
  spaceGroupAvailability: SpaceGroupAvailability;
  supportCarModel: Scalars['String']['output'];
};

export type LessorPropertyList = {
  __typename?: 'LessorPropertyList';
  address?: Maybe<Scalars['String']['output']>;
  availability?: Maybe<PropertyAvailabilitySummary>;
  controlNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  images?: Maybe<LessorPropertyListImage>;
  memo?: Maybe<Scalars['String']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  officer?: Maybe<LessorPropertyListOfficer>;
  prefecture?: Maybe<Prefecture>;
  remarks?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
  visibility: PropertyVisibility;
};

export type LessorPropertyListEdge = {
  __typename?: 'LessorPropertyListEdge';
  cursor: Scalars['String']['output'];
  node: LessorPropertyList;
};

export type LessorPropertyListFilter = {
  order?: InputMaybe<LessorPropertyListOrder>;
  personInCharge?: InputMaybe<Scalars['ID']['input']>;
  registrationPeriod?: InputMaybe<DateRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<PropertyVisibility>;
};

export type LessorPropertyListImage = {
  __typename?: 'LessorPropertyListImage';
  url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LessorPropertyListOfficer = {
  __typename?: 'LessorPropertyListOfficer';
  fullname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type LessorPropertyListOrder = {
  controlNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  officerName?: InputMaybe<Scalars['String']['input']>;
  propertyBookedSpaceNumber?: InputMaybe<Scalars['String']['input']>;
  propertyEmptySpaceNumber?: InputMaybe<Scalars['String']['input']>;
  propertyFullPlanCancelledNumber?: InputMaybe<Scalars['String']['input']>;
  propertyFullPlanEndedNumber?: InputMaybe<Scalars['String']['input']>;
  propertyFullSpaceNumber?: InputMaybe<Scalars['String']['input']>;
  propertyFullTemporaryNumber?: InputMaybe<Scalars['String']['input']>;
  propertyMonthlyRent?: InputMaybe<Scalars['String']['input']>;
  propertyOccupiedSpaceNumber?: InputMaybe<Scalars['String']['input']>;
  propertyTotalSpaceNumber?: InputMaybe<Scalars['String']['input']>;
  visibilityPriority?: InputMaybe<Scalars['String']['input']>;
};

export type LessorSpaceGroupListFilter = {
  order?: InputMaybe<SpaceGroupOrder>;
};

export type LessorSpaceGroupsList = {
  __typename?: 'LessorSpaceGroupsList';
  feature: LessorSpaceGroupsListFeature;
  freeRent: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  initialOtherFee?: Maybe<Array<Maybe<InitialOtherFee>>>;
  isAvailabilityPublic: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  monthlyOtherFee?: Maybe<Array<Maybe<MonthlyOtherFee>>>;
  monthlyRent: LessorSpaceGroupsListMonthlyRent;
  remarks?: Maybe<Scalars['String']['output']>;
  spaceGroupAvailability: SpaceGroupAvailability;
  supportCarModel: Scalars['String']['output'];
};

export type LessorSpaceGroupsListEdge = {
  __typename?: 'LessorSpaceGroupsListEdge';
  cursor: Scalars['String']['output'];
  node: LessorSpaceGroupsList;
};

export type LessorSpaceGroupsListFeature = {
  __typename?: 'LessorSpaceGroupsListFeature';
  type: Scalars['String']['output'];
};

export type LessorSpaceGroupsListMonthlyRent = {
  __typename?: 'LessorSpaceGroupsListMonthlyRent';
  default: DefaultMonthlyRent;
};

export type MailingGroup = {
  __typename?: 'MailingGroup';
  id: Scalars['ID']['output'];
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type MailingGroupDetail = {
  __typename?: 'MailingGroupDetail';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  officerIds: Array<Scalars['ID']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type MailingGroupId = {
  __typename?: 'MailingGroupId';
  id: Scalars['ID']['output'];
};

export type MessageConnection = {
  __typename?: 'MessageConnection';
  edges?: Maybe<Array<Maybe<ApplicationMessageEdge>>>;
  pageInfo: PageInfo;
};

export type MessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
};

export type MessagePayload = {
  __typename?: 'MessagePayload';
  message?: Maybe<ApplicationMessagePayload>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type MessageTemplateRes = {
  __typename?: 'MessageTemplateRes';
  body?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type MessageTemplateResponse = {
  __typename?: 'MessageTemplateResponse';
  id: Scalars['String']['output'];
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type MessageTemplateResponseDto = {
  __typename?: 'MessageTemplateResponseDto';
  body?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export const MessageType = {
  ContractChange: 'CONTRACT_CHANGE',
  Message: 'MESSAGE'
} as const;

export type MessageType = typeof MessageType[keyof typeof MessageType];
export type MonthlyFeeDetail = {
  __typename?: 'MonthlyFeeDetail';
  applyMonthlyOtherFee?: Maybe<Array<ApplyMonthlyOtherFee>>;
  monthlyAdminFee?: Maybe<Scalars['Float']['output']>;
  monthlyRent?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type MonthlyOtherFee = {
  __typename?: 'MonthlyOtherFee';
  applyMonths: Array<Scalars['Int']['output']>;
  cost: PaymentInfo;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type MonthlyOtherFeeDescription = {
  __typename?: 'MonthlyOtherFeeDescription';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  taxDescription?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type MonthlyOtherFeeInput = {
  applyMonths: Array<Scalars['Int']['input']>;
  cost: TaxPriceInput;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type MonthlyRent = {
  __typename?: 'MonthlyRent';
  default?: Maybe<PaymentInfo>;
  monthlyAdminFee?: Maybe<Scalars['Int']['output']>;
};

export type MonthlyRentInput = {
  default: TaxPriceInput;
};

export type MonthlySpaceAvailabilityDeleteResponse = {
  __typename?: 'MonthlySpaceAvailabilityDeleteResponse';
  monthlySpaceAvailability?: Maybe<IMonthlySpaceAvailability>;
  userErrors?: Maybe<Array<Maybe<Errors>>>;
};

export type MonthlySpaceAvailable = {
  __typename?: 'MonthlySpaceAvailable';
  approveCancelDate?: Maybe<Scalars['Date']['output']>;
  terminateDate?: Maybe<Scalars['Date']['output']>;
};

export type MunicipalityDetailResponse = {
  __typename?: 'MunicipalityDetailResponse';
  id: Scalars['ID']['output'];
  kanaName?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  level: AreaLevel;
  long?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  prefecture?: Maybe<AreaPrefectureItem>;
  prefectureId: Scalars['ID']['output'];
  prefectureSlug: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  type: Scalars['Int']['output'];
  urlSlug: Scalars['String']['output'];
};

export type MunicipalityItem = {
  __typename?: 'MunicipalityItem';
  id: Scalars['ID']['output'];
  kanaName?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  level: AreaLevel;
  long?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  prefectureId: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  type: Scalars['Int']['output'];
  urlSlug: Scalars['String']['output'];
};

export type MunicipalityListResponse = {
  __typename?: 'MunicipalityListResponse';
  groupsMunicipalities: Array<KanaGroupMunicipality>;
  prefecture?: Maybe<AreaPrefectureItem>;
  prefectureSlug: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  adminPropertyBulkInsert?: Maybe<AdminPropertyBulkInsertResponse>;
  applicationCancel: ApplicationPayload;
  applicationChange: ApplicationPayload;
  applicationChangeDetect: ApplicationDetectChangeResponse;
  applicationConfirm: ApplicationConfirmResponse;
  /** @deprecated This mutation is no longer used and will be removed in future versions. */
  applicationDocumentUpload: DocumentResponse;
  applicationDraft?: Maybe<ApplicationResponse>;
  applicationFirstVisitSet: Scalars['Date']['output'];
  applicationLock: ApplicationPayload;
  applicationManageDelete: Scalars['Boolean']['output'];
  applicationOfficial?: Maybe<ApplicationResponse>;
  applicationOfficialEdit?: Maybe<ApplicationResponse>;
  applicationRegistrationChange: ApplicationResponse;
  applicationRelatedEdit?: Maybe<ApplicationResponse>;
  applicationReviewDownload: DownloadApplicationReviewResponse;
  applicationSendCancelRequest?: Maybe<ApplicationSendCancelRequestResponse>;
  /** @deprecated This mutation is no longer used and will be removed in future versions. */
  applicationSendMail: ApplicationPayload;
  applicationSpaceChange: ApplicationSpaceResponse;
  applicationStatusUpdateWhenComplete?: Maybe<ApplicationStatusUpdateWhenCompleteResponse>;
  companyFormUpdate: CompanyPayload;
  companySiteUpdate: CompanyConfig;
  completeContractConfirmationStep: CompleteContractConfirmationStepResponse;
  completeRegister: CompleteRegisterResponse;
  contactRequestCreate: CreateContactRequestResponse;
  contractFormBackStep: ContractPaymentResponse;
  createApplicationLessorSignatory?: Maybe<ApplicationLessorSignatoryResponse>;
  createCardSession: CardSessionResponse;
  /** @deprecated This mutation is no longer used and will be removed in future versions. */
  createUser: UserResDto;
  customerChangePassword: CustomerChangePasswordResponse;
  customerForgotPassword: CustomerForgotPasswordResponse;
  customerLogin: CustomerResponse;
  customerLogout: CustomerLogoutResponse;
  customerResetPassword: CustomerResetPasswordResponse;
  deleteApplicationLessorSignatory?: Maybe<Scalars['Boolean']['output']>;
  deleteMailingGroup: DeleteMailingGroupResponse;
  finalizeContractForBankTransfer: ContractPaymentResponse;
  finalizeContractForCreditCard: ContractPaymentResponseCreditCard;
  finalizeManualContractForCreditCard: ContractPaymentResponseCreditCard;
  generateLessorSyncPortSignedUrl: GenerateSignedUrlResponse;
  /** @deprecated This mutation is no longer used and will be removed in future versions. */
  generateManageSignedUrl: GenerateSignedUrlResponse;
  generateSignedUrl: GenerateSignedUrlResponse;
  generateUploadSignedUrl: GenerateSignedPostPolicyResponse;
  generateUploadSignedUrlForImage: GenerateSignedPostPolicyResponse;
  generateUploadSignedUrlForPropertyMaster: GenerateSignedPostPolicyResponse;
  isRequiedChangePasswordUpdate: RequiedChangePasswordUpdateResponse;
  lesseeMessageCreate: MessagePayload;
  lesseeMessageDelete: Payload;
  lesseeMessageRead: Payload;
  lessorApplicationEdit?: Maybe<LessorApplicationEditResponse>;
  lessorApplicationRegistration?: Maybe<LessorApplicationRegistrationResponse>;
  lessorApproveCancelApplication?: Maybe<ApproveCancelApplicationResponse>;
  lessorProxyApplicationEdit?: Maybe<LessorApplicationEditResponse>;
  messageBatchCreate: BulkMessagePayload;
  messageCreate: MessagePayload;
  messageDelete: Payload;
  messageRead: Payload;
  messageTemplateCreate?: Maybe<MessageTemplateResponse>;
  messageTemplateDelete?: Maybe<MessageTemplateResponse>;
  messageTemplateUpdate?: Maybe<MessageTemplateResponse>;
  ownerInquiryCreate: Scalars['Boolean']['output'];
  partialApplicationUpdate: PartialApplicationResponse;
  propertyCreate: PropertyCreateResponse;
  propertyDelete: PropertyDeleteResponse;
  propertyManageCompanyCreate: PropertyManageCompanyCreateResponse;
  propertyManageCompanyDelete: PropertyManageCompanyDeleteResponse;
  propertyManageCompanyOfficerCreate: CreatePropertyManageCompanyOfficerResponse;
  propertyManageCompanyOfficerDelete: PropertyManageCompanyOfficerDeleteResponse;
  propertyManageCompanyOfficerUpdate: PropertyManageCompanyOfficerUpdateResponse;
  propertyManageCompanyUpdate: PropertyManageCompanyUpdateResponse;
  propertyNotify?: Maybe<Scalars['Boolean']['output']>;
  propertyUpdate: PropertyUpdateResponse;
  relatedApplicationStatusUpdateWhenChat?: Maybe<RelatedApplicationStatusUpdateWhenChatResponse>;
  requestContractReview: Scalars['Boolean']['output'];
  requestRegister: RequestRegisterResponse;
  requestSignContract: RequestSignContractResponse;
  saveMailingGroup: SaveMailingGroupResponse;
  saveSignedContractPdfUrl: SaveSignedContractPdfUrlResult;
  spaceDelete: SpaceDeleteResponse;
  spaceGroupCreate: SpaceGroupCreatePayload;
  spaceGroupDelete: DeleteSpaceGroupResponse;
  spaceGroupUpdate: SpaceGroupUpdatePayload;
  spaceUpdate: SpacePayload;
  spaceUsageDelete: MonthlySpaceAvailabilityDeleteResponse;
  submitAgreementPayment: ContractPaymentResponse;
  submitParkingCertificate: ContractPaymentResponse;
  submitPaymentInfo: ContractPaymentResponse;
  syncSignContractTime: SyncSignContractTimeResponse;
  updateApplicationLessorSignatory?: Maybe<ApplicationLessorSignatoryResponse>;
  updateAtPortLink: AtportLinkUpdateResponse;
  updateContract: UpdateContractResult;
  updatePartialProperty: PropertyUpdateResponse;
  updatePartialSpaceGroup: SpaceGroupUpdatePayload;
  /** @deprecated This mutation is no longer used and will be removed in future versions. */
  updatePropertyImage?: Maybe<UpdatePropertyImageResponse>;
  /** @deprecated This mutation is no longer used and will be removed in future versions. */
  updateSpaceImage?: Maybe<UpdateSpaceImageResponse>;
  verifyRegister: VerifyRegisterResponse;
};


export type MutationAdminPropertyBulkInsertArgs = {
  adminPropertyBulkInsert: AdminPropertyBulkInsert;
};


export type MutationApplicationCancelArgs = {
  applicationId: Scalars['ID']['input'];
  applicationStatusCancel: Scalars['Int']['input'];
  cancelMessage: Scalars['String']['input'];
};


export type MutationApplicationChangeArgs = {
  applicationId: Scalars['ID']['input'];
  editMessage: Scalars['String']['input'];
};


export type MutationApplicationChangeDetectArgs = {
  applicationInput: ApplicationInput;
};


export type MutationApplicationConfirmArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApplicationDocumentUploadArgs = {
  applicationId: Scalars['ID']['input'];
  uploadDocumentInput: UploadDocumentInput;
};


export type MutationApplicationDraftArgs = {
  applicationInputDraft: ApplicationInputDraft;
};


export type MutationApplicationFirstVisitSetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApplicationLockArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationApplicationManageDeleteArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationApplicationOfficialArgs = {
  applicationInput: ApplicationInput;
};


export type MutationApplicationOfficialEditArgs = {
  applicationInput: ApplicationInput;
};


export type MutationApplicationRegistrationChangeArgs = {
  applicationInput: ApplicationInput;
};


export type MutationApplicationRelatedEditArgs = {
  applicationInput: ApplicationInput;
  id: Scalars['ID']['input'];
};


export type MutationApplicationReviewDownloadArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationApplicationSendCancelRequestArgs = {
  applicationId: Scalars['ID']['input'];
  requestCancelApplicationInput: RequestCancelApplicationInput;
};


export type MutationApplicationSendMailArgs = {
  applicationId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']>;
};


export type MutationApplicationSpaceChangeArgs = {
  applicationId: Scalars['ID']['input'];
  spaceIds: Array<Scalars['ID']['input']>;
};


export type MutationApplicationStatusUpdateWhenCompleteArgs = {
  applicationId: Scalars['ID']['input'];
  updateApplicationStatus: Scalars['Int']['input'];
};


export type MutationCompanyFormUpdateArgs = {
  companyId: Scalars['ID']['input'];
  formConfig: FormConfigInput;
};


export type MutationCompanySiteUpdateArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  companySite: CompanySiteInput;
};


export type MutationCompleteContractConfirmationStepArgs = {
  contractDetailId: Scalars['ID']['input'];
};


export type MutationCompleteRegisterArgs = {
  completeRegisterInput: CompleteRegisterInput;
};


export type MutationContactRequestCreateArgs = {
  contactRequestCreate: CreateContactRequestInput;
};


export type MutationContractFormBackStepArgs = {
  contractFormBackStepInput: ContractFormBackStepInput;
};


export type MutationCreateApplicationLessorSignatoryArgs = {
  input: CreateApplicationLessorSignatoryInput;
};


export type MutationCreateCardSessionArgs = {
  createCardSessionInput: CreateCardSessionInput;
};


export type MutationCreateUserArgs = {
  user: UserReqDto;
};


export type MutationCustomerChangePasswordArgs = {
  customerChangePasswordInput: CustomerChangePasswordInput;
};


export type MutationCustomerForgotPasswordArgs = {
  customerForgotPasswordInput: CustomerForgotPasswordInput;
};


export type MutationCustomerLoginArgs = {
  customerLoginInput: CustomerLoginInput;
};


export type MutationCustomerResetPasswordArgs = {
  customerResetPasswordInput: CustomerResetPasswordInput;
};


export type MutationDeleteApplicationLessorSignatoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMailingGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFinalizeContractForBankTransferArgs = {
  finalizeContractInput: FinalizeContractInput;
};


export type MutationFinalizeContractForCreditCardArgs = {
  finalizeContractInput: FinalizeContractInput;
};


export type MutationGenerateLessorSyncPortSignedUrlArgs = {
  signedUrlInput: GenerateSignedUrlInput;
};


export type MutationGenerateManageSignedUrlArgs = {
  signedUrlInput: GenerateSignedUrlInput;
};


export type MutationGenerateSignedUrlArgs = {
  applicationId?: InputMaybe<Scalars['ID']['input']>;
  signedUrlInput: GenerateSignedUrlInput;
};


export type MutationGenerateUploadSignedUrlArgs = {
  uploadSignedUrlInput: GenerateUploadSignedUrlInput;
};


export type MutationGenerateUploadSignedUrlForImageArgs = {
  uploadSignedUrlInputDetail: GenerateUploadSignedUrlInputDetail;
};


export type MutationGenerateUploadSignedUrlForPropertyMasterArgs = {
  uploadSignedUrlInput: GenerateUploadSignedUrlForPropertyMasterInputDetail;
};


export type MutationLesseeMessageCreateArgs = {
  applicationId: Scalars['ID']['input'];
  input: MessageInput;
};


export type MutationLesseeMessageDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLesseeMessageReadArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationLessorApplicationEditArgs = {
  lessorApplicationEditInput: LessorApplicationEditInput;
};


export type MutationLessorApplicationRegistrationArgs = {
  lessorApplicationRegistrationInput: LessorApplicationRegistrationInput;
};


export type MutationLessorApproveCancelApplicationArgs = {
  applicationId: Scalars['ID']['input'];
  approveCancelApplicationInput: ApproveCancelApplicationInput;
};


export type MutationLessorProxyApplicationEditArgs = {
  lessorProxyApplicationEditInput: LessorApplicationEditInput;
};


export type MutationMessageBatchCreateArgs = {
  applicationIds: Array<Scalars['ID']['input']>;
  input: MessageInput;
};


export type MutationMessageCreateArgs = {
  applicationId: Scalars['ID']['input'];
  message: MessageInput;
};


export type MutationMessageDeleteArgs = {
  applicationMessageId: Scalars['ID']['input'];
};


export type MutationMessageReadArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationMessageTemplateCreateArgs = {
  messageTemplate: CreateMessageTemplateInput;
};


export type MutationMessageTemplateDeleteArgs = {
  messageTemplate: DeleteMessageTemplateInput;
};


export type MutationMessageTemplateUpdateArgs = {
  messageTemplate: UpdateMessageTemplateInput;
};


export type MutationOwnerInquiryCreateArgs = {
  ownerInquiryCreate: CreateOwnerInquiryInput;
};


export type MutationPartialApplicationUpdateArgs = {
  partialApplicationInput: PartialApplicationInput;
};


export type MutationPropertyCreateArgs = {
  property: CreatePropertyInput;
};


export type MutationPropertyDeleteArgs = {
  propertyId: Scalars['String']['input'];
};


export type MutationPropertyManageCompanyCreateArgs = {
  propertyManageCompany: PropertyManageCompanyCreateInput;
};


export type MutationPropertyManageCompanyDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPropertyManageCompanyOfficerCreateArgs = {
  createPropertyManageCompanyOfficerInput: CreatePropertyManageCompanyOfficerInput;
};


export type MutationPropertyManageCompanyOfficerDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPropertyManageCompanyOfficerUpdateArgs = {
  propertyManageCompanyOfficerId: Scalars['ID']['input'];
  updatePropertyManageCompanyOfficerInput?: InputMaybe<UpdatePropertyManageCompanyOfficerInput>;
};


export type MutationPropertyManageCompanyUpdateArgs = {
  id: Scalars['String']['input'];
  propertyManageCompany: PropertyManageCompanyUpdateInput;
};


export type MutationPropertyNotifyArgs = {
  atportLink: AtportLink;
  propertyId: Scalars['String']['input'];
};


export type MutationPropertyUpdateArgs = {
  property: UpdatePropertyInput;
  propertyId: Scalars['String']['input'];
};


export type MutationRelatedApplicationStatusUpdateWhenChatArgs = {
  originalApplicationId: Scalars['ID']['input'];
  relatedApplicationId: Scalars['ID']['input'];
  updateApplicationStatus: Scalars['Int']['input'];
};


export type MutationRequestContractReviewArgs = {
  requestContractReviewInput: RequestContractReviewInput;
};


export type MutationRequestRegisterArgs = {
  requestRegisterInput: RequestRegisterInput;
};


export type MutationRequestSignContractArgs = {
  contractDetailId: Scalars['String']['input'];
};


export type MutationSaveMailingGroupArgs = {
  input: SaveMailingGroupInput;
};


export type MutationSaveSignedContractPdfUrlArgs = {
  input: SaveSignedContractPdfUrlInput;
};


export type MutationSpaceDeleteArgs = {
  spaceId: Scalars['String']['input'];
};


export type MutationSpaceGroupCreateArgs = {
  propertyId: Scalars['ID']['input'];
  spaceGroup: SpaceGroupInput;
};


export type MutationSpaceGroupDeleteArgs = {
  spaceGroupId: Scalars['ID']['input'];
};


export type MutationSpaceGroupUpdateArgs = {
  spaceGroup: SpaceGroupUpdateInput;
  spaceGroupId: Scalars['ID']['input'];
};


export type MutationSpaceUpdateArgs = {
  spaceGroupId: Scalars['ID']['input'];
  spaces: SpaceInput;
};


export type MutationSpaceUsageDeleteArgs = {
  monthlySpaceAvailabilityId: Scalars['ID']['input'];
};


export type MutationSubmitAgreementPaymentArgs = {
  agreementPaymentInput: AgreementPaymentInput;
};


export type MutationSubmitParkingCertificateArgs = {
  parkingCertificateInput: ParkingCertificateInput;
};


export type MutationSubmitPaymentInfoArgs = {
  paymentInfoInput: PaymentInfoInput;
};


export type MutationSyncSignContractTimeArgs = {
  contractDetailId: Scalars['ID']['input'];
};


export type MutationUpdateApplicationLessorSignatoryArgs = {
  input: UpdateApplicationLessorSignatoryInput;
};


export type MutationUpdateAtPortLinkArgs = {
  atPortLink: UpdateAtportlinkInput;
  propertyId: Scalars['String']['input'];
};


export type MutationUpdateContractArgs = {
  input: UpdateContractInput;
};


export type MutationUpdatePartialPropertyArgs = {
  property: UpdatePartialPropertyInput;
  propertyId: Scalars['String']['input'];
};


export type MutationUpdatePartialSpaceGroupArgs = {
  spaceGroup: UpdatePartialSpaceGroupInput;
  spaceGroupId: Scalars['ID']['input'];
};


export type MutationUpdatePropertyImageArgs = {
  images: Array<PropertyImageInput>;
  propertyId: Scalars['ID']['input'];
};


export type MutationUpdateSpaceImageArgs = {
  images: Array<SpaceImageInput>;
  spaceGroupId: Scalars['ID']['input'];
};


export type MutationVerifyRegisterArgs = {
  verifyRegisterInput: VerifyRegisterInput;
};

export type NumberPlate = {
  furigana?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  regionCord?: InputMaybe<Scalars['String']['input']>;
};

export type NumberPlateType = {
  __typename?: 'NumberPlateType';
  furigana: Scalars['String']['output'];
  number: Scalars['String']['output'];
  region: Scalars['String']['output'];
  regionCord: Scalars['String']['output'];
};

export type NumberPlateTypeChange = {
  __typename?: 'NumberPlateTypeChange';
  furigana: StringChange;
  number: StringChange;
  region: StringChange;
  regionCord: StringChange;
};

export type Officer = {
  __typename?: 'Officer';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OfficerDetail = {
  __typename?: 'OfficerDetail';
  deletedAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  firstNameKana: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  lastNameKana: Scalars['String']['output'];
  propertyManageCompany: PropertyManageCompany;
};

export type OfficerListDetail = {
  __typename?: 'OfficerListDetail';
  deletedAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  firstNameKana: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  lastNameKana: Scalars['String']['output'];
  propertyManageCompany: PropertyManageCompany;
};

export type OfficerMe = {
  __typename?: 'OfficerMe';
  company: OfficerMeCompany;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isRequiredChangePassword: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type OfficerMeCompany = {
  __typename?: 'OfficerMeCompany';
  address: Scalars['String']['output'];
  config: OfficerMeCompanyConfig;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type OfficerMeCompanyConfig = {
  __typename?: 'OfficerMeCompanyConfig';
  isConfiguredSite: Scalars['Boolean']['output'];
};

export const OrderByEnum = {
  Asc: 'ASC',
  Desc: 'DESC'
} as const;

export type OrderByEnum = typeof OrderByEnum[keyof typeof OrderByEnum];
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ParkingCertificateInput = {
  certificateDeliveryMunicipality?: InputMaybe<Scalars['String']['input']>;
  certificateDeliveryPrefectureId?: InputMaybe<Scalars['String']['input']>;
  certificateDeliveryTown?: InputMaybe<Scalars['String']['input']>;
  contractDetailId: Scalars['ID']['input'];
  desiredDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  needParkingCertificate: Scalars['Boolean']['input'];
};

export type ParkingLotInput = {
  address: Scalars['String']['input'];
  spaces: Scalars['String']['input'];
};

export type PartialApplicationInput = {
  applicationId: Scalars['ID']['input'];
  memo?: InputMaybe<Scalars['String']['input']>;
};

export type PartialApplicationResponse = {
  __typename?: 'PartialApplicationResponse';
  applicationId: Scalars['ID']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type PasswordInputSetting = {
  confirmPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type PasswordSettingResponse = {
  __typename?: 'PasswordSettingResponse';
  token: Scalars['String']['output'];
};

export type Payload = {
  __typename?: 'Payload';
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type PaymentInfo = {
  __typename?: 'PaymentInfo';
  isTaxExempt: Scalars['Boolean']['output'];
  value: Scalars['Int']['output'];
};

export type PaymentInfoInput = {
  contractDetailId: Scalars['ID']['input'];
  /** 0: CREDIT_CARD, 1: BANK_TRANSFER */
  paymentMethodType: Scalars['Int']['input'];
};

export type PaymentStatusResponse = {
  __typename?: 'PaymentStatusResponse';
  addCardUrl?: Maybe<Scalars['String']['output']>;
  application?: Maybe<ApplicationContractDetailResponse>;
  contractBillingId?: Maybe<Scalars['ID']['output']>;
  contractBills?: Maybe<Array<Maybe<ContractBillResponse>>>;
  contractPaymentInfo?: Maybe<ContractPaymentInfoResponse>;
  needParkingCertificate?: Maybe<Scalars['Boolean']['output']>;
  /**
   * - CARD_NOT_ADDED (1): The payment card has not been added.
   * - PAYMENT_PENDING (2): Payment is pending and has not been completed yet.
   * - PAYMENT_COMPLETED (3): Payment has been successfully completed.
   */
  status: Scalars['Int']['output'];
};

export type Prefecture = {
  __typename?: 'Prefecture';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Preview = {
  __typename?: 'Preview';
  token?: Maybe<Scalars['String']['output']>;
};

export type Property = {
  __typename?: 'Property';
  address?: Maybe<Scalars['String']['output']>;
  controlNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  images?: Maybe<Array<Maybe<Images>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PropertyApplicationResponse = {
  __typename?: 'PropertyApplicationResponse';
  applicationSpace?: Maybe<Array<Maybe<ApplicationSpaceResponse>>>;
  applicationUsageInfo?: Maybe<Array<Maybe<ApplicationUsageInfoResponse>>>;
  approveCancelAt?: Maybe<Scalars['Date']['output']>;
  approveCancelDate?: Maybe<Scalars['Date']['output']>;
  child?: Maybe<ApplicationRelated>;
  existingApplication: Scalars['Boolean']['output'];
  firstVisitedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  requestCancelAt?: Maybe<Scalars['Date']['output']>;
  requestCancelDate?: Maybe<Scalars['Date']['output']>;
  status: Scalars['String']['output'];
};

/** Property availability from propertyStatusNumberWithoutRemove computed field */
export type PropertyAvailabilitySummary = {
  __typename?: 'PropertyAvailabilitySummary';
  /** Total booked spaces excluding temporary */
  bookedSpace?: Maybe<Scalars['Int']['output']>;
  /** Number of empty/available spaces */
  emptySpace?: Maybe<Scalars['Int']['output']>;
  /** Number of spaces with non-temporary bookings with cancel date >= today */
  fullPlanCancelled?: Maybe<Scalars['Int']['output']>;
  /** Number of spaces with non-temporary bookings with terminate date >= today */
  fullPlanEnded?: Maybe<Scalars['Int']['output']>;
  /** Number of spaces with permanent bookings */
  fullSpace?: Maybe<Scalars['Int']['output']>;
  /** Number of spaces with temporary bookings */
  fullTemporary?: Maybe<Scalars['Int']['output']>;
  /** Total occupied spaces including temporary */
  occupiedSpace?: Maybe<Scalars['Int']['output']>;
  /** Total number of spaces */
  totalSpace?: Maybe<Scalars['Int']['output']>;
};

export type PropertyBaseResponse = {
  __typename?: 'PropertyBaseResponse';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PropertyCreate = {
  __typename?: 'PropertyCreate';
  id?: Maybe<Scalars['String']['output']>;
};

export type PropertyCreateResponse = {
  __typename?: 'PropertyCreateResponse';
  property?: Maybe<PropertyCreate>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type PropertyDeleteResponse = {
  __typename?: 'PropertyDeleteResponse';
  property?: Maybe<IProperty>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type PropertyHasActiveApplicationResponse = {
  __typename?: 'PropertyHasActiveApplicationResponse';
  hasActiveApplication: Scalars['Boolean']['output'];
};

export type PropertyImageInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  storagePath: Scalars['String']['input'];
};

export type PropertyImageResponse = {
  __typename?: 'PropertyImageResponse';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  storagePath: Scalars['String']['output'];
};

export type PropertyInfoResponse = {
  __typename?: 'PropertyInfoResponse';
  address: Scalars['String']['output'];
  application: PropertyApplicationResponse;
  controlNumber: Scalars['String']['output'];
  formConfiguration: Scalars['jsonb']['output'];
  id: Scalars['String']['output'];
  image?: Maybe<File>;
  name: Scalars['String']['output'];
  spaceGroup: LesseeSpaceGroup;
  visibility: PropertyVisibility;
};

export type PropertyInfoResponseBySpaceGroupId = {
  __typename?: 'PropertyInfoResponseBySpaceGroupId';
  address: Scalars['String']['output'];
  controlNumber: Scalars['String']['output'];
  formConfiguration: Scalars['jsonb']['output'];
  id: Scalars['String']['output'];
  image?: Maybe<File>;
  name: Scalars['String']['output'];
  spaceGroup: LesseeSpaceGroup;
  visibility: PropertyVisibility;
};

export type PropertyInput = {
  isLanditProperty?: InputMaybe<Scalars['Boolean']['input']>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
};

export type PropertyMailingGroup = {
  __typename?: 'PropertyMailingGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PropertyManageCompany = {
  __typename?: 'PropertyManageCompany';
  branchName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PropertyManageCompanyConnection = {
  __typename?: 'PropertyManageCompanyConnection';
  edges?: Maybe<Array<Maybe<PropertyManageCompanyListEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PropertyManageCompanyCreateInput = {
  address: Scalars['String']['input'];
  branchName?: InputMaybe<Scalars['String']['input']>;
  closingTime?: InputMaybe<Scalars['String']['input']>;
  defaultContractDocument: Scalars['String']['input'];
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  openingTime?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyManageCompanyCreateResponse = {
  __typename?: 'PropertyManageCompanyCreateResponse';
  address: Scalars['String']['output'];
  branchName?: Maybe<Scalars['String']['output']>;
  closingTime?: Maybe<Scalars['String']['output']>;
  defaultContractDocument?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  openingTime?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type PropertyManageCompanyDeleteResponse = {
  __typename?: 'PropertyManageCompanyDeleteResponse';
  deletedAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type PropertyManageCompanyListEdge = {
  __typename?: 'PropertyManageCompanyListEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CompanyDetailList>;
};

export type PropertyManageCompanyOfficerConnection = {
  __typename?: 'PropertyManageCompanyOfficerConnection';
  edges?: Maybe<Array<Maybe<PropertyManageCompanyOfficerListEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PropertyManageCompanyOfficerDeleteResponse = {
  __typename?: 'PropertyManageCompanyOfficerDeleteResponse';
  deletedAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type PropertyManageCompanyOfficerListEdge = {
  __typename?: 'PropertyManageCompanyOfficerListEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<OfficerListDetail>;
};

export type PropertyManageCompanyOfficerUpdateResponse = {
  __typename?: 'PropertyManageCompanyOfficerUpdateResponse';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  firstNameKana: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  lastNameKana: Scalars['String']['output'];
};

export type PropertyManageCompanyUpdateInput = {
  address: Scalars['String']['input'];
  branchName?: InputMaybe<Scalars['String']['input']>;
  closingTime?: InputMaybe<Scalars['String']['input']>;
  defaultContractDocument?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  openingTime?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyManageCompanyUpdateResponse = {
  __typename?: 'PropertyManageCompanyUpdateResponse';
  address: Scalars['String']['output'];
  branchName?: Maybe<Scalars['String']['output']>;
  closingTime?: Maybe<Scalars['String']['output']>;
  defaultContractDocument?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  openingTime?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type PropertyNameAndActiveAndAllApplicationIdsResponse = {
  __typename?: 'PropertyNameAndActiveAndAllApplicationIdsResponse';
  applicationIds: Array<Scalars['ID']['output']>;
  propertyName: Scalars['String']['output'];
};

export type PropertyUpdate = {
  __typename?: 'PropertyUpdate';
  id?: Maybe<Scalars['String']['output']>;
};

export type PropertyUpdateResponse = {
  __typename?: 'PropertyUpdateResponse';
  property?: Maybe<PropertyUpdate>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type PropertyUsed = {
  __typename?: 'PropertyUsed';
  address: Scalars['String']['output'];
  controlNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images: Array<Maybe<Image>>;
  name: Scalars['String']['output'];
};

export type PropertyUsedImageResponse = {
  __typename?: 'PropertyUsedImageResponse';
  url?: Maybe<Scalars['String']['output']>;
};

export const PropertyVisibility = {
  Limited: 'LIMITED',
  Private: 'PRIVATE',
  Public: 'PUBLIC'
} as const;

export type PropertyVisibility = typeof PropertyVisibility[keyof typeof PropertyVisibility];
export type PublicAreaSitemapEdge = {
  __typename?: 'PublicAreaSitemapEdge';
  cursor: Scalars['String']['output'];
  node: PublicAreaSitemapItem;
};

export type PublicAreaSitemapItem = {
  __typename?: 'PublicAreaSitemapItem';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type PublicAreasForSitemapConnection = {
  __typename?: 'PublicAreasForSitemapConnection';
  edges: Array<PublicAreaSitemapEdge>;
  pageInfo: PageInfo;
};

export type PublicPropertiesForSitemapConnection = {
  __typename?: 'PublicPropertiesForSitemapConnection';
  edges: Array<PublicPropertySitemapEdge>;
  pageInfo: PageInfo;
};

export type PublicPropertySitemapEdge = {
  __typename?: 'PublicPropertySitemapEdge';
  cursor: Scalars['String']['output'];
  node: PublicPropertySitemapItem;
};

export type PublicPropertySitemapItem = {
  __typename?: 'PublicPropertySitemapItem';
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export const PublicTargetFolder = {
  Property: 'PROPERTY',
  SpaceGroup: 'SPACE_GROUP'
} as const;

export type PublicTargetFolder = typeof PublicTargetFolder[keyof typeof PublicTargetFolder];
export type Query = {
  __typename?: 'Query';
  activeContractors: ActiveContractorConnection;
  activePropertiesOfCompany: Array<Maybe<ActivePropertiesOfCompanyResponse>>;
  activeSpacesOfProperty: Array<ActiveSpacesOfPropertyResponse>;
  /** @deprecated This query is no longer used and will be removed in future versions. */
  adminProperties: AdminPropertyConnection;
  /** @deprecated This query is no longer used and will be removed in future versions. */
  adminProperty: AdminPropertyDetailResponse;
  /** @deprecated This query is no longer used and will be removed in future versions. */
  adminSpaceGroup?: Maybe<AdminSpaceGroupDetail>;
  /** @deprecated This query is no longer used and will be removed in future versions. */
  adminSpaceGroups?: Maybe<AdminSpaceGroupListConnection>;
  /** @deprecated This query is no longer used and will be removed in future versions. */
  adminSpaces: AdminSpaceConnection;
  application: ApplicationIncludeOtherFee;
  applicationConfirmGet: ApplicationConfirmGetResponse;
  applicationContractChangeManage: ApplicationContractChange;
  applicationContractorGet?: Maybe<ApplicationContractorGetResponse>;
  applicationDownload: ApplicationDownloadResponse;
  applicationDraftBySpaceGroupId?: Maybe<Scalars['String']['output']>;
  applicationLessorSignatories?: Maybe<Array<Maybe<ApplicationLessorSignatoryResponse>>>;
  applicationLessorSignatory?: Maybe<ApplicationLessorSignatoryResponse>;
  applicationManage: ApplicationManageResponse;
  applicationManageList: Array<Maybe<ApplicationManageItemResponse>>;
  applicationProperty?: Maybe<ApplicationProperty>;
  applicationPropertyInfo?: Maybe<ApplicationPropertyInfoResponse>;
  /** @deprecated This query is no longer used and will be removed in future versions. */
  applicationStatusContract: ApplicationStatusContractResponse;
  applicationStatusReview: ApplicationStatusReviewResponse;
  applicationUsageInfosTemporary: ApplicationUsageInfoTemporary;
  applications: ApplicationConnection;
  areaMunicipalities: MunicipalityListResponse;
  areaPathLevel: AreaPathLevelResponse;
  areaPrefectures: AreaPrefectureListResponse;
  areaTownDetail: TownDetailResponse;
  areaTownDetailByLocation: TownDetailResponse;
  areaTowns: TownListResponse;
  companyConfigDetail: CompanyConfigDetailResponse;
  customerApplications: CustomerApplicationConnection;
  customerContractBillings?: Maybe<Array<ContractBillingItemResponse>>;
  dashboardApplicationStatistics: DashboardApplicationStatisticsResult;
  dashboardBillingStats: DashboardBillingStatsResult;
  dashboardPropertyStatistics: DashboardPropertyStatisticsResult;
  dashboardSpaceStats: DashboardSpaceStatsResponse;
  /** @deprecated This query is no longer used and will be removed in future versions. */
  documentIsExist: Scalars['Boolean']['output'];
  formConfig?: Maybe<CompanyFormConfig>;
  generateAdminSignedUrl: GenerateSignedUrlResponse;
  getContractDetail: ContractDetailResponse;
  getContractDetailManage: GetContractDetailManageResponse;
  getContractDocumentsDetail: ContractDocumentDetailResponse;
  getContractPdfDocument: GetContractPdfDocumentResult;
  getCreditCardPaymentStatus: PaymentStatusResponse;
  getFileCloudSignContract: Scalars['String']['output'];
  /** @deprecated This query is no longer used and will be removed in future versions. */
  getPropertyInfoBySpaceGroupId: PropertyInfoResponseBySpaceGroupId;
  getRentalInformation: RentalInformationResponse;
  /** @deprecated This query is no longer used and will be removed in future versions. */
  lesseeApplicationDocumentDetail: LesseeApplicationDocumentDetailResponse;
  lesseeApplicationGuaranteeDetail?: Maybe<LesseeApplicationGuaranteeResponse>;
  lesseeGetContractDocumentDetail?: Maybe<LesseeContractDocumentDetailResponse>;
  lesseeGetContractPdfDocument: GetContractPdfDocumentResult;
  lesseeGetFileCloudSignContract: Scalars['String']['output'];
  lesseePropertyDetail: LesseePropertyDetail;
  lesseePropertyList: Array<Maybe<AllLesseePropertiesList>>;
  lesseePropertyListWithPaging: LesseePropertyConnection;
  lessorGetContractDetail: LessorGetDetailResponse;
  lessorLatestLesseeMessages: Array<LessorLatestLesseeMessage>;
  lessorRunningScheduleToSlack: Scalars['Boolean']['output'];
  /** @deprecated This query is no longer used and will be removed in future versions. */
  lessorTotalUnreadCount: UnreadCountPayload;
  mailingGroupDetail: MailingGroupDetail;
  mailingGroups: Array<MailingGroup>;
  me: OfficerMe;
  messageTemplate?: Maybe<MessageTemplateResponseDto>;
  messageTemplates?: Maybe<Array<Maybe<MessageTemplateRes>>>;
  messages: MessageConnection;
  messagesManage?: Maybe<MessageConnection>;
  officers: Array<Officer>;
  prefectures: Array<Maybe<Prefecture>>;
  properties: LessorPropertyConnection;
  property: LessorPropertyDetailResponse;
  propertyHasActiveApplication: PropertyHasActiveApplicationResponse;
  propertyInfo: PropertyInfoResponse;
  propertyInfoManage: PropertyInfoResponse;
  propertyManageCompanyDetail: CompanyDetail;
  propertyManageCompanyList?: Maybe<PropertyManageCompanyConnection>;
  propertyManageCompanyOfficerDetail: OfficerDetail;
  propertyManageCompanyOfficerList?: Maybe<PropertyManageCompanyOfficerConnection>;
  /** @deprecated This query is no longer used and will be removed in future versions. */
  propertyName: Scalars['String']['output'];
  propertyNameAndActiveAllApplicationIds: PropertyNameAndActiveAndAllApplicationIdsResponse;
  propertyStatusWithSpaceGroupIsFull: PropertyStatusWithSpaceGroupIsFullResponse;
  publicAreasForSitemap: PublicAreasForSitemapConnection;
  publicPropertiesForSitemap: PublicPropertiesForSitemapConnection;
  salesManagementDetail: SalesManagementDetail;
  salesManagementList: SalesManagementListResponse;
  sayHello: Scalars['String']['output'];
  siteConfig: LessorCompanyConfigDetailResponse;
  space: SpaceDetail;
  spaceGroup?: Maybe<SpaceGroup>;
  spaceGroupByAnyId?: Maybe<SpaceGroup>;
  spaceGroups?: Maybe<SpaceGroupListConnection>;
  spaces: SpaceConnection;
  unreadCount: UnreadCountPayload;
  /** @deprecated This query is no longer used and will be removed in future versions. */
  users: Array<Maybe<UserResDto>>;
  /** @deprecated This query is no longer used and will be removed in future versions. */
  waitingContractRequestList?: Maybe<WaitingContractRequestConnection>;
};


export type QueryActiveContractorsArgs = {
  filter?: InputMaybe<ActiveContractorFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryActiveSpacesOfPropertyArgs = {
  propertyId: Scalars['ID']['input'];
};


export type QueryAdminPropertiesArgs = {
  filter?: InputMaybe<AdminPropertyListInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAdminPropertyArgs = {
  propertyId: Scalars['ID']['input'];
};


export type QueryAdminSpaceGroupArgs = {
  spaceGroupId: Scalars['ID']['input'];
};


export type QueryAdminSpaceGroupsArgs = {
  filter?: InputMaybe<AdminSpaceGroupListFilter>;
  pagination?: InputMaybe<PaginationInput>;
  propertyId: Scalars['ID']['input'];
};


export type QueryAdminSpacesArgs = {
  filter?: InputMaybe<AdminSpaceListFilter>;
  pagination?: InputMaybe<PaginationInput>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
  spaceGroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryApplicationArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryApplicationConfirmGetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApplicationContractChangeManageArgs = {
  applicationId: Scalars['ID']['input'];
  newApplicationRelatedId: Scalars['ID']['input'];
};


export type QueryApplicationContractorGetArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryApplicationDownloadArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryApplicationDraftBySpaceGroupIdArgs = {
  spaceGroupId: Scalars['ID']['input'];
};


export type QueryApplicationLessorSignatoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApplicationManageArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryApplicationPropertyArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryApplicationPropertyInfoArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryApplicationStatusContractArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryApplicationStatusReviewArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryApplicationUsageInfosTemporaryArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryApplicationsArgs = {
  filter?: InputMaybe<ApplicationFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAreaMunicipalitiesArgs = {
  prefectureSlug: Scalars['String']['input'];
};


export type QueryAreaPathLevelArgs = {
  urlPath: Scalars['String']['input'];
};


export type QueryAreaTownDetailArgs = {
  municipalitySlug: Scalars['String']['input'];
  prefectureSlug: Scalars['String']['input'];
  townSlug: Scalars['String']['input'];
};


export type QueryAreaTownDetailByLocationArgs = {
  lat: Scalars['Float']['input'];
  long: Scalars['Float']['input'];
};


export type QueryAreaTownsArgs = {
  municipalitySlug: Scalars['String']['input'];
  prefectureSlug: Scalars['String']['input'];
};


export type QueryCompanyConfigDetailArgs = {
  config: CompanyConfigDetailInput;
};


export type QueryCustomerApplicationsArgs = {
  filter?: InputMaybe<CustomerApplicationFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCustomerContractBillingsArgs = {
  contractDetailId: Scalars['ID']['input'];
};


export type QueryDashboardApplicationStatisticsArgs = {
  statuses?: InputMaybe<Array<InputMaybe<ApplicationStatusEnum>>>;
};


export type QueryDashboardBillingStatsArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  period: DashboardStatsPeriodOption;
};


export type QueryDocumentIsExistArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryGenerateAdminSignedUrlArgs = {
  signedUrlInput: GenerateAdminSignedUrlInput;
};


export type QueryGetContractDetailArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryGetContractDetailManageArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryGetContractDocumentsDetailArgs = {
  contractDocumentId: Scalars['String']['input'];
};


export type QueryGetContractPdfDocumentArgs = {
  contractDetailId: Scalars['String']['input'];
};


export type QueryGetFileCloudSignContractArgs = {
  contractDocumentId: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
};


export type QueryGetPropertyInfoBySpaceGroupIdArgs = {
  spaceGroupId: Scalars['ID']['input'];
};


export type QueryGetRentalInformationArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryLesseeApplicationDocumentDetailArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryLesseeApplicationGuaranteeDetailArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryLesseeGetContractDocumentDetailArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryLesseeGetContractPdfDocumentArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryLesseeGetFileCloudSignContractArgs = {
  applicationId: Scalars['ID']['input'];
  contractDocumentId: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
};


export type QueryLesseePropertyDetailArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLesseePropertyListArgs = {
  filter?: InputMaybe<AllPropertyListFilter>;
};


export type QueryLesseePropertyListWithPagingArgs = {
  filter?: InputMaybe<LesseePropertyListFilter>;
  properties: Array<PropertyInput>;
};


export type QueryLessorGetContractDetailArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryLessorLatestLesseeMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMailingGroupDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMessageTemplateArgs = {
  messageTemplateId: Scalars['String']['input'];
};


export type QueryMessagesArgs = {
  applicationId: Scalars['ID']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMessagesManageArgs = {
  applicationId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryOfficersArgs = {
  mailingGroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPropertiesArgs = {
  filter?: InputMaybe<LessorPropertyListFilter>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPropertyArgs = {
  order?: InputMaybe<LessorPropertyDetailOrder>;
  propertyId: Scalars['ID']['input'];
};


export type QueryPropertyHasActiveApplicationArgs = {
  propertyId: Scalars['ID']['input'];
};


export type QueryPropertyInfoArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryPropertyInfoManageArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryPropertyManageCompanyDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPropertyManageCompanyListArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPropertyManageCompanyOfficerDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPropertyManageCompanyOfficerListArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPropertyNameArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryPropertyNameAndActiveAllApplicationIdsArgs = {
  propertyId: Scalars['ID']['input'];
};


export type QueryPropertyStatusWithSpaceGroupIsFullArgs = {
  propertyId: Scalars['ID']['input'];
  spaceGroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPublicAreasForSitemapArgs = {
  pagination?: InputMaybe<PaginationInput>;
  type: AreaLevel;
};


export type QueryPublicPropertiesForSitemapArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QuerySalesManagementDetailArgs = {
  billingId: Scalars['String']['input'];
};


export type QuerySalesManagementListArgs = {
  filter?: InputMaybe<SalesManagementFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SalesManagementSortInput>;
};


export type QuerySpaceArgs = {
  spaceId: Scalars['ID']['input'];
};


export type QuerySpaceGroupArgs = {
  spaceGroupId: Scalars['ID']['input'];
};


export type QuerySpaceGroupByAnyIdArgs = {
  anyId: Scalars['String']['input'];
  propertyId: Scalars['String']['input'];
};


export type QuerySpaceGroupsArgs = {
  filter?: InputMaybe<LessorSpaceGroupListFilter>;
  pagination?: InputMaybe<PaginationInput>;
  propertyId: Scalars['ID']['input'];
};


export type QuerySpacesArgs = {
  filter?: InputMaybe<SpaceFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
  spaceGroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUnreadCountArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryWaitingContractRequestListArgs = {
  filter?: InputMaybe<WaitingContractRequestFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ReceiverInput = {
  companyNameReceiver: Scalars['String']['input'];
  emailReceiver: Scalars['String']['input'];
  nameReceiver: Scalars['String']['input'];
};

export type ReceiverResponse = {
  __typename?: 'ReceiverResponse';
  accessExpiresAt?: Maybe<Scalars['String']['output']>;
  companyNameReceiver: Scalars['String']['output'];
  emailReceiver: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nameReceiver: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  processedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type RelatedApplicationStatusUpdate = {
  __typename?: 'RelatedApplicationStatusUpdate';
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RelatedApplicationStatusUpdateWhenChatResponse = {
  __typename?: 'RelatedApplicationStatusUpdateWhenChatResponse';
  application?: Maybe<RelatedApplicationStatusUpdate>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type RentalInfoDetailType = {
  __typename?: 'RentalInfoDetailType';
  administrativeFee?: Maybe<Scalars['Int']['output']>;
  deposit?: Maybe<PaymentInfo>;
  depositAdminFee?: Maybe<Scalars['Int']['output']>;
  firstMonthlyRent?: Maybe<Scalars['Int']['output']>;
  gratuityFee?: Maybe<PaymentInfo>;
  monthlyAdminFee?: Maybe<Scalars['Int']['output']>;
  monthlyRent?: Maybe<PaymentInfo>;
  storeFee?: Maybe<PaymentInfo>;
};

export type RentalInformationResponse = {
  __typename?: 'RentalInformationResponse';
  application: ApplicationResponse;
  feeSummary?: Maybe<Scalars['String']['output']>;
  initialOtherFee?: Maybe<Array<Maybe<InitialOtherFee>>>;
  monthlyOtherFeeDescription?: Maybe<Array<Maybe<MonthlyOtherFeeDescription>>>;
  needParkingCertificate: Scalars['Boolean']['output'];
};

export type ReporteeResponse = {
  __typename?: 'ReporteeResponse';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Scalars['String']['output'];
};

export type RequestCancelApplicationInput = {
  requestCancelDate: Scalars['Date']['input'];
};

export type RequestContractReviewInput = {
  contractDetailId: Scalars['ID']['input'];
  lessorSignatoryId: Scalars['ID']['input'];
  specialTerms?: InputMaybe<Scalars['String']['input']>;
};

export type RequestRegisterInput = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  contractMakingId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  propertyId?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  spaceGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type RequestRegisterResponse = {
  __typename?: 'RequestRegisterResponse';
  message: Scalars['String']['output'];
};

export type RequestSignContractResponse = {
  __typename?: 'RequestSignContractResponse';
  confirmAndRequestStampAt: Scalars['String']['output'];
};

export type RequiedChangePasswordUpdateResponse = {
  __typename?: 'RequiedChangePasswordUpdateResponse';
  isSuccess: Scalars['Boolean']['output'];
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type SalesManagementBilling = {
  __typename?: 'SalesManagementBilling';
  amount: Scalars['Float']['output'];
  billingCycleEnd?: Maybe<Scalars['Date']['output']>;
  billingCycleStart?: Maybe<Scalars['Date']['output']>;
  contractorName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  dueDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  itemType: Scalars['Int']['output'];
  paymentMethodType?: Maybe<Scalars['Int']['output']>;
  propertyControlNumber?: Maybe<Scalars['String']['output']>;
  propertyName?: Maybe<Scalars['String']['output']>;
  status: ContractBillingStatusEnum;
  useEndDate?: Maybe<Scalars['Date']['output']>;
  useStartDate?: Maybe<Scalars['Date']['output']>;
};

export type SalesManagementDetail = {
  __typename?: 'SalesManagementDetail';
  amount: Scalars['Float']['output'];
  billingPeriodEnd?: Maybe<Scalars['Date']['output']>;
  billingPeriodStart?: Maybe<Scalars['Date']['output']>;
  contractorName?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['Date']['output'];
  feeDetail?: Maybe<BillingFeeDetail>;
  feeDetailType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemType: Scalars['Int']['output'];
  needParkingCertificate?: Maybe<Scalars['Boolean']['output']>;
  propertyControlNumber?: Maybe<Scalars['String']['output']>;
  propertyName?: Maybe<Scalars['String']['output']>;
  status: ContractBillingStatusEnum;
};

export type SalesManagementFilterInput = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  periodEnd?: InputMaybe<Scalars['String']['input']>;
  periodStart?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<ContractBillingStatusEnum>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type SalesManagementListResponse = {
  __typename?: 'SalesManagementListResponse';
  billings: Array<SalesManagementBilling>;
  currentPage: Scalars['Int']['output'];
  summary: SalesManagementSummary;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SalesManagementSortInput = {
  direction?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
};

export type SalesManagementSummary = {
  __typename?: 'SalesManagementSummary';
  totalAmount: Scalars['Float']['output'];
  totalPaid: Scalars['Float']['output'];
  totalSubrogation: Scalars['Float']['output'];
};

export type SaveMailingGroupInput = {
  mailingGroupId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  officerIds: Array<Scalars['ID']['input']>;
};

export type SaveMailingGroupResponse = {
  __typename?: 'SaveMailingGroupResponse';
  mailingGroup?: Maybe<MailingGroupId>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type SaveSignedContractPdfUrlInput = {
  contractDetailId: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
};

export type SaveSignedContractPdfUrlResult = {
  __typename?: 'SaveSignedContractPdfUrlResult';
  fileUrl: Scalars['String']['output'];
  uploadedAt: Scalars['DateTime']['output'];
};

export type Sender = {
  __typename?: 'Sender';
  name: Scalars['String']['output'];
  specificId: Scalars['ID']['output'];
  type: SenderType;
};

export const SenderType = {
  Lessee: 'LESSEE',
  Lessor: 'LESSOR',
  System: 'SYSTEM'
} as const;

export type SenderType = typeof SenderType[keyof typeof SenderType];
export type SettingFileInput = {
  fileId: Scalars['String']['input'];
  settingWidgetInputs?: InputMaybe<Array<InputMaybe<SettingWidgetInput>>>;
};

export type SettingWidgetInput = {
  fileId: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  participantId: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['Int']['input'];
  widgetId?: InputMaybe<Scalars['String']['input']>;
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export type SignedUploadContractPdfFile = {
  __typename?: 'SignedUploadContractPdfFile';
  fileUrl?: Maybe<Scalars['String']['output']>;
  uploadedAt?: Maybe<Scalars['String']['output']>;
};

export type SizeInput = {
  carWidth?: InputMaybe<Scalars['Int']['input']>;
  groundHeight?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  length?: InputMaybe<Scalars['Int']['input']>;
  tireWidth?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export const SizeOfCar = {
  Bike: 'BIKE',
  CompactCar: 'COMPACT_CAR',
  LargeCar: 'LARGE_CAR',
  LightVehicle: 'LIGHT_VEHICLE',
  MidSizeCar: 'MID_SIZE_CAR',
  None: 'NONE',
  OneBox: 'ONE_BOX',
  Truck: 'TRUCK'
} as const;

export type SizeOfCar = typeof SizeOfCar[keyof typeof SizeOfCar];
export type Space = {
  __typename?: 'Space';
  availableStatus: SpaceAvailableStatusEnum;
  id?: Maybe<Scalars['ID']['output']>;
  minAvailabilityDate?: Maybe<Scalars['Date']['output']>;
  monthlySpaceAvailable: MonthlySpaceAvailable;
  name: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export const SpaceAvailableStatus = {
  Empty: 'EMPTY',
  Full: 'FULL',
  FullPlanCancel: 'FULL_PLAN_CANCEL',
  FullPlanEnd: 'FULL_PLAN_END',
  FullTemporary: 'FULL_TEMPORARY'
} as const;

export type SpaceAvailableStatus = typeof SpaceAvailableStatus[keyof typeof SpaceAvailableStatus];
export const SpaceAvailableStatusEnum = {
  Empty: 'EMPTY',
  Full: 'FULL',
  FullPlanCancel: 'FULL_PLAN_CANCEL',
  FullPlanEnd: 'FULL_PLAN_END',
  FullTemporary: 'FULL_TEMPORARY'
} as const;

export type SpaceAvailableStatusEnum = typeof SpaceAvailableStatusEnum[keyof typeof SpaceAvailableStatusEnum];
export type SpaceConnection = {
  __typename?: 'SpaceConnection';
  edges?: Maybe<Array<Maybe<SpaceEdge>>>;
  pageInfo: PageInfo;
};

export type SpaceDelete = {
  __typename?: 'SpaceDelete';
  id?: Maybe<Scalars['String']['output']>;
};

export type SpaceDeleteResponse = {
  __typename?: 'SpaceDeleteResponse';
  space?: Maybe<SpaceDelete>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type SpaceDetail = {
  __typename?: 'SpaceDetail';
  id?: Maybe<Scalars['String']['output']>;
  isAcceptable: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  spaceAvailableStatus?: Maybe<SpaceAvailableStatus>;
  status?: Maybe<Scalars['Int']['output']>;
  usages?: Maybe<Array<Maybe<SpaceUsage>>>;
};

export type SpaceEdge = {
  __typename?: 'SpaceEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<SpaceEdgeValue>;
};

export type SpaceEdgeValue = {
  __typename?: 'SpaceEdgeValue';
  id?: Maybe<Scalars['String']['output']>;
  isAcceptable: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  spaceAvailableStatus?: Maybe<SpaceAvailableStatus>;
  spaceGroup?: Maybe<SpaceGroupValue>;
  status?: Maybe<Scalars['Int']['output']>;
  usages?: Maybe<Array<Maybe<SpaceUsage>>>;
};

export type SpaceFilterInput = {
  order?: InputMaybe<SpaceOrder>;
};

export type SpaceGroup = {
  __typename?: 'SpaceGroup';
  contract?: Maybe<Contract>;
  contractCost?: Maybe<ContractCost>;
  depositAdminFee?: Maybe<Scalars['Int']['output']>;
  existingSpaceGroupId?: Maybe<Scalars['String']['output']>;
  feature?: Maybe<SpaceGroupFeature>;
  freeRent: Scalars['Int']['output'];
  id?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<Images>>>;
  initialCost?: Maybe<InitialCost>;
  initialOtherFee?: Maybe<Array<Maybe<InitialOtherFee>>>;
  isAvailabilityPublic: Scalars['Boolean']['output'];
  isExistingTransfer?: Maybe<Scalars['Boolean']['output']>;
  isPublic: Scalars['Boolean']['output'];
  lesseeBaseUrl?: Maybe<Scalars['String']['output']>;
  monthlyOtherFee?: Maybe<Array<Maybe<MonthlyOtherFee>>>;
  monthlyRent?: Maybe<MonthlyRent>;
  remarks?: Maybe<Scalars['String']['output']>;
  size?: Maybe<SpaceGroupSize>;
  spaceGroupAvailability?: Maybe<SpaceGroupAvailability>;
  specialTerms?: Maybe<Scalars['String']['output']>;
  supportCarModel?: Maybe<Scalars['String']['output']>;
};

/** Space group availability from spaceGroupStatusNumberWithoutRemove computed field */
export type SpaceGroupAvailability = {
  __typename?: 'SpaceGroupAvailability';
  /** Total booked spaces excluding temporary */
  bookedSpace?: Maybe<Scalars['Int']['output']>;
  /** Number of empty/available spaces */
  emptySpace?: Maybe<Scalars['Int']['output']>;
  /** Number of spaces with non-temporary bookings with cancel date >= today */
  fullPlanCancelled?: Maybe<Scalars['Int']['output']>;
  /** Number of spaces with non-temporary bookings with terminate date >= today */
  fullPlanEnded?: Maybe<Scalars['Int']['output']>;
  /** Number of spaces with permanent bookings */
  fullSpace?: Maybe<Scalars['Int']['output']>;
  /** Number of spaces with temporary bookings */
  fullTemporary?: Maybe<Scalars['Int']['output']>;
  /** Total occupied spaces including temporary */
  occupiedSpace?: Maybe<Scalars['Int']['output']>;
  /** Total number of spaces in the space group */
  totalSpace?: Maybe<Scalars['Int']['output']>;
};

export type SpaceGroupCreate = {
  __typename?: 'SpaceGroupCreate';
  id?: Maybe<Scalars['ID']['output']>;
};

export type SpaceGroupCreatePayload = {
  __typename?: 'SpaceGroupCreatePayload';
  spaceGroup?: Maybe<SpaceGroupCreate>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type SpaceGroupFeature = {
  __typename?: 'SpaceGroupFeature';
  loan?: Maybe<Scalars['String']['output']>;
  pavement?: Maybe<Scalars['String']['output']>;
  roof: Scalars['String']['output'];
  time?: Maybe<FeatureTime>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SpaceGroupInput = {
  contract: ContractInput;
  contractCost: ContractCostInput;
  feature: FeatureInput;
  freeRent: Scalars['Int']['input'];
  images: Array<Scalars['String']['input']>;
  initialCost: InitialCostInput;
  initialOtherFee?: InputMaybe<Array<InitialOtherFeeInput>>;
  isAvailabilityPublic: Scalars['Boolean']['input'];
  isPublic: Scalars['Boolean']['input'];
  monthlyOtherFee?: InputMaybe<Array<MonthlyOtherFeeInput>>;
  monthlyRent: MonthlyRentInput;
  remarks?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<SizeInput>;
  specialTerms?: InputMaybe<Scalars['String']['input']>;
  supportCarModel: Array<SupportCarModel>;
};

export type SpaceGroupIsFull = {
  __typename?: 'SpaceGroupIsFull';
  id: Scalars['ID']['output'];
  isFull: Scalars['Boolean']['output'];
  visibility: PropertyVisibility;
};

export type SpaceGroupListConnection = {
  __typename?: 'SpaceGroupListConnection';
  edges: Array<LessorSpaceGroupsListEdge>;
  pageInfo: PageInfo;
};

export type SpaceGroupNearbyResponse = {
  __typename?: 'SpaceGroupNearbyResponse';
  id: Scalars['String']['output'];
  minAvailabilityDate?: Maybe<Scalars['Date']['output']>;
  monthlyRentValue: Scalars['Float']['output'];
  spaceGroupMonthlyRentIsMax: Scalars['Boolean']['output'];
};

export const SpaceGroupOrder = {
  BookedSpaceNumberAsc: 'BOOKED_SPACE_NUMBER_ASC',
  BookedSpaceNumberDesc: 'BOOKED_SPACE_NUMBER_DESC',
  EmptyNumberAsc: 'EMPTY_NUMBER_ASC',
  EmptyNumberDesc: 'EMPTY_NUMBER_DESC',
  FullPlanCancelledNumberAsc: 'FULL_PLAN_CANCELLED_NUMBER_ASC',
  FullPlanCancelledNumberDesc: 'FULL_PLAN_CANCELLED_NUMBER_DESC',
  FullPlanEndedNumberAsc: 'FULL_PLAN_ENDED_NUMBER_ASC',
  FullPlanEndedNumberDesc: 'FULL_PLAN_ENDED_NUMBER_DESC',
  FullSpaceNumberAsc: 'FULL_SPACE_NUMBER_ASC',
  FullSpaceNumberDesc: 'FULL_SPACE_NUMBER_DESC',
  FullTemporaryNumberAsc: 'FULL_TEMPORARY_NUMBER_ASC',
  FullTemporaryNumberDesc: 'FULL_TEMPORARY_NUMBER_DESC',
  IsAvailabilityPublicAsc: 'IS_AVAILABILITY_PUBLIC_ASC',
  IsAvailabilityPublicDesc: 'IS_AVAILABILITY_PUBLIC_DESC',
  IsPublicAsc: 'IS_PUBLIC_ASC',
  IsPublicDesc: 'IS_PUBLIC_DESC',
  MonthlyRentAsc: 'MONTHLY_RENT_ASC',
  MonthlyRentDesc: 'MONTHLY_RENT_DESC',
  OccupiedSpaceNumberAsc: 'OCCUPIED_SPACE_NUMBER_ASC',
  OccupiedSpaceNumberDesc: 'OCCUPIED_SPACE_NUMBER_DESC',
  TotalNumberAsc: 'TOTAL_NUMBER_ASC',
  TotalNumberDesc: 'TOTAL_NUMBER_DESC'
} as const;

export type SpaceGroupOrder = typeof SpaceGroupOrder[keyof typeof SpaceGroupOrder];
export type SpaceGroupSize = {
  __typename?: 'SpaceGroupSize';
  carWidth?: Maybe<Scalars['Int']['output']>;
  groundHeight?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  tireWidth?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type SpaceGroupUpdate = {
  __typename?: 'SpaceGroupUpdate';
  id?: Maybe<Scalars['ID']['output']>;
};

export type SpaceGroupUpdateInput = {
  contract: ContractInput;
  contractCost: ContractCostInput;
  feature: FeatureInput;
  freeRent: Scalars['Int']['input'];
  images: Array<InputMaybe<ImagesUpdate>>;
  initialCost: InitialCostInput;
  initialOtherFee?: InputMaybe<Array<InitialOtherFeeInput>>;
  isAvailabilityPublic: Scalars['Boolean']['input'];
  isPublic: Scalars['Boolean']['input'];
  monthlyOtherFee?: InputMaybe<Array<MonthlyOtherFeeInput>>;
  monthlyRent: MonthlyRentInput;
  remarks?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<SizeInput>;
  specialTerms?: InputMaybe<Scalars['String']['input']>;
  supportCarModel: Array<SupportCarModel>;
};

export type SpaceGroupUpdatePayload = {
  __typename?: 'SpaceGroupUpdatePayload';
  spaceGroup?: Maybe<SpaceGroupCreate>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type SpaceGroupUsed = {
  __typename?: 'SpaceGroupUsed';
  contractCost: ContractCost;
  id: Scalars['ID']['output'];
  initialCost: InitialCost;
  monthlyRent: MonthlyRent;
  property?: Maybe<PropertyUsed>;
  remarks: Scalars['String']['output'];
  spaceGroupAvailability?: Maybe<SpaceGroupAvailability>;
  spaces?: Maybe<Array<Maybe<SpaceUsed>>>;
  supportCarModel: Scalars['jsonb']['output'];
};

export type SpaceGroupValue = {
  __typename?: 'SpaceGroupValue';
  id?: Maybe<Scalars['String']['output']>;
  initialOtherFee?: Maybe<Array<Maybe<InitialOtherFee>>>;
  monthlyOtherFee?: Maybe<Array<Maybe<MonthlyOtherFee>>>;
  monthlyRent?: Maybe<PaymentInfo>;
  supportCarModel?: Maybe<Scalars['jsonb']['output']>;
};

export type SpaceGroups = {
  __typename?: 'SpaceGroups';
  feature: Scalars['jsonb']['output'];
  freeRent: Scalars['Int']['output'];
  isAvailabilityPublic: Scalars['Boolean']['output'];
  monthlyRentValue?: Maybe<Scalars['Float']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  spaceGroupStatusNumber?: Maybe<Scalars['jsonb']['output']>;
  supportCarModel?: Maybe<LesseePropertyDetail>;
};

export type SpaceImageInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  storagePath: Scalars['String']['input'];
};

export type SpaceImageResponse = {
  __typename?: 'SpaceImageResponse';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  storagePath: Scalars['String']['output'];
};

export type SpaceInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isAcceptable: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  usages?: InputMaybe<Array<SpaceUsageInput>>;
};

export const SpaceOrder = {
  IsAcceptableAsc: 'IS_ACCEPTABLE_ASC',
  IsAcceptableDesc: 'IS_ACCEPTABLE_DESC',
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC',
  StatusAsc: 'STATUS_ASC',
  StatusDesc: 'STATUS_DESC'
} as const;

export type SpaceOrder = typeof SpaceOrder[keyof typeof SpaceOrder];
export type SpacePayload = {
  __typename?: 'SpacePayload';
  space?: Maybe<SpaceUpdate>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type SpaceUpdate = {
  __typename?: 'SpaceUpdate';
  id?: Maybe<Scalars['String']['output']>;
};

export type SpaceUsage = {
  __typename?: 'SpaceUsage';
  approveCancelDate?: Maybe<Scalars['Date']['output']>;
  contractor?: Maybe<Contractor>;
  id?: Maybe<Scalars['String']['output']>;
  isEditable: Scalars['Boolean']['output'];
  terminateDate?: Maybe<Scalars['Date']['output']>;
  useStartDate?: Maybe<Scalars['Date']['output']>;
};

export type SpaceUsageInput = {
  contractor?: InputMaybe<ContractorInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  terminateDate?: InputMaybe<Scalars['Date']['input']>;
  useStartDate: Scalars['Date']['input'];
};

export type SpaceUsed = {
  __typename?: 'SpaceUsed';
  id: Scalars['ID']['output'];
  isAcceptable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export const StatusEnum = {
  Done: 'DONE',
  Waiting: 'WAITING'
} as const;

export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
export type StringChange = {
  __typename?: 'StringChange';
  isChange: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export const SupportCarModel = {
  CompactCar: 'COMPACT_CAR',
  FullSizeCar: 'FULL_SIZE_CAR',
  KCar: 'K_CAR',
  MidSizeCar: 'MID_SIZE_CAR',
  Motorcycle: 'MOTORCYCLE',
  OneBoxCar: 'ONE_BOX_CAR',
  Truck: 'TRUCK'
} as const;

export type SupportCarModel = typeof SupportCarModel[keyof typeof SupportCarModel];
export type SyncSignContractTimeResponse = {
  __typename?: 'SyncSignContractTimeResponse';
  finalConfirmSignContractDocumentAt?: Maybe<Scalars['String']['output']>;
  lesseeSignContractDocumentAt?: Maybe<Scalars['String']['output']>;
  lessorSignContractDocumentAt?: Maybe<Scalars['String']['output']>;
};

export const TargetFolder = {
  Application: 'APPLICATION',
  ApplicationLessorSignatory: 'APPLICATION_LESSOR_SIGNATORY',
  Company: 'COMPANY',
  Property: 'PROPERTY',
  SignedContractDocument: 'SIGNED_CONTRACT_DOCUMENT',
  SpaceGroup: 'SPACE_GROUP'
} as const;

export type TargetFolder = typeof TargetFolder[keyof typeof TargetFolder];
export type TaxPriceInput = {
  isTaxExempt: Scalars['Boolean']['input'];
  value: Scalars['Int']['input'];
};

export type TownDetailResponse = {
  __typename?: 'TownDetailResponse';
  id: Scalars['ID']['output'];
  kanaName?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  level: AreaLevel;
  long?: Maybe<Scalars['Float']['output']>;
  municipality: MunicipalityDetailResponse;
  municipalityId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  type: Scalars['Int']['output'];
  urlSlug: Scalars['String']['output'];
};

export type TownItem = {
  __typename?: 'TownItem';
  id: Scalars['ID']['output'];
  kanaName?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  level: AreaLevel;
  long?: Maybe<Scalars['Float']['output']>;
  municipalityId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  type: Scalars['Int']['output'];
  urlSlug: Scalars['String']['output'];
};

export type TownListResponse = {
  __typename?: 'TownListResponse';
  groupTowns: Array<KanaGroupTown>;
  municipality: MunicipalityDetailResponse;
  prefectureSlug: Scalars['String']['output'];
};

export type UnreadCountPayload = {
  __typename?: 'UnreadCountPayload';
  count: Scalars['Int']['output'];
};

export type UpdateApplicationLessorSignatoryInput = {
  agentCompanyName?: InputMaybe<Scalars['String']['input']>;
  agentMunicipality?: InputMaybe<Scalars['String']['input']>;
  agentName?: InputMaybe<Scalars['String']['input']>;
  agentPrefectureId?: InputMaybe<Scalars['String']['input']>;
  agentTown?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  isLessorJoinContract: Scalars['Boolean']['input'];
  municipality?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  prefectureId?: InputMaybe<Scalars['String']['input']>;
  sealImageUrl?: InputMaybe<Scalars['String']['input']>;
  signatoryCompanyName?: InputMaybe<Scalars['String']['input']>;
  signatoryEmail: Scalars['String']['input'];
  /**
   * signatoryType as integer:
   * 0: HOLDER_STAMP
   * 1: OTHER_STAMP
   */
  signatoryName: Scalars['String']['input'];
  signatoryType: Scalars['Int']['input'];
  town?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAtportlinkInput = {
  isLinked?: InputMaybe<Scalars['Boolean']['input']>;
  requestedCustomerAcquisitionWithinOneWeek?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateContractInput = {
  certificateDeliveryMunicipality?: InputMaybe<Scalars['String']['input']>;
  certificateDeliveryPrefectureId?: InputMaybe<Scalars['String']['input']>;
  certificateDeliveryTown?: InputMaybe<Scalars['String']['input']>;
  contractDetailId: Scalars['ID']['input'];
  desiredDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  lessorSignatoryId: Scalars['ID']['input'];
  needParkingCertificate: Scalars['Boolean']['input'];
  /** 0: CREDIT_CARD, 1: BANK_TRANSFER */
  paymentMethodType: Scalars['Int']['input'];
  specialTerms?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContractResult = {
  __typename?: 'UpdateContractResult';
  additionalInfo?: Maybe<Scalars['jsonb']['output']>;
  applicationId: Scalars['ID']['output'];
  applicationLessorSignatoryInfo?: Maybe<ApplicationLessorSignatoryInfoType>;
  certificateDeliveryAddressFull?: Maybe<Scalars['String']['output']>;
  certificateDeliveryMunicipality?: Maybe<Scalars['String']['output']>;
  certificateDeliveryPrefectureId?: Maybe<Scalars['String']['output']>;
  certificateDeliveryTown?: Maybe<Scalars['String']['output']>;
  contractDetailId: Scalars['ID']['output'];
  desiredDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  needParkingCertificate: Scalars['Boolean']['output'];
  paymentMethodType: Scalars['Int']['output'];
  specialTerms?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type UpdateMessageTemplateInput = {
  body: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type UpdatePartialPropertyInput = {
  memo?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<PropertyVisibility>;
};

export type UpdatePartialSpaceGroupInput = {
  isAvailabilityPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePropertyImageResponse = {
  __typename?: 'UpdatePropertyImageResponse';
  images?: Maybe<Array<Maybe<PropertyImageResponse>>>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type UpdatePropertyImages = {
  id?: InputMaybe<Scalars['ID']['input']>;
  storagePath: Scalars['String']['input'];
};

export type UpdatePropertyInput = {
  geocode: Geocode;
  hasGuarantee?: InputMaybe<Scalars['Boolean']['input']>;
  images?: InputMaybe<Array<InputMaybe<UpdatePropertyImages>>>;
  itemNumber?: InputMaybe<Scalars['String']['input']>;
  mailingGroupId?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  municipality: Scalars['String']['input'];
  name: Scalars['String']['input'];
  personInCharge: Scalars['String']['input'];
  prefectureId: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  town: Scalars['String']['input'];
  visibility?: InputMaybe<PropertyVisibility>;
};

export type UpdatePropertyManageCompanyOfficerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  firstNameKana: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  lastNameKana: Scalars['String']['input'];
};

export type UpdateSpaceImageResponse = {
  __typename?: 'UpdateSpaceImageResponse';
  images?: Maybe<Array<Maybe<SpaceImageResponse>>>;
  userErrors?: Maybe<Array<Maybe<UserErrors>>>;
};

export type UploadDocumentInput = {
  field: DocumentType;
  filename: Scalars['String']['input'];
  storagePath: Scalars['String']['input'];
};

export type UsageInforWorkplace = {
  __typename?: 'UsageInforWorkplace';
  address: Scalars['String']['output'];
  employmentCompanyAddressMunicipality?: Maybe<Scalars['String']['output']>;
  employmentCompanyAddressPrefectureId?: Maybe<Scalars['String']['output']>;
  employmentCompanyAddressTown?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type UserConfig = {
  birthday: Scalars['Boolean']['input'];
  certificate: Scalars['Boolean']['input'];
  employmentCompanyAddress: Scalars['Boolean']['input'];
  employmentCompanyName: Scalars['Boolean']['input'];
  relationship: Scalars['Boolean']['input'];
};

export type UserConfigType = {
  __typename?: 'UserConfigType';
  address: Scalars['Boolean']['output'];
  backOfIdCard: Scalars['Boolean']['output'];
  birthday: Scalars['Boolean']['output'];
  certificate: Scalars['Boolean']['output'];
  email: Scalars['Boolean']['output'];
  employmentCompanyAddress: Scalars['Boolean']['output'];
  employmentCompanyName: Scalars['Boolean']['output'];
  idCard: Scalars['Boolean']['output'];
  name: Scalars['Boolean']['output'];
  phoneNumber: Scalars['Boolean']['output'];
  relationship: Scalars['Boolean']['output'];
};

export type UserErrors = {
  __typename?: 'UserErrors';
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type UserInfo = {
  __typename?: 'UserInfo';
  address: Scalars['String']['output'];
  age: Scalars['Int']['output'];
  backOfIdCard?: Maybe<File>;
  birthday?: Maybe<Scalars['String']['output']>;
  certificate?: Maybe<File>;
  email: Scalars['String']['output'];
  idCard?: Maybe<File>;
  municipality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  prefectureId?: Maybe<Scalars['String']['output']>;
  relationship: Scalars['String']['output'];
  town?: Maybe<Scalars['String']['output']>;
  workplace?: Maybe<UsageInforWorkplace>;
};

export type UserReqDto = {
  email?: InputMaybe<Scalars['String']['input']>;
  officerId?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type UserResDto = {
  __typename?: 'UserResDto';
  authUid: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  officerId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type VerifyRegisterInput = {
  token: Scalars['String']['input'];
};

export type VerifyRegisterResponse = {
  __typename?: 'VerifyRegisterResponse';
  message: Scalars['String']['output'];
};

export type WaitingContractProperty = {
  __typename?: 'WaitingContractProperty';
  propertyControlNumber?: Maybe<Scalars['String']['output']>;
  propertyName?: Maybe<Scalars['String']['output']>;
};

export type WaitingContractPropertySortKey = {
  propertyName?: InputMaybe<OrderByEnum>;
};

export type WaitingContractRequest = {
  __typename?: 'WaitingContractRequest';
  availableSlotsTime: Scalars['String']['output'];
  carModel: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isCorporate: Scalars['Boolean']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  other?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  propertyId: Scalars['String']['output'];
  sizeOfCar: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  useOfCars: Scalars['Int']['output'];
  waitingContractProperty?: Maybe<WaitingContractProperty>;
};

export type WaitingContractRequestConnection = {
  __typename?: 'WaitingContractRequestConnection';
  edges: Array<WaitingContractRequestEdge>;
  pageInfo: PageInfo;
};

export type WaitingContractRequestEdge = {
  __typename?: 'WaitingContractRequestEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<WaitingContractRequest>;
};

export type WaitingContractRequestFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<WaitingContractRequestSortKey>;
  status?: InputMaybe<StatusEnum>;
};

export type WaitingContractRequestPageInfo = {
  __typename?: 'WaitingContractRequestPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type WaitingContractRequestSortKey = {
  availableSlotsTime?: InputMaybe<OrderByEnum>;
  carModel?: InputMaybe<OrderByEnum>;
  companyName?: InputMaybe<OrderByEnum>;
  createdAt?: InputMaybe<OrderByEnum>;
  email?: InputMaybe<OrderByEnum>;
  isCorporate?: InputMaybe<OrderByEnum>;
  memo?: InputMaybe<OrderByEnum>;
  name?: InputMaybe<OrderByEnum>;
  status?: InputMaybe<OrderByEnum>;
  waitingContractProperty?: InputMaybe<WaitingContractPropertySortKey>;
};

export type WidgetResponse = {
  __typename?: 'WidgetResponse';
  fileId?: Maybe<Scalars['String']['output']>;
  h?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  participantId?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  w?: Maybe<Scalars['Int']['output']>;
  widgetType?: Maybe<Scalars['Int']['output']>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type CContractorResponse = {
  __typename?: 'cContractorResponse';
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type PropertyStatusWithSpaceGroupIsFullResponse = {
  __typename?: 'propertyStatusWithSpaceGroupIsFullResponse';
  id: Scalars['ID']['output'];
  spaceGroup?: Maybe<SpaceGroupIsFull>;
  visibility: PropertyVisibility;
};

export type FindApplicationsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<ApplicationFilterInput>;
}>;


export type FindApplicationsQuery = { applications: { __typename?: 'ApplicationConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, totalCount?: number | null }, edges?: Array<{ __typename?: 'ApplicationEdge', node?: { __typename?: 'Application', id: string, numberOfCar: number, status: ApplicationStatusEnum, updatedAt: string, unreadCount?: number | null, spaceGroup: { __typename?: 'SpaceGroupUsed', property?: { __typename?: 'PropertyUsed', id: string, address: string, name: string, controlNumber: string, images: Array<{ __typename?: 'Image', url?: string | null } | null> } | null, spaceGroupAvailability?: { __typename?: 'SpaceGroupAvailability', totalSpace?: number | null, emptySpace?: number | null, fullTemporary?: number | null, fullSpace?: number | null, fullPlanEnded?: number | null, fullPlanCancelled?: number | null, bookedSpace?: number | null, occupiedSpace?: number | null } | null }, applicant: { __typename?: 'Applicant', name: string, company?: { __typename?: 'Company', isCorporate: boolean, name: string } | null }, parent?: { __typename?: 'Application', id: string } | null, child?: { __typename?: 'Application', id: string } | null, duration: { __typename?: 'ApplicationTime', applyAt?: string | null, startAt?: string | null } } | null } | null> | null } };

export type FindApplicationQueryVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type FindApplicationQuery = { application: { __typename?: 'ApplicationIncludeOtherFee', id: string, numberOfCar: number, intendedUse: string, status: ApplicationStatusEnum, updatedAt: string, isEditable: boolean, unreadCount?: number | null, memo?: string | null, type?: ApplicationTypeEnum | null, contractType?: ContractTypeEnum | null, requestCancelDate?: any | null, approveCancelDate?: any | null, approveCancelAt?: any | null, requestCancelAt?: any | null, spaceGroup: { __typename?: 'SpaceGroupUsed', id: string, supportCarModel: any, remarks: string, monthlyRent: { __typename?: 'MonthlyRent', monthlyAdminFee?: number | null, default?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null }, initialCost: { __typename?: 'InitialCost', deposit?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null, gratuityFee?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null }, contractCost: { __typename?: 'ContractCost', administrativeFee?: number | null, depositAdminFee?: number | null, renewalAddFee?: number | null, renewalAdminFee?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null, storeFee?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null, renewalFee?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null }, spaceGroupAvailability?: { __typename?: 'SpaceGroupAvailability', totalSpace?: number | null, emptySpace?: number | null, fullTemporary?: number | null, fullSpace?: number | null, fullPlanEnded?: number | null, fullPlanCancelled?: number | null, bookedSpace?: number | null, occupiedSpace?: number | null } | null, spaces?: Array<{ __typename?: 'SpaceUsed', id: string, name: string, isAcceptable: boolean } | null> | null, property?: { __typename?: 'PropertyUsed', id: string, name: string, address: string, controlNumber: string, images: Array<{ __typename?: 'Image', url?: string | null, id?: string | null } | null> } | null }, applicant: { __typename?: 'Applicant', name: string, company?: { __typename?: 'Company', isCorporate: boolean, name: string, furigana: string, address: string, prefectureId?: string | null, municipality?: string | null, town?: string | null, importantDate?: string | null, revenue?: number | null, numberOfEmployees?: number | null, phoneNumber: string, email: string, content: string, id: string, fax: string, hp: string, personInContact?: { __typename?: 'CompanyContactPerson', name: string, department: string, phoneNumber: string, fax: string, email: string } | null } | null }, guarantor: { __typename?: 'Guarantor', id: string, name: string, isGuarantor: boolean, address: string, prefectureId?: string | null, municipality?: string | null, town?: string | null, employmentCompanyName?: string | null, employmentCompanyAddress?: string | null, employmentCompanyAddressPrefectureId?: string | null, employmentCompanyAddressMunicipality?: string | null, employmentCompanyAddressTown?: string | null, familyRelationship: string, birthday?: string | null, revenue?: number | null, phoneNumber: string, email: string, fax: string, lengthOfEmployment?: number | null, hp?: string | null, capital?: number | null, annualRevenue?: number | null, numberOfEmployees?: number | null, importantDate?: any | null, cosignerIdCard?: { __typename?: 'File', url: string, originUrl?: string | null, createdAt?: string | null, documentType?: number | null, fileName?: string | null, fileType: string } | null, backOfCosignerIdCard?: { __typename?: 'File', url: string, originUrl?: string | null, createdAt?: string | null, documentType?: number | null, fileName?: string | null, fileType: string } | null, workplace?: { __typename?: 'GuarantorWorkPlace', name: string, address: string, prefectureId?: string | null, municipality?: string | null, town?: string | null, employmentCompanyAddressPrefectureId?: string | null, employmentCompanyAddressMunicipality?: string | null, employmentCompanyAddressTown?: string | null, lengthOfEmployment?: number | null, hp: string, capital?: number | null, annualRevenue?: number | null, numberOfEmployees?: number | null, phoneNumber: string, email: string, fax: string, importantDate?: any | null } | null }, duration: { __typename?: 'ApplicationTime', startAt?: string | null, endAt?: string | null, applyAt?: string | null, contractAt?: string | null, reviewSentAt?: string | null, cancellationAt?: string | null }, documents: Array<{ __typename?: 'File', url: string, originUrl?: string | null, createdAt?: string | null, documentType?: number | null, fileName?: string | null, fileType: string }>, carUserInfo: Array<{ __typename?: 'CarUserInfo', id: string, carInfo?: { __typename?: 'CarInfo', number: any, color: string, model: string, type: number } | null, userInfo?: { __typename?: 'UserInfo', name: string, phoneNumber: string, email: string, address: string, prefectureId?: string | null, municipality?: string | null, town?: string | null, relationship: string, birthday?: string | null, age: number, workplace?: { __typename?: 'UsageInforWorkplace', name: string, address: string, employmentCompanyAddressPrefectureId?: string | null, employmentCompanyAddressMunicipality?: string | null, employmentCompanyAddressTown?: string | null } | null, idCard?: { __typename?: 'File', url: string, originUrl?: string | null, createdAt?: string | null, documentType?: number | null, fileName?: string | null, fileType: string } | null, backOfIdCard?: { __typename?: 'File', url: string, originUrl?: string | null, createdAt?: string | null, documentType?: number | null, fileName?: string | null, fileType: string } | null, certificate?: { __typename?: 'File', url: string, originUrl?: string | null, createdAt?: string | null, documentType?: number | null, fileName?: string | null, fileType: string } | null } | null }>, spaces: Array<{ __typename?: 'SpaceUsed', id: string, name: string, isAcceptable: boolean }>, initialOtherFee?: Array<{ __typename?: 'InitialOtherFee', name: string, order: number, cost: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } } | null> | null, monthlyOtherFee?: Array<{ __typename?: 'MonthlyOtherFee', name: string, applyMonths: Array<number>, order: number, cost: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } } | null> | null, property?: { __typename?: 'PropertyBaseResponse', id: string, name: string } | null } };

export type FindApplicationPropertyQueryVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type FindApplicationPropertyQuery = { applicationProperty?: { __typename?: 'ApplicationProperty', spaceGroup?: { __typename?: 'ApplicationSpaceGroup', supportCarModel?: string | null, monthlyRent?: { __typename?: 'MonthlyRent', monthlyAdminFee?: number | null, default?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null } | null, initialCost?: { __typename?: 'InitialCost', deposit?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null, gratuityFee?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null } | null, contractCost?: { __typename?: 'ContractCost', administrativeFee?: number | null, renewalAdminFee?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null, storeFee?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null } | null, availability?: { __typename?: 'ApplicationSpaceGroupAvailability', numberOfFree?: number | null, numberOfFullSpace?: number | null } | null, property?: { __typename?: 'Property', id?: string | null, address?: string | null, name?: string | null, controlNumber?: string | null, images?: Array<{ __typename?: 'Images', storagePath?: string | null, url?: string | null } | null> | null } | null, initialOtherFee?: Array<{ __typename?: 'InitialOtherFee', name: string, order: number, cost: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } } | null> | null, monthlyOtherFee?: Array<{ __typename?: 'MonthlyOtherFee', name: string, order: number, applyMonths: Array<number>, cost: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } } | null> | null } | null } | null };

export type FindApplicationStatusReviewQueryVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type FindApplicationStatusReviewQuery = { applicationStatusReview: { __typename?: 'ApplicationStatusReviewResponse', application?: { __typename?: 'ApplicationStatusReview', reviewSendAt?: any | null, status: string } | null, document?: { __typename?: 'DocumentStatusReview', downloadedAt?: any | null } | null }, applicationProperty?: { __typename?: 'ApplicationProperty', spaceGroup?: { __typename?: 'ApplicationSpaceGroup', property?: { __typename?: 'Property', name?: string | null } | null } | null } | null, applicationDownload: { __typename?: 'ApplicationDownloadResponse', url?: string | null } };

export type FindApplicationDownloadQueryVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type FindApplicationDownloadQuery = { applicationDownload: { __typename?: 'ApplicationDownloadResponse', url?: string | null, filename?: string | null } };

export type UpdateApplicationStatusMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  newStatus: Scalars['Int']['input'];
}>;


export type UpdateApplicationStatusMutation = { applicationStatusUpdateWhenComplete?: { __typename?: 'ApplicationStatusUpdateWhenCompleteResponse', application?: { __typename?: 'ApplicationStatusUpdate', id?: string | null, status?: string | null } | null, userErrors?: Array<{ __typename?: 'UserErrors', message: string, field: string } | null> | null } | null };

export type CancelApplicationMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  cancelMessage: Scalars['String']['input'];
  applicationStatusCancel: Scalars['Int']['input'];
}>;


export type CancelApplicationMutation = { applicationCancel: { __typename?: 'ApplicationPayload', application?: { __typename?: 'ApplicationResponseSuccess', id?: string | null } | null, userErrors?: Array<{ __typename?: 'Errors', field: string, message: string } | null> | null } };

export type RequestChangeApplicationMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  editMessage: Scalars['String']['input'];
}>;


export type RequestChangeApplicationMutation = { applicationChange: { __typename?: 'ApplicationPayload', application?: { __typename?: 'ApplicationResponseSuccess', id?: string | null } | null, userErrors?: Array<{ __typename?: 'Errors', field: string, message: string } | null> | null } };

export type LockApplicationMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type LockApplicationMutation = { applicationLock: { __typename?: 'ApplicationPayload', application?: { __typename?: 'ApplicationResponseSuccess', id?: string | null, status?: string | null } | null, userErrors?: Array<{ __typename?: 'Errors', field: string, message: string } | null> | null } };

export type ChangeApplicationSpacesMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  spaceIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ChangeApplicationSpacesMutation = { applicationSpaceChange: { __typename?: 'ApplicationSpaceResponse', applicationSpace: Array<{ __typename?: 'ApplicationSpace', id: string }>, userErrors?: Array<{ __typename?: 'Errors', field: string, message: string } | null> | null } };

export type FindApplicationOnlineContractQueryVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type FindApplicationOnlineContractQuery = { application: { __typename?: 'ApplicationIncludeOtherFee', contractDocument?: { __typename?: 'BaseContractDocumentResponse', id?: string | null, cloudsignDocumentId?: string | null, documentStatus?: string | null } | null } };

export type FindCustomerApplicationsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<CustomerApplicationFilterInput>;
}>;


export type FindCustomerApplicationsQuery = { customerApplications: { __typename?: 'CustomerApplicationConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, totalCount?: number | null }, edges?: Array<{ __typename?: 'CustomerApplicationEdge', node?: { __typename?: 'CustomerApplication', id: string, numberOfCar: number, status: ApplicationStatusEnum, updatedAt: string, unreadCount?: number | null, memo?: string | null, type?: ApplicationTypeEnum | null, requestCancelDate?: any | null, approveCancelDate?: any | null, approveCancelAt?: any | null, requestCancelAt?: any | null, spaceGroup: { __typename?: 'SpaceGroupUsed', supportCarModel: any, property?: { __typename?: 'PropertyUsed', id: string, address: string, name: string, controlNumber: string, images: Array<{ __typename?: 'Image', url?: string | null } | null> } | null, spaceGroupAvailability?: { __typename?: 'SpaceGroupAvailability', totalSpace?: number | null, emptySpace?: number | null, fullTemporary?: number | null, fullSpace?: number | null, fullPlanEnded?: number | null, fullPlanCancelled?: number | null, bookedSpace?: number | null, occupiedSpace?: number | null } | null }, spaces: Array<{ __typename?: 'CustomerSpace', id: string, name: string }>, applicant: { __typename?: 'Applicant', name: string, company?: { __typename?: 'Company', isCorporate: boolean, name: string } | null }, duration: { __typename?: 'ApplicationTime', applyAt?: string | null, startAt?: string | null }, carUserInfo: Array<{ __typename?: 'CarUserInfo', id: string, carInfo?: { __typename?: 'CarInfo', number: any, color: string, model: string, type: number } | null }>, parent?: { __typename?: 'Application', id: string } | null, child?: { __typename?: 'Application', id: string } | null } | null } | null> | null } };

export type FindWaitingContractQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<WaitingContractRequestFilterInput>;
}>;


export type FindWaitingContractQuery = { waitingContractRequestList?: { __typename?: 'WaitingContractRequestConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, totalCount?: number | null }, edges: Array<{ __typename?: 'WaitingContractRequestEdge', node?: { __typename?: 'WaitingContractRequest', id: string, propertyId: string, availableSlotsTime: string, useOfCars: number, sizeOfCar: number, status: number, carModel: string, other?: string | null, isCorporate: boolean, companyName: string, name: string, phoneNumber: string, email: string, memo?: string | null, createdAt: any, updatedAt: any, waitingContractProperty?: { __typename?: 'WaitingContractProperty', propertyName?: string | null, propertyControlNumber?: string | null } | null } | null }> } | null };

export type ApplicationReviewDownloadMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type ApplicationReviewDownloadMutation = { applicationReviewDownload: { __typename?: 'DownloadApplicationReviewResponse', downloadedAt?: any | null } };

export type LessorTotalUnreadCountQueryVariables = Exact<{ [key: string]: never; }>;


export type LessorTotalUnreadCountQuery = { lessorTotalUnreadCount: { __typename?: 'UnreadCountPayload', count: number } };

export type PartialApplicationUpdateMutationVariables = Exact<{
  partialApplicationInput: PartialApplicationInput;
}>;


export type PartialApplicationUpdateMutation = { partialApplicationUpdate: { __typename?: 'PartialApplicationResponse', applicationId: string, memo?: string | null, updatedAt: any } };

export type CompleteContractConfirmationStepMutationVariables = Exact<{
  contractDetailId: Scalars['ID']['input'];
}>;


export type CompleteContractConfirmationStepMutation = { completeContractConfirmationStep: { __typename?: 'CompleteContractConfirmationStepResponse', id: string, contractConfirmationStep: number, updatedAt: any } };

export type RequestContractReviewMutationVariables = Exact<{
  input: RequestContractReviewInput;
}>;


export type RequestContractReviewMutation = { requestContractReview: boolean };

export type RequestSignContractMutationVariables = Exact<{
  contractDetailId: Scalars['String']['input'];
}>;


export type RequestSignContractMutation = { requestSignContract: { __typename?: 'RequestSignContractResponse', confirmAndRequestStampAt: string } };

export type ApproveCancelApplicationMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  approveCancelApplicationInput: ApproveCancelApplicationInput;
}>;


export type ApproveCancelApplicationMutation = { lessorApproveCancelApplication?: { __typename?: 'ApproveCancelApplicationResponse', application?: { __typename?: 'ApplicationResponseSuccess', id?: string | null, status?: string | null } | null, userErrors?: Array<{ __typename?: 'Errors', field: string, message: string } | null> | null } | null };

export type GetMessagesQueryVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetMessagesQuery = { messages: { __typename?: 'MessageConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, totalCount?: number | null }, edges?: Array<{ __typename?: 'ApplicationMessageEdge', node?: { __typename?: 'ApplicationMessage', id: string, content: string, sendAt: any, isRead: boolean, type: MessageType, bulkMessageId?: string | null, file?: { __typename?: 'File', fileType: string, url: string, originUrl?: string | null } | null, sender: { __typename?: 'Sender', type: SenderType, name: string, specificId: string } } | null } | null> | null } };

export type SendMessageMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  message: MessageInput;
}>;


export type SendMessageMutation = { messageCreate: { __typename?: 'MessagePayload', message?: { __typename?: 'ApplicationMessagePayload', id: string } | null, userErrors?: Array<{ __typename?: 'UserErrors', message: string, field: string } | null> | null } };

export type DeleteMessageMutationVariables = Exact<{
  messageId: Scalars['ID']['input'];
}>;


export type DeleteMessageMutation = { messageDelete: { __typename?: 'Payload', userErrors?: Array<{ __typename?: 'UserErrors', field: string, message: string } | null> | null } };

export type ReadMessageMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type ReadMessageMutation = { messageRead: { __typename?: 'Payload', userErrors?: Array<{ __typename?: 'UserErrors', field: string, message: string } | null> | null } };

export type GetUnreadCountQueryVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type GetUnreadCountQuery = { unreadCount: { __typename?: 'UnreadCountPayload', count: number } };

export type ContractFieldsFragment = { __typename?: 'Contract', years?: number | null, dailyRateType?: number | null };

export type MonthRentFieldsFragment = { __typename?: 'MonthlyRent', monthlyAdminFee?: number | null, default?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null };

export type InitialCostFieldsFragment = { __typename?: 'InitialCost', deposit?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null, gratuityFee?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null };

export type FeatureFieldsFragment = { __typename?: 'Feature', type: string, roof: string, pavement: string, lentItem: string, time: { __typename?: 'FeatureTime', startDate: any, endDate?: any | null } };

export type AvailabilityFieldsFragment = { __typename?: 'Availability', numberOfFree?: number | null, numberOfOccupied?: number | null };

export type PageInfoFieldsFragment = { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, totalCount?: number | null };

export type SpacesUsedFieldsFragment = { __typename?: 'SpaceUsed', id: string, name: string, isAcceptable: boolean };

export type CompanyFieldsFragment = { __typename?: 'Company', isCorporate: boolean, name: string, furigana: string, address: string, content: string, hp: string, importantDate?: string | null, revenue?: number | null, numberOfEmployees?: number | null, phoneNumber: string, email: string, fax: string, id: string, personInContact?: { __typename?: 'CompanyContactPerson', name: string, department: string, phoneNumber: string } | null };

export type GuarantorFieldsFragment = { __typename?: 'Guarantor', name: string, isGuarantor: boolean, address: string, familyRelationship: string, birthday?: string | null, revenue?: number | null, phoneNumber: string, email: string, fax: string, cosignerIdCard?: { __typename?: 'File', url: string, originUrl?: string | null, createdAt?: string | null, documentType?: number | null, fileName?: string | null, fileType: string } | null, workplace?: { __typename?: 'GuarantorWorkPlace', name: string, address: string, lengthOfEmployment?: number | null, hp: string, capital?: number | null, annualRevenue?: number | null, numberOfEmployees?: number | null, phoneNumber: string, email: string, fax: string, importantDate?: any | null } | null };

export type GuarantorWorkPlaceFieldsFragment = { __typename?: 'GuarantorWorkPlace', name: string, address: string, lengthOfEmployment?: number | null, hp: string, capital?: number | null, annualRevenue?: number | null, numberOfEmployees?: number | null, phoneNumber: string, email: string, fax: string, importantDate?: any | null };

export type CarInfoFieldsFragment = { __typename?: 'CarInfo', number: any, type: number, color: string, model: string };

export type UserInfoFieldsFragment = { __typename?: 'UserInfo', name: string, phoneNumber: string, email: string, address: string, relationship: string, birthday?: string | null, age: number, workplace?: { __typename?: 'UsageInforWorkplace', name: string, address: string } | null, idCard?: { __typename?: 'File', url: string, originUrl?: string | null, createdAt?: string | null, documentType?: number | null, fileName?: string | null, fileType: string } | null, certificate?: { __typename?: 'File', url: string, originUrl?: string | null, createdAt?: string | null, documentType?: number | null, fileName?: string | null, fileType: string } | null };

export type FileFieldsFragment = { __typename?: 'File', url: string, originUrl?: string | null, createdAt?: string | null, documentType?: number | null, fileName?: string | null, fileType: string };

export type FindSiteConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type FindSiteConfigQuery = { siteConfig: { __typename?: 'LessorCompanyConfigDetailResponse', siteName: string, companyHp?: string | null, logo: string } };

export type FindFormConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type FindFormConfigQuery = { formConfig?: { __typename?: 'CompanyFormConfig', applicant?: { __typename?: 'ApplicantConfigType', name: boolean, furigana: boolean, address?: boolean | null, businessContent: boolean, hp: boolean, importantDate: boolean, revenue: boolean, numberOfEmployees: boolean, phoneNumber: boolean, email: boolean, fax: boolean, idCard: boolean, backOfIdCard: boolean, historyDoc: boolean, insuranceCard: boolean, contactPerson: { __typename?: 'ContactPersonType', name: boolean, department: boolean, phoneNumber: boolean, email: boolean, fax: boolean } } | null, application?: { __typename?: 'ApplicationConfigType', useStartDate: boolean, intendedUse: boolean, hopeSpaces: boolean } | null, car?: { __typename?: 'CarConfigType', sizeOfCar: boolean, carModel: boolean, numberPlate: boolean, colorOfCar: boolean } | null, user?: { __typename?: 'UserConfigType', name: boolean, address: boolean, relationship: boolean, birthday: boolean, phoneNumber: boolean, email: boolean, employmentCompanyName: boolean, employmentCompanyAddress: boolean, idCard: boolean, certificate: boolean } | null, guarantor?: { __typename?: 'GuarantorConfigType', name: boolean, address: boolean, familyRelationship: boolean, birthday: boolean, revenue: boolean, phoneNumber: boolean, email: boolean, lengthOfEmployment: boolean, fax: boolean, employmentCompanyName: boolean, employmentCompanyAddress: boolean, hp: boolean, importantDate: boolean, capital: boolean, annualRevenue: boolean, numberOfEmployees: boolean, cosignerIdCard: boolean } | null } | null };

export type UpdateFormConfigMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  formConfig: FormConfigInput;
}>;


export type UpdateFormConfigMutation = { companyFormUpdate: { __typename?: 'CompanyPayload', company?: { __typename?: 'ICompany', id: string } | null, userErrors?: Array<{ __typename?: 'Errors', field: string, message: string } | null> | null } };

export type ActivePropertiesOfCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivePropertiesOfCompanyQuery = { activePropertiesOfCompany: Array<{ __typename?: 'ActivePropertiesOfCompanyResponse', id: string, name: string } | null> };

export type ActiveSpacesOfPropertyQueryVariables = Exact<{
  propertyId: Scalars['ID']['input'];
}>;


export type ActiveSpacesOfPropertyQuery = { activeSpacesOfProperty: Array<{ __typename?: 'ActiveSpacesOfPropertyResponse', id: string, name: string, spaceGroupId: string }> };

export type CreateCustomerMutationVariables = Exact<{
  applicationInput: LessorApplicationRegistrationInput;
}>;


export type CreateCustomerMutation = { lessorApplicationRegistration?: { __typename?: 'LessorApplicationRegistrationResponse', application?: { __typename?: 'ApplicationOfficial', id?: string | null, message?: string | null } | null, userErrors?: Array<{ __typename?: 'Errors', field: string, message: string } | null> | null } | null };

export type UpdateCustomerMutationVariables = Exact<{
  applicationInput: LessorApplicationEditInput;
}>;


export type UpdateCustomerMutation = { lessorApplicationEdit?: { __typename?: 'LessorApplicationEditResponse', application?: { __typename?: 'ApplicationOfficial', id?: string | null, message?: string | null } | null, userErrors?: Array<{ __typename?: 'Errors', field: string, message: string } | null> | null } | null };

export type ProxyEditCustomerMutationVariables = Exact<{
  applicationInput: LessorApplicationEditInput;
}>;


export type ProxyEditCustomerMutation = { lessorProxyApplicationEdit?: { __typename?: 'LessorApplicationEditResponse', application?: { __typename?: 'ApplicationOfficial', id?: string | null, message?: string | null } | null, userErrors?: Array<{ __typename?: 'Errors', field: string, message: string } | null> | null } | null };

export type DashboardApplicationStatisticsQueryVariables = Exact<{
  statuses?: InputMaybe<Array<InputMaybe<ApplicationStatusEnum>> | InputMaybe<ApplicationStatusEnum>>;
}>;


export type DashboardApplicationStatisticsQuery = { dashboardApplicationStatistics: { __typename?: 'DashboardApplicationStatisticsResult', statistics: Array<{ __typename?: 'DashboardApplicationStatistic', status: ApplicationStatusEnum, count: number }> } };

export type DashboardPropertyStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardPropertyStatisticsQuery = { dashboardPropertyStatistics: { __typename?: 'DashboardPropertyStatisticsResult', totalPublicProperties: number, totalPrivateProperties: number, emptyProperties: number, fullProperties: number, efficiency: number, present: { __typename?: 'DashboardPropertyStatsPresent', full: number, free: number } } };

export type DashboardSpaceStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardSpaceStatsQuery = { dashboardSpaceStats: { __typename?: 'DashboardSpaceStatsResponse', totalSpacesActive: number, totalSpaceFull: number, totalSpaceTemporary: number, totalSpaceFree: number, totalSpaceInactive: number, efficiency: number, present: { __typename?: 'DashboardSpaceStatsPresent', temporary: number, full: number, free: number } } };

export type LessorLatestLesseeMessagesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LessorLatestLesseeMessagesQuery = { lessorLatestLesseeMessages: Array<{ __typename?: 'LessorLatestLesseeMessage', id: string, createdAt: any, content: string, applicationId: string, hasAttachment: boolean, isRead: boolean, sender: { __typename?: 'Sender', type: SenderType, name: string, specificId: string } }> };

export type DashboardBillingStatsQueryVariables = Exact<{
  period: DashboardStatsPeriodOption;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DashboardBillingStatsQuery = { dashboardBillingStats: { __typename?: 'DashboardBillingStatsResult', period: DashboardStatsPeriodOption, offset: number, totalMonths: number, months: Array<{ __typename?: 'DashboardBillingStatsMonth', month: string, billedAmount: number, paidAmount: number, subrogationAmount: number }> } };

export type FindMeQueryVariables = Exact<{ [key: string]: never; }>;


export type FindMeQuery = { me: { __typename?: 'OfficerMe', id: string, name: string, email: string, isRequiredChangePassword: boolean, company: { __typename?: 'OfficerMeCompany', id: string, name: string, address: string, phoneNumber: string, config: { __typename?: 'OfficerMeCompanyConfig', isConfiguredSite: boolean } } } };

export type FindMessageTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type FindMessageTemplatesQuery = { messageTemplates?: Array<{ __typename?: 'MessageTemplateRes', id?: string | null, title?: string | null, body?: string | null, updatedAt?: string | null } | null> | null };

export type FindMessageTemplateByIdQueryVariables = Exact<{
  messageTemplateId: Scalars['String']['input'];
}>;


export type FindMessageTemplateByIdQuery = { messageTemplate?: { __typename?: 'MessageTemplateResponseDto', id?: string | null, title?: string | null, body?: string | null, updatedAt?: string | null, userErrors?: Array<{ __typename?: 'UserErrors', field: string, message: string } | null> | null } | null };

export type CreateMessageTemplateMutationVariables = Exact<{
  messageTemplate: CreateMessageTemplateInput;
}>;


export type CreateMessageTemplateMutation = { messageTemplateCreate?: { __typename?: 'MessageTemplateResponse', id: string, userErrors?: Array<{ __typename?: 'UserErrors', field: string, message: string } | null> | null } | null };

export type DeleteMessageTemplateMutationVariables = Exact<{
  messageTemplate: DeleteMessageTemplateInput;
}>;


export type DeleteMessageTemplateMutation = { messageTemplateDelete?: { __typename?: 'MessageTemplateResponse', id: string, userErrors?: Array<{ __typename?: 'UserErrors', field: string, message: string } | null> | null } | null };

export type UpdateMessageTemplateMutationVariables = Exact<{
  messageTemplate: UpdateMessageTemplateInput;
}>;


export type UpdateMessageTemplateMutation = { messageTemplateUpdate?: { __typename?: 'MessageTemplateResponse', id: string, userErrors?: Array<{ __typename?: 'UserErrors', field: string, message: string } | null> | null } | null };

export type FindMailingGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindMailingGroupsQuery = { mailingGroups: Array<{ __typename?: 'MailingGroup', id: string, name: string, memberCount: number, updatedAt: string }> };

export type FindMailingGroupDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FindMailingGroupDetailQuery = { mailingGroupDetail: { __typename?: 'MailingGroupDetail', id: string, name: string, officerIds: Array<string>, updatedAt: string } };

export type SaveMailingGroupMutationVariables = Exact<{
  input: SaveMailingGroupInput;
}>;


export type SaveMailingGroupMutation = { saveMailingGroup: { __typename?: 'SaveMailingGroupResponse', mailingGroup?: { __typename?: 'MailingGroupId', id: string } | null, userErrors?: Array<{ __typename?: 'UserErrors', message: string, field: string } | null> | null } };

export type DeleteMailingGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMailingGroupMutation = { deleteMailingGroup: { __typename?: 'DeleteMailingGroupResponse', id: string, userErrors?: Array<{ __typename?: 'UserErrors', message: string, field: string } | null> | null } };

export type FindOnlineContractStatusQueryVariables = Exact<{
  contractDocumentId: Scalars['String']['input'];
}>;


export type FindOnlineContractStatusQuery = { getContractDocumentsDetail: { __typename?: 'ContractDocumentDetailResponse', receivers?: Array<{ __typename?: 'ReceiverResponse', status?: number | null } | null> | null } };

export type GetContractDocumentsDetailQueryVariables = Exact<{
  contractDocumentId: Scalars['String']['input'];
}>;


export type GetContractDocumentsDetailQuery = { getContractDocumentsDetail: { __typename?: 'ContractDocumentDetailResponse', id: string, cloudsignDocumentId?: string | null, documentStatus?: number | null, conclusionDate?: any | null, message?: string | null, title?: string | null, note?: string | null, canTransfer?: boolean | null, isUpdatedContract?: boolean | null, files?: Array<{ __typename?: 'FileResponse', id?: string | null, name?: string | null } | null> | null, receivers?: Array<{ __typename?: 'ReceiverResponse', id: string, nameReceiver: string, emailReceiver: string, companyNameReceiver: string, order?: number | null, status?: number | null, processedAt?: string | null, accessExpiresAt?: string | null } | null> | null } };

export type FindFileCloudSignContractQueryVariables = Exact<{
  contractDocumentId: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
}>;


export type FindFileCloudSignContractQuery = { getFileCloudSignContract: string };

export type LessorGetContractDetailQueryVariables = Exact<{
  applicationId: Scalars['String']['input'];
}>;


export type LessorGetContractDetailQuery = { lessorGetContractDetail: { __typename?: 'LessorGetDetailResponse', id: string, applicationId: string, specialTerms?: string | null, step: number, needParkingCertificate?: boolean | null, desiredDeliveryDate?: any | null, certificateDeliveryAddressFull?: string | null, privacyPolicyAgreed?: boolean | null, certificateDeliveryPrefectureId?: string | null, certificateDeliveryMunicipality?: string | null, certificateDeliveryTown?: string | null, formExpiredAt?: any | null, formSubmittedAt?: any | null, isDoneFirstPayment: boolean, contractConfirmationStep?: number | null, manualContractStep?: number | null, additionalInfo?: any | null, applicationLessorSignatoryInfo?: { __typename?: 'ApplicationLessorSignatoryInfoType', id: string, name: string, email?: string | null, signatory_type?: number | null, signatory_name?: string | null, signatory_email?: string | null } | null, application?: { __typename?: 'ApplicationCustomerResponse', id: string, contractDoneDate?: any | null, email?: string | null, contractDocuments?: Array<{ __typename?: 'ContractDocumentCustomResponse', id: string, conclusionDate?: any | null } | null> | null, applicationProperty?: { __typename?: 'ApplicationPropertyResponse', administrativeFee?: number | null, depositAdminFee?: number | null, propertyName?: string | null, propertyAddress?: string | null, propertyControlNumber?: string | null, deposit?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null, gratuityFee?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null, storeFee?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null } | null, applicationContractor?: { __typename?: 'LessorApplicationContractorResponse', name?: string | null, isCorporate: boolean, cContractor?: { __typename?: 'cContractorResponse', name?: string | null } | null } | null } | null, contractPaymentInfo?: { __typename?: 'ContractPaymentInfoResponse', paymentMethodType?: number | null, creditCardPaymentMethod?: { __typename?: 'CreditCardPaymentMethodResponse', cardHolderName: string, cardLast4: string, cardExpire: string, updatedAt: any } | null } | null } };

export type GetContractPdfDocumentQueryVariables = Exact<{
  contractDetailId: Scalars['String']['input'];
}>;


export type GetContractPdfDocumentQuery = { getContractPdfDocument: { __typename?: 'GetContractPdfDocumentResult', generated?: { __typename?: 'GeneratedContractPdfFile', status?: number | null, fileUrl?: string | null, createdAt?: string | null } | null, signedUpload?: { __typename?: 'SignedUploadContractPdfFile', fileUrl?: string | null, uploadedAt?: string | null } | null } };

export type UpdateContractMutationVariables = Exact<{
  input: UpdateContractInput;
}>;


export type UpdateContractMutation = { updateContract: { __typename?: 'UpdateContractResult', contractDetailId: string, applicationId: string, specialTerms?: string | null, needParkingCertificate: boolean, desiredDeliveryDate?: any | null, certificateDeliveryAddressFull?: string | null, certificateDeliveryPrefectureId?: string | null, certificateDeliveryMunicipality?: string | null, certificateDeliveryTown?: string | null, additionalInfo?: any | null, paymentMethodType: number, updatedAt: any, applicationLessorSignatoryInfo?: { __typename?: 'ApplicationLessorSignatoryInfoType', id: string, name: string, property_manage_company_id: string, prefecture_id?: string | null, municipality?: string | null, town?: string | null, invoice_number?: string | null, seal_image_url?: string | null, email?: string | null, is_lessor_join_contract?: boolean | null, signatory_company_name?: string | null, signatory_type?: number | null, signatory_name?: string | null, signatory_email?: string | null, agent_company_name?: string | null, agent_name?: string | null, agent_prefecture_id?: string | null, agent_municipality?: string | null, agent_town?: string | null } | null } };

export type RequestSaveSignedContractPdfUrlMutationVariables = Exact<{
  input: SaveSignedContractPdfUrlInput;
}>;


export type RequestSaveSignedContractPdfUrlMutation = { saveSignedContractPdfUrl: { __typename?: 'SaveSignedContractPdfUrlResult', fileUrl: string, uploadedAt: any } };

export type SyncSignContractTimeMutationVariables = Exact<{
  contractDetailId: Scalars['ID']['input'];
}>;


export type SyncSignContractTimeMutation = { syncSignContractTime: { __typename?: 'SyncSignContractTimeResponse', lesseeSignContractDocumentAt?: string | null, lessorSignContractDocumentAt?: string | null, finalConfirmSignContractDocumentAt?: string | null } };

export type OwnerInquiryCreateMutationVariables = Exact<{
  ownerInquiryCreate: CreateOwnerInquiryInput;
}>;


export type OwnerInquiryCreateMutation = { ownerInquiryCreate: boolean };

export type FindPropertiesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<LessorPropertyListFilter>;
}>;


export type FindPropertiesQuery = { properties: { __typename?: 'LessorPropertyConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, totalCount?: number | null }, edges: Array<{ __typename?: 'LessorPropertyListEdge', cursor: string, node: { __typename?: 'LessorPropertyList', id?: string | null, name?: string | null, address?: string | null, controlNumber?: string | null, remarks?: string | null, visibility: PropertyVisibility, memo?: string | null, images?: { __typename?: 'LessorPropertyListImage', url?: Array<string | null> | null } | null, availability?: { __typename?: 'PropertyAvailabilitySummary', totalSpace?: number | null, emptySpace?: number | null, fullTemporary?: number | null, fullSpace?: number | null, fullPlanEnded?: number | null, fullPlanCancelled?: number | null, bookedSpace?: number | null, occupiedSpace?: number | null } | null, officer?: { __typename?: 'LessorPropertyListOfficer', id?: string | null, fullname?: string | null } | null } }> } };

export type CreatePropertyMutationVariables = Exact<{
  property: CreatePropertyInput;
}>;


export type CreatePropertyMutation = { propertyCreate: { __typename?: 'PropertyCreateResponse', property?: { __typename?: 'PropertyCreate', id?: string | null } | null, userErrors?: Array<{ __typename?: 'UserErrors', message: string, field: string } | null> | null } };

export type FindPropertyDetailQueryVariables = Exact<{
  propertyId: Scalars['ID']['input'];
  order?: InputMaybe<LessorPropertyDetailOrder>;
}>;


export type FindPropertyDetailQuery = { property: { __typename?: 'LessorPropertyDetailResponse', id: string, address: string, name: string, remarks?: string | null, municipality?: string | null, town?: string | null, controlNumber: string, visibility: PropertyVisibility, memo?: string | null, hasGuarantee?: boolean | null, atportLink?: any | null, images: Array<{ __typename?: 'Image', url?: string | null, id?: string | null } | null>, prefecture?: { __typename?: 'Prefecture', id: string, name: string } | null, officer: { __typename?: 'LessorPropertyDetailOfficer', id: string, name: string }, geocode: { __typename?: 'Geom', latitude: number, longitude: number }, spaceGroups: Array<{ __typename?: 'LessorPropertyDetailSpaceGroups', id: string, remarks?: string | null, supportCarModel: string, isAvailabilityPublic: boolean, monthlyRent: { __typename?: 'LessorPropertyDetailMonthlyRent', default: { __typename?: 'DefaultMonthlyRent', value: number, isTaxExempt: boolean } }, feature: { __typename?: 'LessorPropertyDetailFeature', type: string }, spaceGroupAvailability: { __typename?: 'SpaceGroupAvailability', totalSpace?: number | null, emptySpace?: number | null, fullTemporary?: number | null, fullSpace?: number | null, fullPlanEnded?: number | null, fullPlanCancelled?: number | null, bookedSpace?: number | null, occupiedSpace?: number | null } } | null>, mailingGroup?: { __typename?: 'PropertyMailingGroup', id: string, name: string } | null } };

export type FindPreviewPropertyQueryVariables = Exact<{
  propertyId: Scalars['ID']['input'];
}>;


export type FindPreviewPropertyQuery = { property: { __typename?: 'LessorPropertyDetailResponse', id: string, preview: { __typename?: 'Preview', token?: string | null } } };

export type UpdatePropertyMutationVariables = Exact<{
  property: UpdatePropertyInput;
  propertyId: Scalars['String']['input'];
}>;


export type UpdatePropertyMutation = { propertyUpdate: { __typename?: 'PropertyUpdateResponse', property?: { __typename?: 'PropertyUpdate', id?: string | null } | null, userErrors?: Array<{ __typename?: 'UserErrors', message: string, field: string } | null> | null } };

export type DeletePropertyMutationVariables = Exact<{
  propertyId: Scalars['String']['input'];
}>;


export type DeletePropertyMutation = { propertyDelete: { __typename?: 'PropertyDeleteResponse', property?: { __typename?: 'IProperty', id: string } | null, userErrors?: Array<{ __typename?: 'UserErrors', message: string, field: string } | null> | null } };

export type CreateSpaceGroupMutationVariables = Exact<{
  propertyId: Scalars['ID']['input'];
  spaceGroup: SpaceGroupInput;
}>;


export type CreateSpaceGroupMutation = { spaceGroupCreate: { __typename?: 'SpaceGroupCreatePayload', spaceGroup?: { __typename?: 'SpaceGroupCreate', id?: string | null } | null, userErrors?: Array<{ __typename?: 'UserErrors', message: string, field: string } | null> | null } };

export type UpdateAtPortLinkMutationVariables = Exact<{
  propertyId: Scalars['String']['input'];
  atPortLink: UpdateAtportlinkInput;
}>;


export type UpdateAtPortLinkMutation = { updateAtPortLink: { __typename?: 'AtportLinkUpdateResponse', property?: { __typename?: 'IProperty', id: string } | null, userErrors?: Array<{ __typename?: 'UserErrors', message: string, field: string } | null> | null } };

export type NotifyAtPortLinkMutationVariables = Exact<{
  propertyId: Scalars['String']['input'];
  atPortLink: AtportLink;
}>;


export type NotifyAtPortLinkMutation = { propertyNotify?: boolean | null };

export type UpdatePartialPropertyMutationVariables = Exact<{
  propertyId: Scalars['String']['input'];
  property: UpdatePartialPropertyInput;
}>;


export type UpdatePartialPropertyMutation = { updatePartialProperty: { __typename?: 'PropertyUpdateResponse', property?: { __typename?: 'PropertyUpdate', id?: string | null } | null, userErrors?: Array<{ __typename?: 'UserErrors', message: string, field: string } | null> | null } };

export type GetPrefectureDropdownQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPrefectureDropdownQuery = { prefectures: Array<{ __typename?: 'Prefecture', id: string, name: string } | null> };

export type PropertyHasActiveApplicationQueryVariables = Exact<{
  propertyId: Scalars['ID']['input'];
}>;


export type PropertyHasActiveApplicationQuery = { propertyHasActiveApplication: { __typename?: 'PropertyHasActiveApplicationResponse', hasActiveApplication: boolean } };

export type ActiveContractorsQueryVariables = Exact<{
  pagination: PaginationInput;
  filter: ActiveContractorFilterInput;
}>;


export type ActiveContractorsQuery = { activeContractors: { __typename?: 'ActiveContractorConnection', edges?: Array<{ __typename?: 'ActiveContractorEdge', cursor: string, node?: { __typename?: 'ActiveContractor', applicationId: string, spaceName: string, isCorporate: string, contractorName: string, carModel?: string | null, useStartDate?: any | null, totalMonthlyRent: number, supportCarModel: string } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean, totalCount?: number | null } } };

export type PropertyNameAndActiveAllApplicationIdsQueryVariables = Exact<{
  propertyId: Scalars['ID']['input'];
}>;


export type PropertyNameAndActiveAllApplicationIdsQuery = { propertyNameAndActiveAllApplicationIds: { __typename?: 'PropertyNameAndActiveAndAllApplicationIdsResponse', propertyName: string, applicationIds: Array<string> } };

export type MessageBatchCreateMutationVariables = Exact<{
  applicationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: MessageInput;
}>;


export type MessageBatchCreateMutation = { messageBatchCreate: { __typename?: 'BulkMessagePayload', message?: { __typename?: 'ApplicationBulkMessagePayload', bulkMessageId: string, content: Array<string> } | null, userErrors?: Array<{ __typename?: 'UserErrors', field: string, message: string } | null> | null } };

export type GetRentalInformationQueryVariables = Exact<{
  applicationId: Scalars['String']['input'];
}>;


export type GetRentalInformationQuery = { getRentalInformation: { __typename?: 'RentalInformationResponse', needParkingCertificate: boolean, feeSummary?: string | null, application: { __typename?: 'ApplicationResponse', status: number, useStartDate?: any | null, application?: { __typename?: 'ApplicationOfficial', id?: string | null, message?: string | null } | null, userErrors?: Array<{ __typename?: 'Errors', field: string, message: string } | null> | null } } };

export type FindSalesManagementListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SalesManagementFilterInput>;
  sort?: InputMaybe<SalesManagementSortInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FindSalesManagementListQuery = { salesManagementList: { __typename?: 'SalesManagementListResponse', totalCount: number, totalPages: number, currentPage: number, billings: Array<{ __typename?: 'SalesManagementBilling', id: string, createdAt: any, status: ContractBillingStatusEnum, itemType: number, billingCycleStart?: any | null, billingCycleEnd?: any | null, amount: number, dueDate: any, contractorName?: string | null, propertyName?: string | null, propertyControlNumber?: string | null, paymentMethodType?: number | null, useStartDate?: any | null, useEndDate?: any | null }>, summary: { __typename?: 'SalesManagementSummary', totalAmount: number, totalPaid: number, totalSubrogation: number } } };

export type FindSalesManagementDetailQueryVariables = Exact<{
  billingId: Scalars['String']['input'];
}>;


export type FindSalesManagementDetailQuery = { salesManagementDetail: { __typename?: 'SalesManagementDetail', id: string, status: ContractBillingStatusEnum, itemType: number, amount: number, dueDate: any, contractorName?: string | null, propertyName?: string | null, propertyControlNumber?: string | null, billingPeriodStart?: any | null, billingPeriodEnd?: any | null, feeDetailType?: string | null, needParkingCertificate?: boolean | null, feeDetail?: { __typename?: 'BillingFeeDetail', initial?: Array<{ __typename?: 'InitialFeeDetail', type?: number | null, deposit?: number | null, gratuityFee?: number | null, administrativeFee?: number | null, depositAdminFee?: number | null, storeFee?: number | null, totalAmount?: number | null, applyInitialOtherFee?: Array<{ __typename?: 'ApplyInitialOtherFee', name: string, value: number }> | null }> | null, monthly?: Array<{ __typename?: 'MonthlyFeeDetail', type?: number | null, monthlyRent?: number | null, monthlyAdminFee?: number | null, totalAmount?: number | null, applyMonthlyOtherFee?: Array<{ __typename?: 'ApplyMonthlyOtherFee', name: string, value: number, applyMonths?: Array<number> | null }> | null }> | null } | null } };

export type GetApplicationLessorSignatoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApplicationLessorSignatoriesQuery = { applicationLessorSignatories?: Array<{ __typename?: 'ApplicationLessorSignatoryResponse', id: string, name: string, prefectureId?: string | null, propertyManageCompanyId?: string | null, municipality?: string | null, town?: string | null, invoiceNumber?: string | null, sealImageUrl?: string | null, isLessorJoinContract: boolean, email: string, signatoryType: number, signatoryName: string, signatoryEmail: string, agentName?: string | null } | null> | null };

export type GetApplicationLessorSignatoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetApplicationLessorSignatoryQuery = { applicationLessorSignatory?: { __typename?: 'ApplicationLessorSignatoryResponse', id: string, name: string, prefectureId?: string | null, propertyManageCompanyId?: string | null, municipality?: string | null, town?: string | null, invoiceNumber?: string | null, sealImageUrl?: string | null, isLessorJoinContract: boolean, email: string, signatoryCompanyName?: string | null, signatoryType: number, signatoryName: string, signatoryEmail: string, agentCompanyName?: string | null, agentName?: string | null, agentPrefectureId?: string | null, agentMunicipality?: string | null, agentTown?: string | null } | null };

export type CreateApplicationLessorSignatoryMutationVariables = Exact<{
  input: CreateApplicationLessorSignatoryInput;
}>;


export type CreateApplicationLessorSignatoryMutation = { createApplicationLessorSignatory?: { __typename?: 'ApplicationLessorSignatoryResponse', id: string, name: string, prefectureId?: string | null, propertyManageCompanyId?: string | null, municipality?: string | null, town?: string | null, invoiceNumber?: string | null, sealImageUrl?: string | null, signatoryCompanyName?: string | null, signatoryType: number, signatoryName: string, signatoryEmail: string, agentCompanyName?: string | null, agentName?: string | null, agentPrefectureId?: string | null, agentMunicipality?: string | null, agentTown?: string | null } | null };

export type UpdateApplicationLessorSignatoryMutationVariables = Exact<{
  input: UpdateApplicationLessorSignatoryInput;
}>;


export type UpdateApplicationLessorSignatoryMutation = { updateApplicationLessorSignatory?: { __typename?: 'ApplicationLessorSignatoryResponse', id: string, name: string, prefectureId?: string | null, propertyManageCompanyId?: string | null, municipality?: string | null, town?: string | null, invoiceNumber?: string | null, sealImageUrl?: string | null, signatoryCompanyName?: string | null, signatoryType: number, signatoryName: string, signatoryEmail: string, agentCompanyName?: string | null, agentName?: string | null, agentPrefectureId?: string | null, agentMunicipality?: string | null, agentTown?: string | null } | null };

export type DeleteApplicationLessorSignatoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteApplicationLessorSignatoryMutation = { deleteApplicationLessorSignatory?: boolean | null };

export type GenerateUploadSignedUrlForPropertyMasterMutationVariables = Exact<{
  uploadSignedUrlInput: GenerateUploadSignedUrlForPropertyMasterInputDetail;
}>;


export type GenerateUploadSignedUrlForPropertyMasterMutation = { generateUploadSignedUrlForPropertyMaster: { __typename?: 'GenerateSignedPostPolicyResponse', url: string, fields: any } };

export type GetSyncPortSignedUrlMutationVariables = Exact<{
  signedUrlInput: GenerateSignedUrlInput;
}>;


export type GetSyncPortSignedUrlMutation = { generateLessorSyncPortSignedUrl: { __typename?: 'GenerateSignedUrlResponse', url: string } };

export type GenerateUploadSignedUrlForImageMutationVariables = Exact<{
  uploadSignedUrlInputDetail: GenerateUploadSignedUrlInputDetail;
}>;


export type GenerateUploadSignedUrlForImageMutation = { generateUploadSignedUrlForImage: { __typename?: 'GenerateSignedPostPolicyResponse', url: string, fields: any } };

export type GenerateUploadSignedUrlMutationVariables = Exact<{
  uploadSignedUrlInput: GenerateUploadSignedUrlInput;
}>;


export type GenerateUploadSignedUrlMutation = { generateUploadSignedUrl: { __typename?: 'GenerateSignedPostPolicyResponse', url: string, fields: any } };

export type UpdateSiteConfigMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  companySite: CompanySiteInput;
}>;


export type UpdateSiteConfigMutation = { companySiteUpdate: { __typename?: 'CompanyConfig', company?: { __typename?: 'Company', id: string } | null, userErrors?: Array<{ __typename?: 'Errors', message: string, field: string } | null> | null } };

export type CreateSpaceMutationVariables = Exact<{
  spaceGroupId: Scalars['ID']['input'];
  space: SpaceInput;
}>;


export type CreateSpaceMutation = { spaceUpdate: { __typename?: 'SpacePayload', space?: { __typename?: 'SpaceUpdate', id?: string | null } | null, userErrors?: Array<{ __typename?: 'UserErrors', field: string, message: string } | null> | null } };

export type UpdateSpaceMutationVariables = Exact<{
  spaceGroupId: Scalars['ID']['input'];
  space: SpaceInput;
}>;


export type UpdateSpaceMutation = { spaceUpdate: { __typename?: 'SpacePayload', space?: { __typename?: 'SpaceUpdate', id?: string | null } | null, userErrors?: Array<{ __typename?: 'UserErrors', field: string, message: string } | null> | null } };

export type FindSpacesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  spaceGroupId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<SpaceFilterInput>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FindSpacesQuery = { spaces: { __typename?: 'SpaceConnection', pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, totalCount?: number | null, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'SpaceEdge', cursor: string, node?: { __typename?: 'SpaceEdgeValue', id?: string | null, isAcceptable: boolean, name?: string | null, status?: number | null, spaceAvailableStatus?: SpaceAvailableStatus | null, spaceGroup?: { __typename?: 'SpaceGroupValue', id?: string | null, supportCarModel?: any | null, monthlyRent?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null, monthlyOtherFee?: Array<{ __typename?: 'MonthlyOtherFee', applyMonths: Array<number>, name: string, order: number, cost: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } } | null> | null } | null, usages?: Array<{ __typename?: 'SpaceUsage', useStartDate?: any | null, terminateDate?: any | null, isEditable: boolean, id?: string | null, approveCancelDate?: any | null, contractor?: { __typename?: 'Contractor', name?: string | null, phoneNumber?: string | null, applicationId?: string | null } | null } | null> | null } | null } | null> | null } };

export type FindSpaceQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
}>;


export type FindSpaceQuery = { space: { __typename?: 'SpaceDetail', id?: string | null, isAcceptable: boolean, name?: string | null, status?: number | null, spaceAvailableStatus?: SpaceAvailableStatus | null, usages?: Array<{ __typename?: 'SpaceUsage', useStartDate?: any | null, terminateDate?: any | null, isEditable: boolean, id?: string | null, approveCancelDate?: any | null, contractor?: { __typename?: 'Contractor', name?: string | null, phoneNumber?: string | null, applicationId?: string | null } | null } | null> | null } };

export type DeleteSpaceMutationVariables = Exact<{
  spaceId: Scalars['String']['input'];
}>;


export type DeleteSpaceMutation = { spaceDelete: { __typename?: 'SpaceDeleteResponse', space?: { __typename?: 'SpaceDelete', id?: string | null } | null, userErrors?: Array<{ __typename?: 'UserErrors', field: string, message: string } | null> | null } };

export type DeleteSpaceUsageMutationVariables = Exact<{
  monthlySpaceAvailabilityId: Scalars['ID']['input'];
}>;


export type DeleteSpaceUsageMutation = { spaceUsageDelete: { __typename?: 'MonthlySpaceAvailabilityDeleteResponse', monthlySpaceAvailability?: { __typename?: 'IMonthlySpaceAvailability', id: string } | null, userErrors?: Array<{ __typename?: 'Errors', field: string, message: string } | null> | null } };

export type UpdateSpaceGroupMutationVariables = Exact<{
  spaceGroupId: Scalars['ID']['input'];
  spaceGroup: SpaceGroupUpdateInput;
}>;


export type UpdateSpaceGroupMutation = { spaceGroupUpdate: { __typename?: 'SpaceGroupUpdatePayload', spaceGroup?: { __typename?: 'SpaceGroupCreate', id?: string | null } | null, userErrors?: Array<{ __typename?: 'UserErrors', message: string, field: string } | null> | null } };

export type UpdatePartialSpaceGroupMutationVariables = Exact<{
  spaceGroupId: Scalars['ID']['input'];
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatePartialSpaceGroupMutation = { updatePartialSpaceGroup: { __typename?: 'SpaceGroupUpdatePayload', spaceGroup?: { __typename?: 'SpaceGroupCreate', id?: string | null } | null, userErrors?: Array<{ __typename?: 'UserErrors', message: string, field: string } | null> | null } };

export type DeleteSpaceGroupMutationVariables = Exact<{
  spaceGroupId: Scalars['ID']['input'];
}>;


export type DeleteSpaceGroupMutation = { spaceGroupDelete: { __typename?: 'DeleteSpaceGroupResponse', spaceGroup?: { __typename?: 'DeleteSpaceGroup', id: string } | null, userErrors?: Array<{ __typename?: 'UserErrors', message: string, field: string } | null> | null } };

export type FindSpaceGroupQueryVariables = Exact<{
  anyId: Scalars['String']['input'];
  propertyId: Scalars['String']['input'];
}>;


export type FindSpaceGroupQuery = { spaceGroupByAnyId?: { __typename?: 'SpaceGroup', id?: string | null, existingSpaceGroupId?: string | null, isExistingTransfer?: boolean | null, depositAdminFee?: number | null, lesseeBaseUrl?: string | null, supportCarModel?: string | null, remarks?: string | null, specialTerms?: string | null, isAvailabilityPublic: boolean, isPublic: boolean, freeRent: number, monthlyRent?: { __typename?: 'MonthlyRent', monthlyAdminFee?: number | null, default?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null } | null, size?: { __typename?: 'SpaceGroupSize', height?: number | null, length?: number | null, carWidth?: number | null, groundHeight?: number | null, tireWidth?: number | null, weight?: number | null } | null, initialCost?: { __typename?: 'InitialCost', deposit?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null, gratuityFee?: { __typename?: 'PaymentInfo', isTaxExempt: boolean, value: number } | null } | null, contractCost?: { __typename?: 'ContractCost', administrativeFee?: number | null, renewalAdminFee?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null, storeFee?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null, renewalFee?: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } | null } | null, spaceGroupAvailability?: { __typename?: 'SpaceGroupAvailability', totalSpace?: number | null, emptySpace?: number | null, fullTemporary?: number | null, fullSpace?: number | null, fullPlanEnded?: number | null, fullPlanCancelled?: number | null, bookedSpace?: number | null, occupiedSpace?: number | null } | null, feature?: { __typename?: 'SpaceGroupFeature', type?: string | null, pavement?: string | null, roof: string, loan?: string | null, time?: { __typename?: 'FeatureTime', endDate?: any | null, startDate: any } | null } | null, contract?: { __typename?: 'Contract', years?: number | null, dailyRateType?: number | null } | null, images?: Array<{ __typename?: 'Images', id?: string | null, url?: string | null, storagePath?: string | null } | null> | null, monthlyOtherFee?: Array<{ __typename?: 'MonthlyOtherFee', name: string, applyMonths: Array<number>, order: number, cost: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } } | null> | null, initialOtherFee?: Array<{ __typename?: 'InitialOtherFee', name: string, order: number, cost: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } } | null> | null } | null };

export type FindSpaceGroupListQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  propertyId: Scalars['ID']['input'];
  filter?: InputMaybe<LessorSpaceGroupListFilter>;
}>;


export type FindSpaceGroupListQuery = { spaceGroups?: { __typename?: 'SpaceGroupListConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, totalCount?: number | null }, edges: Array<{ __typename?: 'LessorSpaceGroupsListEdge', cursor: string, node: { __typename?: 'LessorSpaceGroupsList', id: string, remarks?: string | null, supportCarModel: string, isPublic: boolean, isAvailabilityPublic: boolean, freeRent: number, monthlyRent: { __typename?: 'LessorSpaceGroupsListMonthlyRent', default: { __typename?: 'DefaultMonthlyRent', value: number, isTaxExempt: boolean } }, monthlyOtherFee?: Array<{ __typename?: 'MonthlyOtherFee', applyMonths: Array<number>, name: string, order: number, cost: { __typename?: 'PaymentInfo', value: number, isTaxExempt: boolean } } | null> | null, feature: { __typename?: 'LessorSpaceGroupsListFeature', type: string }, spaceGroupAvailability: { __typename?: 'SpaceGroupAvailability', totalSpace?: number | null, emptySpace?: number | null, fullTemporary?: number | null, fullSpace?: number | null, fullPlanEnded?: number | null, fullPlanCancelled?: number | null, bookedSpace?: number | null, occupiedSpace?: number | null } } }> } | null };

export type FindOfficersQueryVariables = Exact<{ [key: string]: never; }>;


export type FindOfficersQuery = { officers: Array<{ __typename?: 'Officer', id: string, name: string, email: string }> };

export type UpdateIsRequiredChangePasswordUpdateMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateIsRequiredChangePasswordUpdateMutation = { isRequiedChangePasswordUpdate: { __typename?: 'RequiedChangePasswordUpdateResponse', isSuccess: boolean, userErrors?: Array<{ __typename?: 'UserErrors', field: string, message: string } | null> | null } };

export const ContractFieldsFragmentDoc = gql`
    fragment contractFields on Contract {
  years
  dailyRateType
}
    `;
export const MonthRentFieldsFragmentDoc = gql`
    fragment monthRentFields on MonthlyRent {
  default {
    value
    isTaxExempt
  }
  monthlyAdminFee
}
    `;
export const InitialCostFieldsFragmentDoc = gql`
    fragment initialCostFields on InitialCost {
  deposit {
    value
    isTaxExempt
  }
  gratuityFee {
    value
    isTaxExempt
  }
}
    `;
export const FeatureFieldsFragmentDoc = gql`
    fragment featureFields on Feature {
  type
  roof
  pavement
  lentItem
  time {
    startDate
    endDate
  }
}
    `;
export const AvailabilityFieldsFragmentDoc = gql`
    fragment availabilityFields on Availability {
  numberOfFree
  numberOfOccupied
}
    `;
export const PageInfoFieldsFragmentDoc = gql`
    fragment pageInfoFields on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
  totalCount
}
    `;
export const SpacesUsedFieldsFragmentDoc = gql`
    fragment spacesUsedFields on SpaceUsed {
  id
  name
  isAcceptable
}
    `;
export const CompanyFieldsFragmentDoc = gql`
    fragment CompanyFields on Company {
  isCorporate
  name
  furigana
  address
  content
  hp
  importantDate
  revenue
  numberOfEmployees
  phoneNumber
  email
  fax
  personInContact {
    name
    department
    phoneNumber
  }
  id
}
    `;
export const FileFieldsFragmentDoc = gql`
    fragment FileFields on File {
  url
  originUrl
  createdAt
  documentType
  fileName
  fileType
}
    `;
export const GuarantorWorkPlaceFieldsFragmentDoc = gql`
    fragment GuarantorWorkPlaceFields on GuarantorWorkPlace {
  name
  address
  lengthOfEmployment
  hp
  capital
  annualRevenue
  numberOfEmployees
  phoneNumber
  email
  fax
  importantDate
}
    `;
export const GuarantorFieldsFragmentDoc = gql`
    fragment GuarantorFields on Guarantor {
  name
  isGuarantor
  address
  familyRelationship
  birthday
  revenue
  phoneNumber
  email
  fax
  cosignerIdCard {
    ...FileFields
  }
  workplace {
    ...GuarantorWorkPlaceFields
  }
}
    ${FileFieldsFragmentDoc}
${GuarantorWorkPlaceFieldsFragmentDoc}`;
export const CarInfoFieldsFragmentDoc = gql`
    fragment CarInfoFields on CarInfo {
  number
  type
  color
  model
}
    `;
export const UserInfoFieldsFragmentDoc = gql`
    fragment UserInfoFields on UserInfo {
  name
  phoneNumber
  email
  address
  relationship
  birthday
  age
  workplace {
    name
    address
  }
  idCard {
    ...FileFields
  }
  certificate {
    ...FileFields
  }
}
    ${FileFieldsFragmentDoc}`;
export const FindApplicationsDocument = gql`
    query findApplications($pagination: PaginationInput, $filter: ApplicationFilterInput) {
  applications(pagination: $pagination, filter: $filter) {
    pageInfo {
      ...pageInfoFields
    }
    edges {
      node {
        id
        spaceGroup {
          property {
            id
            images {
              url
            }
            address
            name
            controlNumber
          }
          spaceGroupAvailability {
            totalSpace
            emptySpace
            fullTemporary
            fullSpace
            fullPlanEnded
            fullPlanCancelled
            bookedSpace
            occupiedSpace
          }
        }
        numberOfCar
        applicant {
          name
          company {
            isCorporate
            name
          }
        }
        parent {
          id
        }
        child {
          id
        }
        status
        updatedAt
        duration {
          applyAt
          startAt
        }
        unreadCount
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;
export const FindApplicationDocument = gql`
    query findApplication($applicationId: ID!) {
  application(applicationId: $applicationId) {
    id
    spaceGroup {
      id
      monthlyRent {
        monthlyAdminFee
        default {
          value
          isTaxExempt
        }
      }
      initialCost {
        deposit {
          value
          isTaxExempt
        }
        gratuityFee {
          value
          isTaxExempt
        }
      }
      contractCost {
        renewalAdminFee {
          value
          isTaxExempt
        }
        storeFee {
          value
          isTaxExempt
        }
        administrativeFee
        renewalFee {
          value
          isTaxExempt
        }
        depositAdminFee
        renewalAddFee
      }
      supportCarModel
      spaceGroupAvailability {
        totalSpace
        emptySpace
        fullTemporary
        fullSpace
        fullPlanEnded
        fullPlanCancelled
        bookedSpace
        occupiedSpace
      }
      spaces {
        id
        name
        isAcceptable
      }
      property {
        id
        name
        address
        controlNumber
        images {
          url
          id
        }
      }
      remarks
    }
    applicant {
      name
      company {
        isCorporate
        name
        furigana
        address
        prefectureId
        municipality
        town
        importantDate
        revenue
        numberOfEmployees
        phoneNumber
        email
        content
        id
        fax
        hp
        personInContact {
          name
          department
          phoneNumber
          fax
          email
        }
      }
    }
    guarantor {
      id
      name
      isGuarantor
      address
      prefectureId
      municipality
      town
      employmentCompanyName
      employmentCompanyAddress
      employmentCompanyAddressPrefectureId
      employmentCompanyAddressMunicipality
      employmentCompanyAddressTown
      familyRelationship
      birthday
      revenue
      phoneNumber
      email
      fax
      cosignerIdCard {
        ...FileFields
      }
      backOfCosignerIdCard {
        ...FileFields
      }
      workplace {
        name
        address
        prefectureId
        municipality
        town
        employmentCompanyAddressPrefectureId
        employmentCompanyAddressMunicipality
        employmentCompanyAddressTown
        lengthOfEmployment
        hp
        capital
        annualRevenue
        numberOfEmployees
        phoneNumber
        email
        fax
        importantDate
      }
      lengthOfEmployment
      hp
      capital
      annualRevenue
      numberOfEmployees
      phoneNumber
      email
      fax
      importantDate
    }
    duration {
      startAt
      endAt
      applyAt
      contractAt
      reviewSentAt
      cancellationAt
    }
    documents {
      ...FileFields
    }
    numberOfCar
    intendedUse
    carUserInfo {
      id
      carInfo {
        number
        color
        model
        type
      }
      userInfo {
        name
        phoneNumber
        email
        address
        prefectureId
        municipality
        town
        relationship
        birthday
        age
        workplace {
          name
          address
          employmentCompanyAddressPrefectureId
          employmentCompanyAddressMunicipality
          employmentCompanyAddressTown
        }
        idCard {
          ...FileFields
        }
        backOfIdCard {
          ...FileFields
        }
        certificate {
          ...FileFields
        }
      }
    }
    spaces {
      id
      name
      isAcceptable
    }
    status
    updatedAt
    isEditable
    unreadCount
    initialOtherFee {
      name
      cost {
        value
        isTaxExempt
      }
      order
    }
    monthlyOtherFee {
      name
      cost {
        value
        isTaxExempt
      }
      applyMonths
      order
    }
    memo
    type
    contractType
    property {
      id
      name
    }
    requestCancelDate
    approveCancelDate
    approveCancelAt
    requestCancelAt
  }
}
    ${FileFieldsFragmentDoc}`;
export const FindApplicationPropertyDocument = gql`
    query findApplicationProperty($applicationId: ID!) {
  applicationProperty(applicationId: $applicationId) {
    spaceGroup {
      monthlyRent {
        monthlyAdminFee
        default {
          value
          isTaxExempt
        }
      }
      initialCost {
        deposit {
          value
          isTaxExempt
        }
        gratuityFee {
          value
          isTaxExempt
        }
      }
      contractCost {
        renewalAdminFee {
          value
          isTaxExempt
        }
        storeFee {
          value
          isTaxExempt
        }
        administrativeFee
      }
      supportCarModel
      availability {
        numberOfFree
        numberOfFullSpace
      }
      property {
        id
        address
        name
        images {
          storagePath
          url
        }
        controlNumber
      }
      initialOtherFee {
        name
        cost {
          value
          isTaxExempt
        }
        order
      }
      monthlyOtherFee {
        name
        cost {
          value
          isTaxExempt
        }
        order
        applyMonths
      }
    }
  }
}
    `;
export const FindApplicationStatusReviewDocument = gql`
    query findApplicationStatusReview($applicationId: ID!) {
  applicationStatusReview(applicationId: $applicationId) {
    application {
      reviewSendAt
      status
    }
    document {
      downloadedAt
    }
  }
  applicationProperty(applicationId: $applicationId) {
    spaceGroup {
      property {
        name
      }
    }
  }
  applicationDownload(applicationId: $applicationId) {
    url
  }
}
    `;
export const FindApplicationDownloadDocument = gql`
    query findApplicationDownload($applicationId: ID!) {
  applicationDownload(applicationId: $applicationId) {
    url
    filename
  }
}
    `;
export const UpdateApplicationStatusDocument = gql`
    mutation updateApplicationStatus($applicationId: ID!, $newStatus: Int!) {
  applicationStatusUpdateWhenComplete(
    applicationId: $applicationId
    updateApplicationStatus: $newStatus
  ) {
    application {
      id
      status
    }
    userErrors {
      message
      field
    }
  }
}
    `;
export const CancelApplicationDocument = gql`
    mutation cancelApplication($applicationId: ID!, $cancelMessage: String!, $applicationStatusCancel: Int!) {
  applicationCancel(
    applicationId: $applicationId
    cancelMessage: $cancelMessage
    applicationStatusCancel: $applicationStatusCancel
  ) {
    application {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const RequestChangeApplicationDocument = gql`
    mutation requestChangeApplication($applicationId: ID!, $editMessage: String!) {
  applicationChange(applicationId: $applicationId, editMessage: $editMessage) {
    application {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const LockApplicationDocument = gql`
    mutation lockApplication($applicationId: ID!) {
  applicationLock(applicationId: $applicationId) {
    application {
      id
      status
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const ChangeApplicationSpacesDocument = gql`
    mutation changeApplicationSpaces($applicationId: ID!, $spaceIds: [ID!]!) {
  applicationSpaceChange(applicationId: $applicationId, spaceIds: $spaceIds) {
    applicationSpace {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const FindApplicationOnlineContractDocument = gql`
    query findApplicationOnlineContract($applicationId: ID!) {
  application(applicationId: $applicationId) {
    contractDocument {
      id
      cloudsignDocumentId
      documentStatus
    }
  }
}
    `;
export const FindCustomerApplicationsDocument = gql`
    query findCustomerApplications($pagination: PaginationInput, $filter: CustomerApplicationFilterInput) {
  customerApplications(pagination: $pagination, filter: $filter) {
    pageInfo {
      ...pageInfoFields
    }
    edges {
      node {
        id
        spaceGroup {
          property {
            id
            images {
              url
            }
            address
            name
            controlNumber
          }
          spaceGroupAvailability {
            totalSpace
            emptySpace
            fullTemporary
            fullSpace
            fullPlanEnded
            fullPlanCancelled
            bookedSpace
            occupiedSpace
          }
          supportCarModel
        }
        spaces {
          id
          name
        }
        applicant {
          name
          company {
            isCorporate
            name
          }
        }
        duration {
          applyAt
          startAt
        }
        numberOfCar
        carUserInfo {
          id
          carInfo {
            number
            color
            model
            type
          }
        }
        parent {
          id
        }
        child {
          id
        }
        status
        updatedAt
        unreadCount
        memo
        type
        requestCancelDate
        approveCancelDate
        approveCancelAt
        requestCancelAt
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;
export const FindWaitingContractDocument = gql`
    query findWaitingContract($pagination: PaginationInput, $filter: WaitingContractRequestFilterInput) {
  waitingContractRequestList(pagination: $pagination, filter: $filter) {
    pageInfo {
      ...pageInfoFields
    }
    edges {
      node {
        id
        propertyId
        availableSlotsTime
        useOfCars
        sizeOfCar
        status
        carModel
        other
        isCorporate
        companyName
        name
        phoneNumber
        email
        memo
        createdAt
        updatedAt
        waitingContractProperty {
          propertyName
          propertyControlNumber
        }
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;
export const ApplicationReviewDownloadDocument = gql`
    mutation applicationReviewDownload($applicationId: ID!) {
  applicationReviewDownload(applicationId: $applicationId) {
    downloadedAt
  }
}
    `;
export const LessorTotalUnreadCountDocument = gql`
    query lessorTotalUnreadCount {
  lessorTotalUnreadCount {
    count
  }
}
    `;
export const PartialApplicationUpdateDocument = gql`
    mutation partialApplicationUpdate($partialApplicationInput: PartialApplicationInput!) {
  partialApplicationUpdate(partialApplicationInput: $partialApplicationInput) {
    applicationId
    memo
    updatedAt
  }
}
    `;
export const CompleteContractConfirmationStepDocument = gql`
    mutation completeContractConfirmationStep($contractDetailId: ID!) {
  completeContractConfirmationStep(contractDetailId: $contractDetailId) {
    id
    contractConfirmationStep
    updatedAt
  }
}
    `;
export const RequestContractReviewDocument = gql`
    mutation requestContractReview($input: RequestContractReviewInput!) {
  requestContractReview(requestContractReviewInput: $input)
}
    `;
export const RequestSignContractDocument = gql`
    mutation requestSignContract($contractDetailId: String!) {
  requestSignContract(contractDetailId: $contractDetailId) {
    confirmAndRequestStampAt
  }
}
    `;
export const ApproveCancelApplicationDocument = gql`
    mutation approveCancelApplication($applicationId: ID!, $approveCancelApplicationInput: ApproveCancelApplicationInput!) {
  lessorApproveCancelApplication(
    applicationId: $applicationId
    approveCancelApplicationInput: $approveCancelApplicationInput
  ) {
    application {
      id
      status
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const GetMessagesDocument = gql`
    query getMessages($applicationId: ID!, $pagination: PaginationInput) {
  messages(applicationId: $applicationId, pagination: $pagination) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
      totalCount
    }
    edges {
      node {
        id
        content
        sendAt
        isRead
        file {
          fileType
          url
          originUrl
        }
        sender {
          type
          name
          specificId
        }
        type
        bulkMessageId
      }
    }
  }
}
    `;
export const SendMessageDocument = gql`
    mutation sendMessage($applicationId: ID!, $message: MessageInput!) {
  messageCreate(applicationId: $applicationId, message: $message) {
    message {
      id
    }
    userErrors {
      message
      field
    }
  }
}
    `;
export const DeleteMessageDocument = gql`
    mutation deleteMessage($messageId: ID!) {
  messageDelete(applicationMessageId: $messageId) {
    userErrors {
      field
      message
    }
  }
}
    `;
export const ReadMessageDocument = gql`
    mutation readMessage($applicationId: ID!) {
  messageRead(applicationId: $applicationId) {
    userErrors {
      field
      message
    }
  }
}
    `;
export const GetUnreadCountDocument = gql`
    query getUnreadCount($applicationId: ID!) {
  unreadCount(applicationId: $applicationId) {
    count
  }
}
    `;
export const FindSiteConfigDocument = gql`
    query findSiteConfig {
  siteConfig {
    siteName
    companyHp
    logo
  }
}
    `;
export const FindFormConfigDocument = gql`
    query findFormConfig {
  formConfig {
    applicant {
      name
      furigana
      address
      businessContent
      hp
      importantDate
      revenue
      numberOfEmployees
      phoneNumber
      email
      fax
      contactPerson {
        name
        department
        phoneNumber
        email
        fax
      }
      idCard
      backOfIdCard
      historyDoc
      insuranceCard
    }
    application {
      useStartDate
      intendedUse
      hopeSpaces
    }
    car {
      sizeOfCar
      carModel
      numberPlate
      colorOfCar
    }
    user {
      name
      address
      relationship
      birthday
      phoneNumber
      email
      employmentCompanyName
      employmentCompanyAddress
      idCard
      certificate
    }
    guarantor {
      name
      address
      familyRelationship
      birthday
      revenue
      phoneNumber
      email
      lengthOfEmployment
      fax
      employmentCompanyName
      employmentCompanyAddress
      hp
      importantDate
      capital
      annualRevenue
      numberOfEmployees
      cosignerIdCard
    }
  }
}
    `;
export const UpdateFormConfigDocument = gql`
    mutation updateFormConfig($companyId: ID!, $formConfig: FormConfigInput!) {
  companyFormUpdate(companyId: $companyId, formConfig: $formConfig) {
    company {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const ActivePropertiesOfCompanyDocument = gql`
    query activePropertiesOfCompany {
  activePropertiesOfCompany {
    id
    name
  }
}
    `;
export const ActiveSpacesOfPropertyDocument = gql`
    query activeSpacesOfProperty($propertyId: ID!) {
  activeSpacesOfProperty(propertyId: $propertyId) {
    id
    name
    spaceGroupId
  }
}
    `;
export const CreateCustomerDocument = gql`
    mutation createCustomer($applicationInput: LessorApplicationRegistrationInput!) {
  lessorApplicationRegistration(
    lessorApplicationRegistrationInput: $applicationInput
  ) {
    application {
      id
      message
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const UpdateCustomerDocument = gql`
    mutation updateCustomer($applicationInput: LessorApplicationEditInput!) {
  lessorApplicationEdit(lessorApplicationEditInput: $applicationInput) {
    application {
      id
      message
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const ProxyEditCustomerDocument = gql`
    mutation proxyEditCustomer($applicationInput: LessorApplicationEditInput!) {
  lessorProxyApplicationEdit(lessorProxyApplicationEditInput: $applicationInput) {
    application {
      id
      message
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const DashboardApplicationStatisticsDocument = gql`
    query dashboardApplicationStatistics($statuses: [ApplicationStatusEnum]) {
  dashboardApplicationStatistics(statuses: $statuses) {
    statistics {
      status
      count
    }
  }
}
    `;
export const DashboardPropertyStatisticsDocument = gql`
    query dashboardPropertyStatistics {
  dashboardPropertyStatistics {
    totalPublicProperties
    totalPrivateProperties
    emptyProperties
    fullProperties
    efficiency
    present {
      full
      free
    }
  }
}
    `;
export const DashboardSpaceStatsDocument = gql`
    query dashboardSpaceStats {
  dashboardSpaceStats {
    totalSpacesActive
    totalSpaceFull
    totalSpaceTemporary
    totalSpaceFree
    totalSpaceInactive
    efficiency
    present {
      temporary
      full
      free
    }
  }
}
    `;
export const LessorLatestLesseeMessagesDocument = gql`
    query lessorLatestLesseeMessages($limit: Int) {
  lessorLatestLesseeMessages(limit: $limit) {
    id
    createdAt
    content
    applicationId
    sender {
      type
      name
      specificId
    }
    hasAttachment
    isRead
  }
}
    `;
export const DashboardBillingStatsDocument = gql`
    query dashboardBillingStats($period: DashboardStatsPeriodOption!, $offset: Int) {
  dashboardBillingStats(period: $period, offset: $offset) {
    months {
      month
      billedAmount
      paidAmount
      subrogationAmount
    }
    period
    offset
    totalMonths
  }
}
    `;
export const FindMeDocument = gql`
    query findMe {
  me {
    id
    name
    email
    isRequiredChangePassword
    company {
      id
      name
      address
      phoneNumber
      config {
        isConfiguredSite
      }
    }
  }
}
    `;
export const FindMessageTemplatesDocument = gql`
    query findMessageTemplates {
  messageTemplates {
    id
    title
    body
    updatedAt
  }
}
    `;
export const FindMessageTemplateByIdDocument = gql`
    query findMessageTemplateById($messageTemplateId: String!) {
  messageTemplate(messageTemplateId: $messageTemplateId) {
    id
    title
    body
    updatedAt
    userErrors {
      field
      message
    }
  }
}
    `;
export const CreateMessageTemplateDocument = gql`
    mutation createMessageTemplate($messageTemplate: CreateMessageTemplateInput!) {
  messageTemplateCreate(messageTemplate: $messageTemplate) {
    id
    userErrors {
      field
      message
    }
  }
}
    `;
export const DeleteMessageTemplateDocument = gql`
    mutation deleteMessageTemplate($messageTemplate: DeleteMessageTemplateInput!) {
  messageTemplateDelete(messageTemplate: $messageTemplate) {
    id
    userErrors {
      field
      message
    }
  }
}
    `;
export const UpdateMessageTemplateDocument = gql`
    mutation updateMessageTemplate($messageTemplate: UpdateMessageTemplateInput!) {
  messageTemplateUpdate(messageTemplate: $messageTemplate) {
    id
    userErrors {
      field
      message
    }
  }
}
    `;
export const FindMailingGroupsDocument = gql`
    query findMailingGroups {
  mailingGroups {
    id
    name
    memberCount
    updatedAt
  }
}
    `;
export const FindMailingGroupDetailDocument = gql`
    query findMailingGroupDetail($id: ID!) {
  mailingGroupDetail(id: $id) {
    id
    name
    officerIds
    updatedAt
  }
}
    `;
export const SaveMailingGroupDocument = gql`
    mutation saveMailingGroup($input: SaveMailingGroupInput!) {
  saveMailingGroup(input: $input) {
    mailingGroup {
      id
    }
    userErrors {
      message
      field
    }
  }
}
    `;
export const DeleteMailingGroupDocument = gql`
    mutation deleteMailingGroup($id: ID!) {
  deleteMailingGroup(id: $id) {
    id
    userErrors {
      message
      field
    }
  }
}
    `;
export const FindOnlineContractStatusDocument = gql`
    query findOnlineContractStatus($contractDocumentId: String!) {
  getContractDocumentsDetail(contractDocumentId: $contractDocumentId) {
    receivers {
      status
    }
  }
}
    `;
export const GetContractDocumentsDetailDocument = gql`
    query getContractDocumentsDetail($contractDocumentId: String!) {
  getContractDocumentsDetail(contractDocumentId: $contractDocumentId) {
    id
    cloudsignDocumentId
    documentStatus
    conclusionDate
    message
    title
    note
    canTransfer
    isUpdatedContract
    files {
      id
      name
    }
    receivers {
      id
      nameReceiver
      emailReceiver
      companyNameReceiver
      order
      status
      processedAt
      accessExpiresAt
    }
  }
}
    `;
export const FindFileCloudSignContractDocument = gql`
    query findFileCloudSignContract($contractDocumentId: String!, $fileId: String!) {
  getFileCloudSignContract(
    contractDocumentId: $contractDocumentId
    fileId: $fileId
  )
}
    `;
export const LessorGetContractDetailDocument = gql`
    query lessorGetContractDetail($applicationId: String!) {
  lessorGetContractDetail(applicationId: $applicationId) {
    id
    applicationId
    specialTerms
    step
    needParkingCertificate
    desiredDeliveryDate
    certificateDeliveryAddressFull
    privacyPolicyAgreed
    certificateDeliveryPrefectureId
    certificateDeliveryMunicipality
    certificateDeliveryTown
    applicationLessorSignatoryInfo {
      id
      name
      email
      signatory_type
      signatory_name
      signatory_email
    }
    formExpiredAt
    formSubmittedAt
    isDoneFirstPayment
    application {
      id
      contractDoneDate
      email
      contractDocuments {
        id
        conclusionDate
      }
      applicationProperty {
        deposit {
          value
          isTaxExempt
        }
        gratuityFee {
          value
          isTaxExempt
        }
        administrativeFee
        depositAdminFee
        storeFee {
          value
          isTaxExempt
        }
        propertyName
        propertyAddress
        propertyControlNumber
      }
      applicationContractor {
        name
        isCorporate
        cContractor {
          name
        }
      }
    }
    contractPaymentInfo {
      paymentMethodType
      creditCardPaymentMethod {
        cardHolderName
        cardLast4
        cardExpire
        updatedAt
      }
    }
    contractConfirmationStep
    manualContractStep
    additionalInfo
  }
}
    `;
export const GetContractPdfDocumentDocument = gql`
    query getContractPdfDocument($contractDetailId: String!) {
  getContractPdfDocument(contractDetailId: $contractDetailId) {
    generated {
      status
      fileUrl
      createdAt
    }
    signedUpload {
      fileUrl
      uploadedAt
    }
  }
}
    `;
export const UpdateContractDocument = gql`
    mutation updateContract($input: UpdateContractInput!) {
  updateContract(input: $input) {
    contractDetailId
    applicationId
    applicationLessorSignatoryInfo {
      id
      name
      property_manage_company_id
      prefecture_id
      municipality
      town
      invoice_number
      seal_image_url
      email
      is_lessor_join_contract
      signatory_company_name
      signatory_type
      signatory_name
      signatory_email
      agent_company_name
      agent_name
      agent_prefecture_id
      agent_municipality
      agent_town
    }
    specialTerms
    needParkingCertificate
    desiredDeliveryDate
    certificateDeliveryAddressFull
    certificateDeliveryPrefectureId
    certificateDeliveryMunicipality
    certificateDeliveryTown
    additionalInfo
    paymentMethodType
    updatedAt
  }
}
    `;
export const RequestSaveSignedContractPdfUrlDocument = gql`
    mutation requestSaveSignedContractPdfUrl($input: SaveSignedContractPdfUrlInput!) {
  saveSignedContractPdfUrl(input: $input) {
    fileUrl
    uploadedAt
  }
}
    `;
export const SyncSignContractTimeDocument = gql`
    mutation syncSignContractTime($contractDetailId: ID!) {
  syncSignContractTime(contractDetailId: $contractDetailId) {
    lesseeSignContractDocumentAt
    lessorSignContractDocumentAt
    finalConfirmSignContractDocumentAt
  }
}
    `;
export const OwnerInquiryCreateDocument = gql`
    mutation ownerInquiryCreate($ownerInquiryCreate: CreateOwnerInquiryInput!) {
  ownerInquiryCreate(ownerInquiryCreate: $ownerInquiryCreate)
}
    `;
export const FindPropertiesDocument = gql`
    query findProperties($pagination: PaginationInput, $filter: LessorPropertyListFilter) {
  properties(pagination: $pagination, filter: $filter) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      totalCount
    }
    edges {
      node {
        id
        name
        address
        images {
          url
        }
        controlNumber
        remarks
        availability {
          totalSpace
          emptySpace
          fullTemporary
          fullSpace
          fullPlanEnded
          fullPlanCancelled
          bookedSpace
          occupiedSpace
        }
        officer {
          id
          fullname
        }
        visibility
        memo
      }
      cursor
    }
  }
}
    `;
export const CreatePropertyDocument = gql`
    mutation createProperty($property: CreatePropertyInput!) {
  propertyCreate(property: $property) {
    property {
      id
    }
    userErrors {
      message
      field
    }
  }
}
    `;
export const FindPropertyDetailDocument = gql`
    query findPropertyDetail($propertyId: ID!, $order: LessorPropertyDetailOrder) {
  property(propertyId: $propertyId, order: $order) {
    id
    address
    name
    images {
      url
      id
    }
    remarks
    municipality
    prefecture {
      id
      name
    }
    town
    controlNumber
    officer {
      id
      name
    }
    visibility
    geocode {
      latitude
      longitude
    }
    memo
    hasGuarantee
    atportLink
    spaceGroups {
      id
      remarks
      monthlyRent {
        default {
          value
          isTaxExempt
        }
      }
      supportCarModel
      feature {
        type
      }
      spaceGroupAvailability {
        totalSpace
        emptySpace
        fullTemporary
        fullSpace
        fullPlanEnded
        fullPlanCancelled
        bookedSpace
        occupiedSpace
      }
      isAvailabilityPublic
    }
    visibility
    mailingGroup {
      id
      name
    }
  }
}
    `;
export const FindPreviewPropertyDocument = gql`
    query findPreviewProperty($propertyId: ID!) {
  property(propertyId: $propertyId) {
    id
    preview {
      token
    }
  }
}
    `;
export const UpdatePropertyDocument = gql`
    mutation updateProperty($property: UpdatePropertyInput!, $propertyId: String!) {
  propertyUpdate(property: $property, propertyId: $propertyId) {
    property {
      id
    }
    userErrors {
      message
      field
    }
  }
}
    `;
export const DeletePropertyDocument = gql`
    mutation deleteProperty($propertyId: String!) {
  propertyDelete(propertyId: $propertyId) {
    property {
      id
    }
    userErrors {
      message
      field
    }
  }
}
    `;
export const CreateSpaceGroupDocument = gql`
    mutation createSpaceGroup($propertyId: ID!, $spaceGroup: SpaceGroupInput!) {
  spaceGroupCreate(propertyId: $propertyId, spaceGroup: $spaceGroup) {
    spaceGroup {
      id
    }
    userErrors {
      message
      field
    }
  }
}
    `;
export const UpdateAtPortLinkDocument = gql`
    mutation updateAtPortLink($propertyId: String!, $atPortLink: UpdateAtportlinkInput!) {
  updateAtPortLink(propertyId: $propertyId, atPortLink: $atPortLink) {
    property {
      id
    }
    userErrors {
      message
      field
    }
  }
}
    `;
export const NotifyAtPortLinkDocument = gql`
    mutation notifyAtPortLink($propertyId: String!, $atPortLink: AtportLink!) {
  propertyNotify(propertyId: $propertyId, atportLink: $atPortLink)
}
    `;
export const UpdatePartialPropertyDocument = gql`
    mutation updatePartialProperty($propertyId: String!, $property: UpdatePartialPropertyInput!) {
  updatePartialProperty(property: $property, propertyId: $propertyId) {
    property {
      id
    }
    userErrors {
      message
      field
    }
  }
}
    `;
export const GetPrefectureDropdownDocument = gql`
    query getPrefectureDropdown {
  prefectures {
    id
    name
  }
}
    `;
export const PropertyHasActiveApplicationDocument = gql`
    query propertyHasActiveApplication($propertyId: ID!) {
  propertyHasActiveApplication(propertyId: $propertyId) {
    hasActiveApplication
  }
}
    `;
export const ActiveContractorsDocument = gql`
    query activeContractors($pagination: PaginationInput!, $filter: ActiveContractorFilterInput!) {
  activeContractors(pagination: $pagination, filter: $filter) {
    edges {
      cursor
      node {
        applicationId
        spaceName
        isCorporate
        contractorName
        carModel
        useStartDate
        totalMonthlyRent
        supportCarModel
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
      totalCount
    }
  }
}
    `;
export const PropertyNameAndActiveAllApplicationIdsDocument = gql`
    query propertyNameAndActiveAllApplicationIds($propertyId: ID!) {
  propertyNameAndActiveAllApplicationIds(propertyId: $propertyId) {
    propertyName
    applicationIds
  }
}
    `;
export const MessageBatchCreateDocument = gql`
    mutation messageBatchCreate($applicationIds: [ID!]!, $input: MessageInput!) {
  messageBatchCreate(applicationIds: $applicationIds, input: $input) {
    message {
      bulkMessageId
      content
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const GetRentalInformationDocument = gql`
    query getRentalInformation($applicationId: String!) {
  getRentalInformation(applicationId: $applicationId) {
    application {
      application {
        id
        message
      }
      userErrors {
        field
        message
      }
      status
      useStartDate
    }
    needParkingCertificate
    feeSummary
  }
}
    `;
export const FindSalesManagementListDocument = gql`
    query findSalesManagementList($page: Int, $filter: SalesManagementFilterInput, $sort: SalesManagementSortInput, $pageSize: Int) {
  salesManagementList(
    page: $page
    filter: $filter
    sort: $sort
    pageSize: $pageSize
  ) {
    billings {
      id
      createdAt
      status
      itemType
      billingCycleStart
      billingCycleEnd
      amount
      dueDate
      contractorName
      propertyName
      propertyControlNumber
      paymentMethodType
      useStartDate
      useEndDate
    }
    summary {
      totalAmount
      totalPaid
      totalSubrogation
    }
    totalCount
    totalPages
    currentPage
  }
}
    `;
export const FindSalesManagementDetailDocument = gql`
    query findSalesManagementDetail($billingId: String!) {
  salesManagementDetail(billingId: $billingId) {
    id
    status
    itemType
    amount
    dueDate
    contractorName
    propertyName
    propertyControlNumber
    feeDetail {
      initial {
        type
        deposit
        gratuityFee
        administrativeFee
        depositAdminFee
        storeFee
        applyInitialOtherFee {
          name
          value
        }
        totalAmount
      }
      monthly {
        type
        monthlyRent
        monthlyAdminFee
        applyMonthlyOtherFee {
          name
          value
          applyMonths
        }
        totalAmount
      }
    }
    billingPeriodStart
    billingPeriodEnd
    feeDetailType
    needParkingCertificate
  }
}
    `;
export const GetApplicationLessorSignatoriesDocument = gql`
    query getApplicationLessorSignatories {
  applicationLessorSignatories {
    id
    name
    prefectureId
    propertyManageCompanyId
    municipality
    town
    invoiceNumber
    sealImageUrl
    isLessorJoinContract
    email
    signatoryType
    signatoryName
    signatoryEmail
    agentName
  }
}
    `;
export const GetApplicationLessorSignatoryDocument = gql`
    query getApplicationLessorSignatory($id: ID!) {
  applicationLessorSignatory(id: $id) {
    id
    name
    prefectureId
    propertyManageCompanyId
    municipality
    town
    invoiceNumber
    sealImageUrl
    isLessorJoinContract
    email
    signatoryCompanyName
    signatoryType
    signatoryName
    signatoryEmail
    agentCompanyName
    agentName
    agentPrefectureId
    agentMunicipality
    agentTown
  }
}
    `;
export const CreateApplicationLessorSignatoryDocument = gql`
    mutation createApplicationLessorSignatory($input: CreateApplicationLessorSignatoryInput!) {
  createApplicationLessorSignatory(input: $input) {
    id
    name
    prefectureId
    propertyManageCompanyId
    municipality
    town
    invoiceNumber
    sealImageUrl
    signatoryCompanyName
    signatoryType
    signatoryName
    signatoryEmail
    agentCompanyName
    agentName
    agentPrefectureId
    agentMunicipality
    agentTown
  }
}
    `;
export const UpdateApplicationLessorSignatoryDocument = gql`
    mutation updateApplicationLessorSignatory($input: UpdateApplicationLessorSignatoryInput!) {
  updateApplicationLessorSignatory(input: $input) {
    id
    name
    prefectureId
    propertyManageCompanyId
    municipality
    town
    invoiceNumber
    sealImageUrl
    signatoryCompanyName
    signatoryType
    signatoryName
    signatoryEmail
    agentCompanyName
    agentName
    agentPrefectureId
    agentMunicipality
    agentTown
  }
}
    `;
export const DeleteApplicationLessorSignatoryDocument = gql`
    mutation deleteApplicationLessorSignatory($id: ID!) {
  deleteApplicationLessorSignatory(id: $id)
}
    `;
export const GenerateUploadSignedUrlForPropertyMasterDocument = gql`
    mutation generateUploadSignedUrlForPropertyMaster($uploadSignedUrlInput: GenerateUploadSignedUrlForPropertyMasterInputDetail!) {
  generateUploadSignedUrlForPropertyMaster(
    uploadSignedUrlInput: $uploadSignedUrlInput
  ) {
    url
    fields
  }
}
    `;
export const GetSyncPortSignedUrlDocument = gql`
    mutation getSyncPortSignedUrl($signedUrlInput: GenerateSignedUrlInput!) {
  generateLessorSyncPortSignedUrl(signedUrlInput: $signedUrlInput) {
    url
  }
}
    `;
export const GenerateUploadSignedUrlForImageDocument = gql`
    mutation generateUploadSignedUrlForImage($uploadSignedUrlInputDetail: GenerateUploadSignedUrlInputDetail!) {
  generateUploadSignedUrlForImage(
    uploadSignedUrlInputDetail: $uploadSignedUrlInputDetail
  ) {
    url
    fields
  }
}
    `;
export const GenerateUploadSignedUrlDocument = gql`
    mutation generateUploadSignedUrl($uploadSignedUrlInput: GenerateUploadSignedUrlInput!) {
  generateUploadSignedUrl(uploadSignedUrlInput: $uploadSignedUrlInput) {
    url
    fields
  }
}
    `;
export const UpdateSiteConfigDocument = gql`
    mutation updateSiteConfig($companyId: String!, $companySite: CompanySiteInput!) {
  companySiteUpdate(companyId: $companyId, companySite: $companySite) {
    company {
      id
    }
    userErrors {
      message
      field
    }
  }
}
    `;
export const CreateSpaceDocument = gql`
    mutation createSpace($spaceGroupId: ID!, $space: SpaceInput!) {
  spaceUpdate(spaceGroupId: $spaceGroupId, spaces: $space) {
    space {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const UpdateSpaceDocument = gql`
    mutation updateSpace($spaceGroupId: ID!, $space: SpaceInput!) {
  spaceUpdate(spaceGroupId: $spaceGroupId, spaces: $space) {
    space {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const FindSpacesDocument = gql`
    query findSpaces($pagination: PaginationInput, $spaceGroupId: ID, $filter: SpaceFilterInput, $propertyId: ID) {
  spaces(
    pagination: $pagination
    filter: $filter
    spaceGroupId: $spaceGroupId
    propertyId: $propertyId
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      totalCount
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
        isAcceptable
        name
        status
        spaceAvailableStatus
        spaceGroup {
          id
          supportCarModel
          monthlyRent {
            value
            isTaxExempt
          }
          monthlyOtherFee {
            applyMonths
            cost {
              value
              isTaxExempt
            }
            name
            order
          }
        }
        usages {
          useStartDate
          terminateDate
          isEditable
          contractor {
            name
            phoneNumber
            applicationId
          }
          id
          approveCancelDate
        }
      }
    }
  }
}
    `;
export const FindSpaceDocument = gql`
    query findSpace($spaceId: ID!) {
  space(spaceId: $spaceId) {
    id
    isAcceptable
    name
    status
    spaceAvailableStatus
    usages {
      useStartDate
      terminateDate
      isEditable
      contractor {
        name
        phoneNumber
        applicationId
      }
      id
      approveCancelDate
    }
  }
}
    `;
export const DeleteSpaceDocument = gql`
    mutation deleteSpace($spaceId: String!) {
  spaceDelete(spaceId: $spaceId) {
    space {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const DeleteSpaceUsageDocument = gql`
    mutation deleteSpaceUsage($monthlySpaceAvailabilityId: ID!) {
  spaceUsageDelete(monthlySpaceAvailabilityId: $monthlySpaceAvailabilityId) {
    monthlySpaceAvailability {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const UpdateSpaceGroupDocument = gql`
    mutation updateSpaceGroup($spaceGroupId: ID!, $spaceGroup: SpaceGroupUpdateInput!) {
  spaceGroupUpdate(spaceGroupId: $spaceGroupId, spaceGroup: $spaceGroup) {
    spaceGroup {
      id
    }
    userErrors {
      message
      field
    }
  }
}
    `;
export const UpdatePartialSpaceGroupDocument = gql`
    mutation updatePartialSpaceGroup($spaceGroupId: ID!, $isPublic: Boolean) {
  updatePartialSpaceGroup(
    spaceGroup: {isPublic: $isPublic}
    spaceGroupId: $spaceGroupId
  ) {
    spaceGroup {
      id
    }
    userErrors {
      message
      field
    }
  }
}
    `;
export const DeleteSpaceGroupDocument = gql`
    mutation deleteSpaceGroup($spaceGroupId: ID!) {
  spaceGroupDelete(spaceGroupId: $spaceGroupId) {
    spaceGroup {
      id
    }
    userErrors {
      message
      field
    }
  }
}
    `;
export const FindSpaceGroupDocument = gql`
    query findSpaceGroup($anyId: String!, $propertyId: String!) {
  spaceGroupByAnyId(anyId: $anyId, propertyId: $propertyId) {
    id
    existingSpaceGroupId
    isExistingTransfer
    depositAdminFee
    lesseeBaseUrl
    monthlyRent {
      monthlyAdminFee
      default {
        value
        isTaxExempt
      }
    }
    size {
      height
      length
      carWidth
      groundHeight
      tireWidth
      weight
    }
    initialCost {
      deposit {
        value
        isTaxExempt
      }
      gratuityFee {
        isTaxExempt
        value
      }
    }
    contractCost {
      renewalAdminFee {
        value
        isTaxExempt
      }
      storeFee {
        value
        isTaxExempt
      }
      administrativeFee
      renewalFee {
        value
        isTaxExempt
      }
    }
    supportCarModel
    spaceGroupAvailability {
      totalSpace
      emptySpace
      fullTemporary
      fullSpace
      fullPlanEnded
      fullPlanCancelled
      bookedSpace
      occupiedSpace
    }
    feature {
      time {
        endDate
        startDate
      }
      type
      pavement
      roof
      loan
    }
    contract {
      years
      dailyRateType
    }
    remarks
    specialTerms
    images {
      id
      url
      storagePath
    }
    size {
      height
      length
      carWidth
      groundHeight
      tireWidth
      weight
    }
    isAvailabilityPublic
    isPublic
    freeRent
    monthlyOtherFee {
      name
      cost {
        value
        isTaxExempt
      }
      applyMonths
      order
    }
    initialOtherFee {
      name
      cost {
        value
        isTaxExempt
      }
      order
    }
  }
}
    `;
export const FindSpaceGroupListDocument = gql`
    query findSpaceGroupList($pagination: PaginationInput, $propertyId: ID!, $filter: LessorSpaceGroupListFilter) {
  spaceGroups(pagination: $pagination, filter: $filter, propertyId: $propertyId) {
    pageInfo {
      ...pageInfoFields
    }
    edges {
      cursor
      node {
        id
        remarks
        monthlyRent {
          default {
            value
            isTaxExempt
          }
        }
        monthlyOtherFee {
          applyMonths
          cost {
            value
            isTaxExempt
          }
          name
          order
        }
        supportCarModel
        feature {
          type
        }
        spaceGroupAvailability {
          totalSpace
          emptySpace
          fullTemporary
          fullSpace
          fullPlanEnded
          fullPlanCancelled
          bookedSpace
          occupiedSpace
        }
        isPublic
        isAvailabilityPublic
        freeRent
      }
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;
export const FindOfficersDocument = gql`
    query findOfficers {
  officers {
    id
    name
    email
  }
}
    `;
export const UpdateIsRequiredChangePasswordUpdateDocument = gql`
    mutation updateIsRequiredChangePasswordUpdate {
  isRequiedChangePasswordUpdate {
    isSuccess
    userErrors {
      field
      message
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    findApplications(variables?: FindApplicationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindApplicationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindApplicationsQuery>({ document: FindApplicationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findApplications', 'query', variables);
    },
    findApplication(variables: FindApplicationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindApplicationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindApplicationQuery>({ document: FindApplicationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findApplication', 'query', variables);
    },
    findApplicationProperty(variables: FindApplicationPropertyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindApplicationPropertyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindApplicationPropertyQuery>({ document: FindApplicationPropertyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findApplicationProperty', 'query', variables);
    },
    findApplicationStatusReview(variables: FindApplicationStatusReviewQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindApplicationStatusReviewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindApplicationStatusReviewQuery>({ document: FindApplicationStatusReviewDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findApplicationStatusReview', 'query', variables);
    },
    findApplicationDownload(variables: FindApplicationDownloadQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindApplicationDownloadQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindApplicationDownloadQuery>({ document: FindApplicationDownloadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findApplicationDownload', 'query', variables);
    },
    updateApplicationStatus(variables: UpdateApplicationStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateApplicationStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateApplicationStatusMutation>({ document: UpdateApplicationStatusDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'updateApplicationStatus', 'mutation', variables);
    },
    cancelApplication(variables: CancelApplicationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CancelApplicationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelApplicationMutation>({ document: CancelApplicationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'cancelApplication', 'mutation', variables);
    },
    requestChangeApplication(variables: RequestChangeApplicationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RequestChangeApplicationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestChangeApplicationMutation>({ document: RequestChangeApplicationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'requestChangeApplication', 'mutation', variables);
    },
    lockApplication(variables: LockApplicationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LockApplicationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LockApplicationMutation>({ document: LockApplicationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'lockApplication', 'mutation', variables);
    },
    changeApplicationSpaces(variables: ChangeApplicationSpacesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ChangeApplicationSpacesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeApplicationSpacesMutation>({ document: ChangeApplicationSpacesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'changeApplicationSpaces', 'mutation', variables);
    },
    findApplicationOnlineContract(variables: FindApplicationOnlineContractQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindApplicationOnlineContractQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindApplicationOnlineContractQuery>({ document: FindApplicationOnlineContractDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findApplicationOnlineContract', 'query', variables);
    },
    findCustomerApplications(variables?: FindCustomerApplicationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindCustomerApplicationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindCustomerApplicationsQuery>({ document: FindCustomerApplicationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findCustomerApplications', 'query', variables);
    },
    findWaitingContract(variables?: FindWaitingContractQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindWaitingContractQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindWaitingContractQuery>({ document: FindWaitingContractDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findWaitingContract', 'query', variables);
    },
    applicationReviewDownload(variables: ApplicationReviewDownloadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ApplicationReviewDownloadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplicationReviewDownloadMutation>({ document: ApplicationReviewDownloadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'applicationReviewDownload', 'mutation', variables);
    },
    lessorTotalUnreadCount(variables?: LessorTotalUnreadCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LessorTotalUnreadCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LessorTotalUnreadCountQuery>({ document: LessorTotalUnreadCountDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'lessorTotalUnreadCount', 'query', variables);
    },
    partialApplicationUpdate(variables: PartialApplicationUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PartialApplicationUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PartialApplicationUpdateMutation>({ document: PartialApplicationUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'partialApplicationUpdate', 'mutation', variables);
    },
    completeContractConfirmationStep(variables: CompleteContractConfirmationStepMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CompleteContractConfirmationStepMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompleteContractConfirmationStepMutation>({ document: CompleteContractConfirmationStepDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'completeContractConfirmationStep', 'mutation', variables);
    },
    requestContractReview(variables: RequestContractReviewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RequestContractReviewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestContractReviewMutation>({ document: RequestContractReviewDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'requestContractReview', 'mutation', variables);
    },
    requestSignContract(variables: RequestSignContractMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RequestSignContractMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestSignContractMutation>({ document: RequestSignContractDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'requestSignContract', 'mutation', variables);
    },
    approveCancelApplication(variables: ApproveCancelApplicationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ApproveCancelApplicationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApproveCancelApplicationMutation>({ document: ApproveCancelApplicationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'approveCancelApplication', 'mutation', variables);
    },
    getMessages(variables: GetMessagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetMessagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMessagesQuery>({ document: GetMessagesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getMessages', 'query', variables);
    },
    sendMessage(variables: SendMessageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SendMessageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendMessageMutation>({ document: SendMessageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'sendMessage', 'mutation', variables);
    },
    deleteMessage(variables: DeleteMessageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteMessageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteMessageMutation>({ document: DeleteMessageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'deleteMessage', 'mutation', variables);
    },
    readMessage(variables: ReadMessageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReadMessageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReadMessageMutation>({ document: ReadMessageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'readMessage', 'mutation', variables);
    },
    getUnreadCount(variables: GetUnreadCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetUnreadCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUnreadCountQuery>({ document: GetUnreadCountDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getUnreadCount', 'query', variables);
    },
    findSiteConfig(variables?: FindSiteConfigQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindSiteConfigQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindSiteConfigQuery>({ document: FindSiteConfigDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findSiteConfig', 'query', variables);
    },
    findFormConfig(variables?: FindFormConfigQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindFormConfigQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindFormConfigQuery>({ document: FindFormConfigDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findFormConfig', 'query', variables);
    },
    updateFormConfig(variables: UpdateFormConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateFormConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFormConfigMutation>({ document: UpdateFormConfigDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'updateFormConfig', 'mutation', variables);
    },
    activePropertiesOfCompany(variables?: ActivePropertiesOfCompanyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ActivePropertiesOfCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivePropertiesOfCompanyQuery>({ document: ActivePropertiesOfCompanyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'activePropertiesOfCompany', 'query', variables);
    },
    activeSpacesOfProperty(variables: ActiveSpacesOfPropertyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ActiveSpacesOfPropertyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActiveSpacesOfPropertyQuery>({ document: ActiveSpacesOfPropertyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'activeSpacesOfProperty', 'query', variables);
    },
    createCustomer(variables: CreateCustomerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateCustomerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCustomerMutation>({ document: CreateCustomerDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'createCustomer', 'mutation', variables);
    },
    updateCustomer(variables: UpdateCustomerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateCustomerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCustomerMutation>({ document: UpdateCustomerDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'updateCustomer', 'mutation', variables);
    },
    proxyEditCustomer(variables: ProxyEditCustomerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ProxyEditCustomerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProxyEditCustomerMutation>({ document: ProxyEditCustomerDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'proxyEditCustomer', 'mutation', variables);
    },
    dashboardApplicationStatistics(variables?: DashboardApplicationStatisticsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DashboardApplicationStatisticsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DashboardApplicationStatisticsQuery>({ document: DashboardApplicationStatisticsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'dashboardApplicationStatistics', 'query', variables);
    },
    dashboardPropertyStatistics(variables?: DashboardPropertyStatisticsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DashboardPropertyStatisticsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DashboardPropertyStatisticsQuery>({ document: DashboardPropertyStatisticsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'dashboardPropertyStatistics', 'query', variables);
    },
    dashboardSpaceStats(variables?: DashboardSpaceStatsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DashboardSpaceStatsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DashboardSpaceStatsQuery>({ document: DashboardSpaceStatsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'dashboardSpaceStats', 'query', variables);
    },
    lessorLatestLesseeMessages(variables?: LessorLatestLesseeMessagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LessorLatestLesseeMessagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LessorLatestLesseeMessagesQuery>({ document: LessorLatestLesseeMessagesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'lessorLatestLesseeMessages', 'query', variables);
    },
    dashboardBillingStats(variables: DashboardBillingStatsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DashboardBillingStatsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DashboardBillingStatsQuery>({ document: DashboardBillingStatsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'dashboardBillingStats', 'query', variables);
    },
    findMe(variables?: FindMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindMeQuery>({ document: FindMeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findMe', 'query', variables);
    },
    findMessageTemplates(variables?: FindMessageTemplatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindMessageTemplatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindMessageTemplatesQuery>({ document: FindMessageTemplatesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findMessageTemplates', 'query', variables);
    },
    findMessageTemplateById(variables: FindMessageTemplateByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindMessageTemplateByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindMessageTemplateByIdQuery>({ document: FindMessageTemplateByIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findMessageTemplateById', 'query', variables);
    },
    createMessageTemplate(variables: CreateMessageTemplateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateMessageTemplateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMessageTemplateMutation>({ document: CreateMessageTemplateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'createMessageTemplate', 'mutation', variables);
    },
    deleteMessageTemplate(variables: DeleteMessageTemplateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteMessageTemplateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteMessageTemplateMutation>({ document: DeleteMessageTemplateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'deleteMessageTemplate', 'mutation', variables);
    },
    updateMessageTemplate(variables: UpdateMessageTemplateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateMessageTemplateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMessageTemplateMutation>({ document: UpdateMessageTemplateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'updateMessageTemplate', 'mutation', variables);
    },
    findMailingGroups(variables?: FindMailingGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindMailingGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindMailingGroupsQuery>({ document: FindMailingGroupsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findMailingGroups', 'query', variables);
    },
    findMailingGroupDetail(variables: FindMailingGroupDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindMailingGroupDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindMailingGroupDetailQuery>({ document: FindMailingGroupDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findMailingGroupDetail', 'query', variables);
    },
    saveMailingGroup(variables: SaveMailingGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SaveMailingGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveMailingGroupMutation>({ document: SaveMailingGroupDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'saveMailingGroup', 'mutation', variables);
    },
    deleteMailingGroup(variables: DeleteMailingGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteMailingGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteMailingGroupMutation>({ document: DeleteMailingGroupDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'deleteMailingGroup', 'mutation', variables);
    },
    findOnlineContractStatus(variables: FindOnlineContractStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindOnlineContractStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindOnlineContractStatusQuery>({ document: FindOnlineContractStatusDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findOnlineContractStatus', 'query', variables);
    },
    getContractDocumentsDetail(variables: GetContractDocumentsDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetContractDocumentsDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetContractDocumentsDetailQuery>({ document: GetContractDocumentsDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getContractDocumentsDetail', 'query', variables);
    },
    findFileCloudSignContract(variables: FindFileCloudSignContractQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindFileCloudSignContractQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindFileCloudSignContractQuery>({ document: FindFileCloudSignContractDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findFileCloudSignContract', 'query', variables);
    },
    lessorGetContractDetail(variables: LessorGetContractDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LessorGetContractDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LessorGetContractDetailQuery>({ document: LessorGetContractDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'lessorGetContractDetail', 'query', variables);
    },
    getContractPdfDocument(variables: GetContractPdfDocumentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetContractPdfDocumentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetContractPdfDocumentQuery>({ document: GetContractPdfDocumentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getContractPdfDocument', 'query', variables);
    },
    updateContract(variables: UpdateContractMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateContractMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateContractMutation>({ document: UpdateContractDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'updateContract', 'mutation', variables);
    },
    requestSaveSignedContractPdfUrl(variables: RequestSaveSignedContractPdfUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RequestSaveSignedContractPdfUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestSaveSignedContractPdfUrlMutation>({ document: RequestSaveSignedContractPdfUrlDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'requestSaveSignedContractPdfUrl', 'mutation', variables);
    },
    syncSignContractTime(variables: SyncSignContractTimeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SyncSignContractTimeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SyncSignContractTimeMutation>({ document: SyncSignContractTimeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'syncSignContractTime', 'mutation', variables);
    },
    ownerInquiryCreate(variables: OwnerInquiryCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<OwnerInquiryCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OwnerInquiryCreateMutation>({ document: OwnerInquiryCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ownerInquiryCreate', 'mutation', variables);
    },
    findProperties(variables?: FindPropertiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindPropertiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindPropertiesQuery>({ document: FindPropertiesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findProperties', 'query', variables);
    },
    createProperty(variables: CreatePropertyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreatePropertyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePropertyMutation>({ document: CreatePropertyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'createProperty', 'mutation', variables);
    },
    findPropertyDetail(variables: FindPropertyDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindPropertyDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindPropertyDetailQuery>({ document: FindPropertyDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findPropertyDetail', 'query', variables);
    },
    findPreviewProperty(variables: FindPreviewPropertyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindPreviewPropertyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindPreviewPropertyQuery>({ document: FindPreviewPropertyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findPreviewProperty', 'query', variables);
    },
    updateProperty(variables: UpdatePropertyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdatePropertyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePropertyMutation>({ document: UpdatePropertyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'updateProperty', 'mutation', variables);
    },
    deleteProperty(variables: DeletePropertyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeletePropertyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePropertyMutation>({ document: DeletePropertyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'deleteProperty', 'mutation', variables);
    },
    createSpaceGroup(variables: CreateSpaceGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateSpaceGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSpaceGroupMutation>({ document: CreateSpaceGroupDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'createSpaceGroup', 'mutation', variables);
    },
    updateAtPortLink(variables: UpdateAtPortLinkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateAtPortLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAtPortLinkMutation>({ document: UpdateAtPortLinkDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'updateAtPortLink', 'mutation', variables);
    },
    notifyAtPortLink(variables: NotifyAtPortLinkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<NotifyAtPortLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<NotifyAtPortLinkMutation>({ document: NotifyAtPortLinkDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'notifyAtPortLink', 'mutation', variables);
    },
    updatePartialProperty(variables: UpdatePartialPropertyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdatePartialPropertyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePartialPropertyMutation>({ document: UpdatePartialPropertyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'updatePartialProperty', 'mutation', variables);
    },
    getPrefectureDropdown(variables?: GetPrefectureDropdownQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPrefectureDropdownQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPrefectureDropdownQuery>({ document: GetPrefectureDropdownDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPrefectureDropdown', 'query', variables);
    },
    propertyHasActiveApplication(variables: PropertyHasActiveApplicationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PropertyHasActiveApplicationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PropertyHasActiveApplicationQuery>({ document: PropertyHasActiveApplicationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'propertyHasActiveApplication', 'query', variables);
    },
    activeContractors(variables: ActiveContractorsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ActiveContractorsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActiveContractorsQuery>({ document: ActiveContractorsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'activeContractors', 'query', variables);
    },
    propertyNameAndActiveAllApplicationIds(variables: PropertyNameAndActiveAllApplicationIdsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PropertyNameAndActiveAllApplicationIdsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PropertyNameAndActiveAllApplicationIdsQuery>({ document: PropertyNameAndActiveAllApplicationIdsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'propertyNameAndActiveAllApplicationIds', 'query', variables);
    },
    messageBatchCreate(variables: MessageBatchCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MessageBatchCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MessageBatchCreateMutation>({ document: MessageBatchCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'messageBatchCreate', 'mutation', variables);
    },
    getRentalInformation(variables: GetRentalInformationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetRentalInformationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRentalInformationQuery>({ document: GetRentalInformationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getRentalInformation', 'query', variables);
    },
    findSalesManagementList(variables?: FindSalesManagementListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindSalesManagementListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindSalesManagementListQuery>({ document: FindSalesManagementListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findSalesManagementList', 'query', variables);
    },
    findSalesManagementDetail(variables: FindSalesManagementDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindSalesManagementDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindSalesManagementDetailQuery>({ document: FindSalesManagementDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findSalesManagementDetail', 'query', variables);
    },
    getApplicationLessorSignatories(variables?: GetApplicationLessorSignatoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetApplicationLessorSignatoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetApplicationLessorSignatoriesQuery>({ document: GetApplicationLessorSignatoriesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getApplicationLessorSignatories', 'query', variables);
    },
    getApplicationLessorSignatory(variables: GetApplicationLessorSignatoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetApplicationLessorSignatoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetApplicationLessorSignatoryQuery>({ document: GetApplicationLessorSignatoryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getApplicationLessorSignatory', 'query', variables);
    },
    createApplicationLessorSignatory(variables: CreateApplicationLessorSignatoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateApplicationLessorSignatoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateApplicationLessorSignatoryMutation>({ document: CreateApplicationLessorSignatoryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'createApplicationLessorSignatory', 'mutation', variables);
    },
    updateApplicationLessorSignatory(variables: UpdateApplicationLessorSignatoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateApplicationLessorSignatoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateApplicationLessorSignatoryMutation>({ document: UpdateApplicationLessorSignatoryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'updateApplicationLessorSignatory', 'mutation', variables);
    },
    deleteApplicationLessorSignatory(variables: DeleteApplicationLessorSignatoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteApplicationLessorSignatoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteApplicationLessorSignatoryMutation>({ document: DeleteApplicationLessorSignatoryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'deleteApplicationLessorSignatory', 'mutation', variables);
    },
    generateUploadSignedUrlForPropertyMaster(variables: GenerateUploadSignedUrlForPropertyMasterMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GenerateUploadSignedUrlForPropertyMasterMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateUploadSignedUrlForPropertyMasterMutation>({ document: GenerateUploadSignedUrlForPropertyMasterDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'generateUploadSignedUrlForPropertyMaster', 'mutation', variables);
    },
    getSyncPortSignedUrl(variables: GetSyncPortSignedUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetSyncPortSignedUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSyncPortSignedUrlMutation>({ document: GetSyncPortSignedUrlDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getSyncPortSignedUrl', 'mutation', variables);
    },
    generateUploadSignedUrlForImage(variables: GenerateUploadSignedUrlForImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GenerateUploadSignedUrlForImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateUploadSignedUrlForImageMutation>({ document: GenerateUploadSignedUrlForImageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'generateUploadSignedUrlForImage', 'mutation', variables);
    },
    generateUploadSignedUrl(variables: GenerateUploadSignedUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GenerateUploadSignedUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateUploadSignedUrlMutation>({ document: GenerateUploadSignedUrlDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'generateUploadSignedUrl', 'mutation', variables);
    },
    updateSiteConfig(variables: UpdateSiteConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateSiteConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSiteConfigMutation>({ document: UpdateSiteConfigDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'updateSiteConfig', 'mutation', variables);
    },
    createSpace(variables: CreateSpaceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateSpaceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSpaceMutation>({ document: CreateSpaceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'createSpace', 'mutation', variables);
    },
    updateSpace(variables: UpdateSpaceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateSpaceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSpaceMutation>({ document: UpdateSpaceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'updateSpace', 'mutation', variables);
    },
    findSpaces(variables?: FindSpacesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindSpacesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindSpacesQuery>({ document: FindSpacesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findSpaces', 'query', variables);
    },
    findSpace(variables: FindSpaceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindSpaceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindSpaceQuery>({ document: FindSpaceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findSpace', 'query', variables);
    },
    deleteSpace(variables: DeleteSpaceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteSpaceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSpaceMutation>({ document: DeleteSpaceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'deleteSpace', 'mutation', variables);
    },
    deleteSpaceUsage(variables: DeleteSpaceUsageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteSpaceUsageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSpaceUsageMutation>({ document: DeleteSpaceUsageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'deleteSpaceUsage', 'mutation', variables);
    },
    updateSpaceGroup(variables: UpdateSpaceGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateSpaceGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSpaceGroupMutation>({ document: UpdateSpaceGroupDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'updateSpaceGroup', 'mutation', variables);
    },
    updatePartialSpaceGroup(variables: UpdatePartialSpaceGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdatePartialSpaceGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePartialSpaceGroupMutation>({ document: UpdatePartialSpaceGroupDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'updatePartialSpaceGroup', 'mutation', variables);
    },
    deleteSpaceGroup(variables: DeleteSpaceGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteSpaceGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSpaceGroupMutation>({ document: DeleteSpaceGroupDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'deleteSpaceGroup', 'mutation', variables);
    },
    findSpaceGroup(variables: FindSpaceGroupQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindSpaceGroupQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindSpaceGroupQuery>({ document: FindSpaceGroupDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findSpaceGroup', 'query', variables);
    },
    findSpaceGroupList(variables: FindSpaceGroupListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindSpaceGroupListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindSpaceGroupListQuery>({ document: FindSpaceGroupListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findSpaceGroupList', 'query', variables);
    },
    findOfficers(variables?: FindOfficersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FindOfficersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindOfficersQuery>({ document: FindOfficersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'findOfficers', 'query', variables);
    },
    updateIsRequiredChangePasswordUpdate(variables?: UpdateIsRequiredChangePasswordUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateIsRequiredChangePasswordUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateIsRequiredChangePasswordUpdateMutation>({ document: UpdateIsRequiredChangePasswordUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'updateIsRequiredChangePasswordUpdate', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;